export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'es',
  messages: {
    en: {
      'welcome': 'Welcome',
      'Manage Business': 'Manage Business',
      'Business Information': 'Business Information',
      'Business Photo': 'Business Photo',
      'Address Information': 'Address Information',
      'Business Details': 'Business Details',

      // Customer Management Translations
      'Contact Information': 'Contact Information',
      'Full Name': 'Full Name',
      'Email Address': 'Email Address',
      'Phone Number': 'Phone Number',
      'State/Province': 'State/Province',
      'Additional Information': 'Additional Information',
      'Any additional notes about this customer': 'Any additional notes about this customer',
      'Create a new customer profile with contact and address information': 'Create a new customer profile with contact and address information',
      'Update customer information and address details': 'Update customer information and address details',
      'Loading customer information...': 'Loading customer information...',
      'Notes': 'Notes',
      'Customer Details': 'Customer Details',
      'View and manage customer information': 'View and manage customer information',
      'System Information': 'System Information',
      'Full Address': 'Full Address',
      'No address provided': 'No address provided',
      'Customer Not Found': 'Customer Not Found',
      'The requested customer could not be found.': 'The requested customer could not be found.',
      'System': 'System',
      'Order is being updated...': 'Order is being updated...',
      'You are editing existing order': 'You are editing existing order',
      'View original order': 'View original order',
      'Cancel Editing': 'Cancel Editing',

      // Login Page Translations
      'Welcome back': 'Welcome back',
      'New to tapy.?': 'New to tapy.?',
      'Current Language': 'Current Language',
      'Switch Language': 'Switch Language',
      'language': 'Language',
      'selectLanguage': 'Select Language',
      'You have been authenticated, loading your business data...': 'You have been authenticated, loading your business data...',
      'Home': 'Home',
      'Features': 'Features',
      'Pricing': 'Pricing',
      'Contact': 'Contact',
      'Contact us': 'Contact us',
      'Business Management': 'Business Management',
      'Business Management Made Simple': 'Business Management Made Simple',
      'Streamline your orders, inventory, and customer management with our all-in-one solution.': 'Streamline your orders, inventory, and customer management with our all-in-one solution.',
      'tapy.': 'tapy.',
      'Key Features': 'Key Features',
      'Order Management': 'Order Management',
      'Inventory Tracking': 'Inventory Tracking',
      'Customer Database': 'Customer Database',
      'Real-time Analytics': 'Real-time Analytics',
      'Please check your email for the magic link': 'Please check your email for the magic link',
      'Failed to send magic link': 'Failed to send magic link',
      'Invalid email or password': 'Invalid email or password',
      'Failed to login': 'Failed to login',
      'You have been authenticated, you are being redirecting automatically, please wait...': 'You have been authenticated, you are being redirecting automatically, please wait...',
      'Logging out': 'Logging out',
      'Please wait while we sign you out': 'Please wait while we sign you out',
      'Switching business': 'Switching business',
      'Clearing data': 'Clearing data',
      'Please wait while we load your businesses': 'Please wait while we load your businesses',
      'Logout': 'Logout',

      // Contact Form Translations
      'Contact Us': 'Contact Us',
      'We\'d love to hear from you': 'We\'d love to hear from you',
      'Enter your full name': 'Enter your full name',
      'Please provide your full name': 'Please provide your full name',
      'Enter your phone number': 'Enter your phone number',
      'Optional - We may call you for urgent matters': 'Optional - We may call you for urgent matters',
      'Enter your email address': 'Enter your email address',
      'Please provide a valid email address': 'Please provide a valid email address',
      'Message': 'Message',
      'Tell us how we can help you...': 'Tell us how we can help you...',
      'Please describe your inquiry or feedback': 'Please describe your inquiry or feedback',
      'Send Message': 'Send Message',
      'Need immediate help?': 'Need immediate help?',
      'Call us directly': 'Call us directly',
      'Thank you for your message! We will get back to you soon.': 'Thank you for your message! We will get back to you soon.',
      'Failed to send message. Please try again.': 'Failed to send message. Please try again.',
      'Contact Us - tapy.': 'Contact Us - tapy.',
      'Get in touch with the tapy. team. We are here to help with your restaurant management needs.': 'Get in touch with the tapy. team. We are here to help with your restaurant management needs.',

      // Thank You Page Translations
      'Thank You!': 'Thank You!',
      'Message Sent Successfully': 'Message Sent Successfully',
      'Message Received': 'Message Received',
      'We\'ve received your message and will get back to you within 24 hours. Our team is excited to help with your restaurant management needs.': 'We\'ve received your message and will get back to you within 24 hours. Our team is excited to help with your restaurant management needs.',
      'Back to Contact': 'Back to Contact',
      'Go to Homepage': 'Go to Homepage',
      'What happens next?': 'What happens next?',
      'Our team will review your message': 'Our team will review your message',
      'We\'ll respond within 24 hours': 'We\'ll respond within 24 hours',
      'Check your email for our response': 'Check your email for our response',
      'Thank you for contacting tapy.. We have received your message and will get back to you soon.': 'Thank you for contacting tapy. We have received your message and will get back to you soon.',
      'Back to Login': 'Back to Login',
      'Back to Panel': 'Back to Panel',

      // Marketing Page Translations
      'Streamline your restaurant operations with tapy.. Manage orders, track inventory, and build customer relationships with our all-in-one restaurant management solution designed specifically for food service businesses.': 'Streamline your restaurant operations with tapy. Manage orders, track inventory, and build customer relationships with our all-in-one restaurant management solution designed specifically for food service businesses.',
      'Get Started': 'Get Started',
      'Learn More': 'Learn More',
      'Login': 'Login',
      'Go to POS': 'Go to POS',
      'Go to point of sale': 'Go to point of sale',
      'Smart Order Management': 'Smart Order Management',
      'Handle dine-in, takeout, and delivery orders seamlessly with our intuitive interface': 'Handle dine-in, takeout, and delivery orders seamlessly with our intuitive interface',
      'Real-Time Inventory Tracking': 'Real-Time Inventory Tracking',
      'Monitor ingredient levels, set automatic reorder points, and never run out of key items': 'Monitor ingredient levels, set automatic reorder points, and never run out of key items',
      'Customer Relationship Management': 'Customer Relationship Management',
      'Build lasting relationships with detailed customer profiles and order history': 'Build lasting relationships with detailed customer profiles and order history',
      'Choose Your Plan': 'Choose Your Plan',
      'Flexible pricing for restaurants of all sizes': 'Flexible pricing for restaurants of all sizes',
      'Start with our free trial and scale as your business grows.': 'Start with our free trial and scale as your business grows.',
      'Ready to Transform Your Restaurant?': 'Ready to Transform Your Restaurant?',
      'Our team is ready to help you streamline your restaurant operations.': 'Our team is ready to help you streamline your restaurant operations.',
      'Get in Touch': 'Get in Touch',
      'Navigate to home section': 'Navigate to home section',
      'Navigate to features section': 'Navigate to features section',
      'Navigate to pricing section': 'Navigate to pricing section',
      'Navigate to contact section': 'Navigate to contact section',
      'Businesses': 'Businesses',
      'Navigate to businesses section': 'Navigate to businesses section',
      'A POS for every business': 'A POS for every business',
      'Restaurants': 'Restaurants',
      'Ice cream shops': 'Ice cream shops',
      'Coffee shops': 'Coffee shops',
      'Hair salons': 'Hair salons',
      'Flower shops': 'Flower shops',
      'Manage orders and tables for your restaurant': 'Manage orders and tables for your restaurant',
      'Control your ice cream and popsicle inventory': 'Control your ice cream and popsicle inventory',
      'Track your coffee and beverage sales': 'Track your coffee and beverage sales',
      'Schedule appointments and manage clients': 'Schedule appointments and manage clients',
      'Manage orders and flower arrangements': 'Manage orders and flower arrangements',
      'Learn more': 'Learn more',
      'Coming soon': 'Coming soon',
      // User Management Translations
      'Users': 'Users',
      'Invite new user': 'Invite new user',
      'Employee': 'Employee',
      'Employee Sales': 'Employee Sales',
      'Product Sales': 'Product Sales',
      'Units sold': 'Units sold',
      'Unit Price': 'Unit Price',
      'Revenue': 'Revenue',
      'All employees': 'All employees',
      'Include categories': 'Include categories',
      'Gross total': 'Gross total',
      'Excluded': 'Excluded',
      'Commissionable total': 'Commissionable total',
      'Unit price': 'Unit price',
      'Included': 'Included',
      'Custom products': 'Custom products',
      'Send Invitation': 'Send Invitation',
      'Select role': 'Select role',
      'Name is required': 'Name is required',
      'Email is required': 'Email is required',
      'Role is required': 'Role is required',
      'Invalid email format': 'Invalid email format',
      'No users found': 'No users found',
      'Search by name': 'Search by name',
      'Search by email': 'Search by email',
      'Search by role': 'Search by role',
      'Remove access': 'Remove access',
      'Edit permissions': 'Edit permissions',
      'User permissions': 'User permissions',
      'View shift financials': 'View shift financials',
      'View stock levels': 'View stock levels',
      'Update stock': 'Update stock',
      'See current stock levels': 'See current stock levels',
      'Use the Update Inventory button to submit your count': 'Use the Update Inventory button to submit your count',
      'will be removed': 'will be removed',
      'this cannot be reverted': 'this cannot be reverted',
      'Access Denied': 'Access Denied',
      'You do not have permission to access this area': 'You do not have permission to access this area',
      'This section is restricted to Admin users only': 'This section is restricted to Admin users only',
      'Go to your dashboard': 'Go to your dashboard',
      'Sign in with a different account': 'Sign in with a different account',
      'Signed in as': 'Signed in as',
      'Yes': 'Yes',
      'No': 'No',
      'Delete': 'Delete',
      'Cancel': 'Cancel',
      'Enter full name': 'Enter full name',
      'Enter email address': 'Enter email address',
      'Loading': 'Loading',
      'Loading...': 'Loading...',
      'Loading products...': 'Loading products...',
      'Loading categories and products...': 'Loading categories and products...',
      'Loading combos...': 'Loading combos...',
      'Counter (Standard POS)': 'Counter (Standard POS)',
      'Restaurant (Tables/KDS)': 'Restaurant (Tables/KDS)',
      'POS configuration updated successfully': 'POS configuration updated successfully',
      'KDS': 'KDS',
      'Date': 'Date',
      'Special instructions': 'Special instructions',
      'Add any special requests or instructions': 'Add any special requests or instructions',
      'Loading shift data': 'Loading shift data',
      'A shift is already open by {userName}': 'A shift is already open by {userName}',
      'Unknown user': 'Unknown user',
      'Actions': 'Actions',
      'Failed to remove user': 'Failed to remove user',
      'Failed to update permissions: ': 'Failed to update permissions: ',
      'Business ID not found': 'Business ID not found',
      'Upload business photo': 'Upload business photo',
      'Business photo': 'Business photo',
      'Upload your business photo': 'Upload your business photo',
      'Drag and drop or click to select': 'Drag and drop or click to select',
      'File too large': 'File too large',
      'Invalid file type': 'Invalid file type',
      'Maximum file size': 'Maximum file size',
      'Allowed formats': 'Allowed formats',
      'Replace photo': 'Replace photo',
      'Upload': 'Upload',
      'Uploading': 'Uploading',
      'User invited successfully': 'User invited successfully',
      'Failed to invite user: ': 'Failed to invite user: ',
      'User removed successfully': 'User removed successfully',
      'Failed to remove user: ': 'Failed to remove user: ',
      'Delete user confirmation': 'Delete user confirmation',
      'User removal canceled': 'User removal canceled',
      'Failed to load users': 'Failed to load users',
      'You cannot remove yourself': 'You cannot remove yourself',
      'Main navigation menu': 'Main navigation menu',
      'Open navigation menu': 'Open navigation menu',
      'Close navigation menu': 'Close navigation menu',
      'Go to login page': 'Go to login page',
      'Go to contact page': 'Go to contact page',

      // Marketing Page Content
      // Hero Section
      '#1 Business Management Solution': '#1 Business Management Solution',
      'Restaurant Management': 'Restaurant Management',
      'Made Simple': 'Made Simple',
      'Streamline your business operations with {brand}. Manage sales, track inventory, and print tickets from a tablet with our {solution} designed for any type of business.': 'Streamline your business operations with {brand}. Manage sales, track inventory, and print tickets from a tablet with our {solution} designed for any type of business.',
      'all-in-one solution': 'all-in-one solution',
      'Start Free Trial': 'Start Free Trial',
      'Watch Demo': 'Watch Demo',
      'Write to us': 'Write to us',
      'Uptime': 'Uptime',
      'Support': 'Support',

      // Features Section
      'Why Choose {brand}?': 'Why Choose {brand}?',
      'Discover the powerful features that make restaurant management effortless': 'Discover the powerful features that make restaurant management effortless',
      'Handle dine-in, takeout, and delivery orders seamlessly with our intuitive interface. Track order status in real-time and ensure customer satisfaction.': 'Handle dine-in, takeout, and delivery orders seamlessly with our intuitive interface. Track order status in real-time and ensure customer satisfaction.',
      'Monitor ingredient levels, set automatic reorder points, and never run out of key items. Reduce waste and optimize your supply chain effortlessly.': 'Monitor ingredient levels, set automatic reorder points, and never run out of key items. Reduce waste and optimize your supply chain effortlessly.',
      'Build lasting relationships with detailed customer profiles and order history. Personalize experiences and increase customer loyalty.': 'Build lasting relationships with detailed customer profiles and order history. Personalize experiences and increase customer loyalty.',

      // Features Section 2
      'Complete Business Management': 'Complete Business Management',
      'Everything you need to run your restaurant efficiently and profitably': 'Everything you need to run your restaurant efficiently and profitably',
      'Business Management Interface': 'Business Management Interface',
      'Product Management': 'Product Management',
      'Complete product catalog with categories, pricing, and inventory. Support for variations, modifiers, and menu customization.': 'Complete product catalog with categories, pricing, and inventory. Support for variations, modifiers, and menu customization.',
      'Financial Management': 'Financial Management',
      'Sales reporting and analytics, revenue tracking by period, payment processing, and comprehensive financial performance insights.': 'Sales reporting and analytics, revenue tracking by period, payment processing, and comprehensive financial performance insights.',
      'Business Configuration': 'Business Configuration',
      'Restaurant settings and preferences, tax configuration, pricing rules, business hours, and customizable workflows.': 'Restaurant settings and preferences, tax configuration, pricing rules, business hours, and customizable workflows.',

      // Features Section 3
      'Advanced Operations & Insights': 'Advanced Operations & Insights',
      'Powerful tools to manage your team, analyze performance, and stay informed': 'Powerful tools to manage your team, analyze performance, and stay informed',
      'Analytics and Management Interface': 'Analytics and Management Interface',
      'User & Staff Management': 'User & Staff Management',
      'Multi-user access with role-based permissions, staff scheduling, user authentication, and team collaboration tools.': 'Multi-user access with role-based permissions, staff scheduling, user authentication, and team collaboration tools.',
      'Analytics & Reporting': 'Analytics & Reporting',
      'Sales performance dashboards, customer insights and trends, inventory reports, and business intelligence forecasting.': 'Sales performance dashboards, customer insights and trends, inventory reports, and business intelligence forecasting.',
      'Smart Notifications': 'Smart Notifications',
      'Real-time alerts and updates, system notifications for important events, and automated reminders to keep you informed.': 'Real-time alerts and updates, system notifications for important events, and automated reminders to keep you informed.',

      // Contact Section
      'Ready to Get Started?': 'Ready to Get Started?',
      'Transform Your Restaurant': 'Transform Your Restaurant',
      'Starting Today': 'Starting Today',
      'Join hundreds of restaurants already using {brand} to streamline their operations and increase profitability.': 'Join hundreds of restaurants already using {brand} to streamline their operations and increase profitability.',
      'Schedule Demo': 'Schedule Demo',
      'Email Support': 'Email Support',
      'Get answers to your questions within 24 hours': 'Get answers to your questions within 24 hours',
      'Phone Support': 'Phone Support',
      'Speak with our experts Monday - Friday, 9 AM - 6 PM PST': 'Speak with our experts Monday - Friday, 9 AM - 6 PM PST',
      'Live Demo': 'Live Demo',
      'See {brand} in action with a personalized demonstration': 'See {brand} in action with a personalized demonstration',
      'Book Demo': 'Book Demo',
      'Trusted by restaurants worldwide': 'Trusted by restaurants worldwide',
      'Restaurant Management Interface': 'Restaurant Management Interface',

      // Pricing Section
      'Simple, Transparent Pricing': 'Simple, Transparent Pricing',
      'Choose Your {plan}': 'Choose Your {plan}',
      'Perfect Plan': 'Perfect Plan',
      'Flexible pricing for restaurants of all sizes. Start with our free trial and scale as your business grows.': 'Flexible pricing for restaurants of all sizes. Start with our free trial and scale as your business grows.',
      'Monthly': 'Monthly',
      'Annual': 'Annual',
      'Save 20%': 'Save 20%',
      'Starter': 'Starter',
      'Perfect for small cafes and food trucks': 'Perfect for small cafes and food trucks',
      '14-day free trial': '14-day free trial',
      'Up to 100 menu items': 'Up to 100 menu items',
      'Basic order management': 'Basic order management',
      'Customer database': 'Customer database',
      'Email support': 'Email support',
      'Most Popular': 'Most Popular',
      'Professional': 'Professional',
      'Ideal for full-service restaurants': 'Ideal for full-service restaurants',
      'Everything in Starter': 'Everything in Starter',
      'Unlimited menu items': 'Unlimited menu items',
      'Advanced inventory management': 'Advanced inventory management',
      'Sales analytics & reports': 'Sales analytics & reports',
      'Priority support': 'Priority support',
      'Enterprise': 'Enterprise',
      'For restaurant chains and franchises': 'For restaurant chains and franchises',
      'Custom': 'Custom',
      'Tailored to your needs': 'Tailored to your needs',
      'Everything in Professional': 'Everything in Professional',
      'Advanced reporting & analytics': 'Advanced reporting & analytics',
      'Custom integrations': 'Custom integrations',
      'Dedicated account manager': 'Dedicated account manager',
      'White-label options': 'White-label options',
      'Contact Sales': 'Contact Sales',

      // Steps Section
      'Get Started in 3 Simple Steps': 'Get Started in 3 Simple Steps',
      'Setting up your restaurant management system has never been easier. Follow these simple steps to transform your operations and start seeing results immediately.': 'Setting up your restaurant management system has never been easier. Follow these simple steps to transform your operations and start seeing results immediately.',
      'Sign Up for an Account': 'Sign Up for an Account',
      'Create a new account to access our restaurant management system and start managing your business efficiently.': 'Create a new account to access our restaurant management system and start managing your business efficiently.',
      'Set Up Your Menu': 'Set Up Your Menu',
      'Easily add and organize your menu items with images, descriptions, and prices to streamline your sales process.': 'Easily add and organize your menu items with images, descriptions, and prices to streamline your sales process.',
      'Start Taking Orders': 'Start Taking Orders',
      'Use our intuitive interface to process orders, track inventory, and manage customer relationships seamlessly.': 'Use our intuitive interface to process orders, track inventory, and manage customer relationships seamlessly.',

      // Navigation Groups
      'POS & Orders': 'POS & Orders',
      'Financial': 'Financial',
      'Inventory': 'Inventory',
      'Counter': 'Counter',
      'Restaurant': 'Restaurant',

      // Testimonials Section
      'What Our Customers Say': 'What Our Customers Say',
      'Discover how restaurants worldwide are transforming their operations with {brand}.': 'Discover how restaurants worldwide are transforming their operations with {brand}.',
      'Maria Rodriguez': 'Maria Rodriguez',
      'Owner, La Mesa Restaurant': 'Owner, La Mesa Restaurant',
      'This software has revolutionized the way we manage our orders and inventory. It\'s user-friendly and has increased our efficiency tenfold.': 'This software has revolutionized the way we manage our orders and inventory. It\'s user-friendly and has increased our efficiency tenfold.',
      'James Chen': 'James Chen',
      'Manager, Fusion Bistro': 'Manager, Fusion Bistro',
      'I highly recommend this restaurant management system to any business looking to streamline their operations. It\'s intuitive and has excellent customer support.': 'I highly recommend this restaurant management system to any business looking to streamline their operations. It\'s intuitive and has excellent customer support.',
      'Sophie Laurent': 'Sophie Laurent',
      'Owner, Artisan Bakery': 'Owner, Artisan Bakery',
      'Our sales have soared since implementing this system. It\'s easy to use and has all the features we need to run our bakery efficiently.': 'Our sales have soared since implementing this system. It\'s easy to use and has all the features we need to run our bakery efficiently.',
      'Antonio Silva': 'Antonio Silva',
      'Owner, Urban Taphouse': 'Owner, Urban Taphouse',
      'I can\'t imagine running my restaurant without this software. It has simplified our transactions and inventory management, saving us time and money.': 'I can\'t imagine running my restaurant without this software. It has simplified our transactions and inventory management, saving us time and money.',

      // Features2 Section
      'Intuitive Interface': 'Intuitive Interface',
      'Our restaurant management software offers a user-friendly interface that is easy to navigate, making order processing quick and efficient.': 'Our restaurant management software offers a user-friendly interface that is easy to navigate, making order processing quick and efficient.',
      'Smart Inventory Management': 'Smart Inventory Management',
      'Efficiently manage your inventory with our software, track stock levels, receive low stock alerts, and streamline ordering processes.': 'Efficiently manage your inventory with our software, track stock levels, receive low stock alerts, and streamline ordering processes.',
      'Advanced Analytics': 'Advanced Analytics',
      'Gain valuable insights into your business performance with detailed reports, track trends, and make informed decisions.': 'Gain valuable insights into your business performance with detailed reports, track trends, and make informed decisions.',
      'Restaurant Management Dashboard': 'Restaurant Management Dashboard',

      // Footer Section
      'Subscribe to our newsletter for the latest updates on new features and product releases.': 'Subscribe to our newsletter for the latest updates on new features and product releases.',
      'Enter your email': 'Enter your email',
      'Subscribe to Newsletter': 'Subscribe to Newsletter',
      'Company': 'Company',
      'About Us': 'About Us',
      'Product': 'Product',
      'FAQs': 'FAQs',
      'Blog': 'Blog',
      'Demo': 'Demo',
      'Sign Up': 'Sign Up',
      'Follow Us': 'Follow Us',
      '© {year} {company}. All rights reserved.': '© {year} {company}. All rights reserved.',
      'Privacy Policy': 'Privacy Policy',
      'Terms of Service': 'Terms of Service',
      'Cookie Policy': 'Cookie Policy',
      'Designed by {company}': 'Designed by {company}',
      '500+ Restaurants': '500+ Restaurants',
      '99.9% Uptime': '99.9% Uptime',
      '24/7 Support': '24/7 Support',
      'All Products': 'All Products',
      'Filter by Category': 'Filter by Category',
      'Select': 'Select',
      'Select Category': 'Select Category',
      'Miscellaneous': 'Miscellaneous',
      // Navigation Items
      'Ingredients': 'Ingredients',
      'Stock Items': 'Stock Items',
      // Shift Management Translations
      'Shifts': 'Shifts',
      'No shifts found': 'No shifts found',
      'Failed to load shifts': 'Failed to load shifts',
      'Shift removed successfully': 'Shift removed successfully',
      'Failed to delete shift: ': 'Failed to delete shift: ',
      'Deletion canceled': 'Deletion canceled',
      'Delete confirmation': 'Delete confirmation',
      'New shift': 'New shift',
      'Open new shift': 'Open new shift',
      'Search by ID': 'Search by ID',
      'Search by status': 'Search by status',
      'Search by amount': 'Search by amount',
      'Status': 'Status',
      'demo': 'Demo',
      'trial': 'Trial',
      'active': 'Active',
      'payment_due': 'Payment Due',
      'paused': 'Paused',
      'churn': 'Churn',
      'Start Date': 'Start Date',
      'End Date': 'End Date',
      'Opening Cash': 'Opening Cash',
      'Closing Cash': 'Closing Cash',
      'View': 'View',
      'Close shift': 'Close shift',
      'open': 'open',
      'in_progress': 'in progress',
      'closed': 'closed',
      'revised': 'revised',
      'voided': 'voided',
      'edit_started': 'Edit started',
      'admin_edit': 'Admin edit',
      'Showing {first} to {last} of {totalRecords} entries': 'Showing {first} to {last} of {totalRecords} entries',

      // Shift Details Page Translations
      'Shift Details': 'Shift Details',
      'View detailed information about this shift and manage expenses': 'View detailed information about this shift and manage expenses',
      'Back to shifts': 'Back to shifts',
      'Shift Information': 'Shift Information',
      'Basic shift details and status': 'Basic shift details and status',
      'Expenses Management': 'Expenses Management',
      'Track and manage shift expenses': 'Track and manage shift expenses',
      'No expenses found': 'No expenses found',
      'Start adding expenses to track shift costs': 'Start adding expenses to track shift costs',
      'Quick Actions': 'Quick Actions',
      'Common shift operations': 'Common shift operations',
      'Add expense': 'Add expense',
      'Expense type is required': 'Expense type is required',
      'Print shift report': 'Print shift report',
      'Shift Summary': 'Shift Summary',
      'Financial overview': 'Financial overview',
      'Total Sales': 'Total Sales',
      'Orders Total': 'Orders Total',
      'Checks Total': 'Checks Total',
      'Total Expenses': 'Total Expenses',
      'Cash Difference': 'Cash Difference',
      // Payment Methods Translations
      'Payment methods': 'Payment methods',
      'Add payment method': 'Add payment method',
      'Add new payment method': 'Add new payment method',
      'Create payment method': 'Create payment method',
      'Please add payment methods': 'Please add payment methods',

      // Print Server Configuration Translations
      'Print Server Configuration': 'Print Server Configuration',
      'Configure your local print server settings': 'Configure your local print server settings',
      'Local Print Server': 'Local Print Server',
      'Enable Local Print Server': 'Enable Local Print Server',
      'Enabled': 'Enabled',
      'Disabled': 'Disabled',
      'When enabled, orders will be sent to your local print server first': 'When enabled, orders will be sent to your local print server first',
      'Print Server URL': 'Print Server URL',
      'Enter the full URL including protocol (http:// or https://)': 'Enter the full URL including protocol (http:// or https://)',
      'Test Connection': 'Test Connection',
      'Save Configuration': 'Save Configuration',
      'Reset to Default': 'Reset to Default',
      'Print server configuration saved': 'Print server configuration saved',
      'Failed to save configuration': 'Failed to save configuration',
      'Please enter a print server URL': 'Please enter a print server URL',
      'Connection successful': 'Connection successful',
      'Connection failed. Please check the URL and try again.': 'Connection failed. Please check the URL and try again.',
      'Print server is reachable and responding correctly': 'Print server is reachable and responding correctly',
      'Unable to connect to print server. Please verify the URL and network connection.': 'Unable to connect to print server. Please verify the URL and network connection.',
      'Setup Instructions': 'Setup Instructions',
      '1. Make sure your print server is running on the local network': '1. Make sure your print server is running on the local network',
      '2. Verify the IP address and port number are correct': '2. Verify the IP address and port number are correct',
      '3. Test the connection before saving the configuration': '3. Test the connection before saving the configuration',
      '4. The print server should respond to /health endpoint': '4. The print server should respond to /health endpoint',
      'Edit payment method': 'Edit payment method',
      'Update payment method': 'Update payment method',
      'Delete payment method': 'Delete payment method',
      'Remove payment method': 'Remove payment method',
      'Payment method created successfully': 'Payment method created successfully',
      'Payment method updated successfully': 'Payment method updated successfully',
      'Payment method removed successfully': 'Payment method removed successfully',
      'Payment method deleted successfully': 'Payment method deleted successfully',
      'Do you want to delete this payment method permanently?': 'Do you want to delete this payment method permanently?',
      'Delete Payment Method': 'Delete Payment Method',
      'Failed to load payment methods': 'Failed to load payment methods',
      'Failed to load images': 'Failed to load images',
      'Recipe Stock Management': 'Recipe Stock Management',
      'Manage ingredients and recipe-based stock': 'Manage ingredients and recipe-based stock',
      'Used in Products': 'Used in Products',
      'Not used in any recipes': 'Not used in any recipes',
      'Unknown': 'Unknown',
      'Update Inventory': 'Update Inventory',
      'Receive Stock': 'Receive Stock',
      'Stock Count': 'Stock Count',
      'Use Receive Stock to add inventory or Stock Count to submit your physical count': 'Use Receive Stock to add inventory or Stock Count to submit your physical count',
      'Counted Stock': 'Counted Stock',
      'Enter count': 'Enter count',
      'Show counted only': 'Show counted only',
      '{counted} of {total} counted': '{counted} of {total} counted',
      'No items counted yet': 'No items counted yet',
      'Submit Count': 'Submit Count',
      'Optional notes about this count': 'Optional notes about this count',
      'Current Stock': 'Current Stock',
      'New Stock': 'New Stock',
      'Set total': 'Set total',
      'Add/Subtract': 'Add/Subtract',
      'Reason': 'Reason',
      'Adjustment Reason': 'Adjustment Reason',
      'Physical count': 'Physical count',
      'Physical Count': 'Physical Count',
      'Receiving goods': 'Receiving goods',
      'Adjustment': 'Adjustment',
      'adjustment': 'Adjustment',
      'Sale': 'Sale',
      'sale': 'Sale',
      'Restock': 'Restock',
      'restock': 'Restock',
      'Waste': 'Waste',
      'waste': 'Waste',
      'Return': 'Return',
      'return': 'Return',
      'venta': 'Sale',
      'receiving': 'Receiving',
      'physical_count': 'Physical count',
      'Search items...': 'Search items...',
      'Show modified only': 'Show modified only',
      'Undo changes': 'Undo changes',
      'Difference': 'Difference',
      'Select reason': 'Select reason',
      'Optional notes about this adjustment': 'Optional notes about this adjustment',
      'Back to Stock Levels': 'Back to Stock Levels',
      'Unit cannot be changed after product creation to maintain inventory integrity': 'Unit cannot be changed after product creation to maintain inventory integrity',
      '{count} items will be updated': '{count} items will be updated',
      'No changes detected': 'No changes detected',
      'Update Stock': 'Update Stock',
      'Stock updated successfully': 'Stock updated successfully',
      'Failed to update inventory': 'Failed to update inventory',
      'No items found': 'No items found',
      'No inventory items available': 'No inventory items available',
      'Created By': 'Created By',
      'Used for product ID: {productId}, quantity: {quantity}': 'Used for product ID: {productId}, quantity: {quantity}',
      'Failed to create payment method: ': 'Failed to create payment method: ',
      'Failed to update payment method: ': 'Failed to update payment method: ',
      'Failed to delete payment method: ': 'Failed to delete payment method: ',
      'No payment methods found': 'No payment methods found',
      'Enter the percentage as a decimal (e.g., 2.5 for 2.5%)': 'Enter the percentage as a decimal (e.g., 2.5 for 2.5%)',
      'Must be a valid number': 'Must be a valid number',
      'Percentage cannot be less than 0': 'Percentage cannot be less than 0',
      'Percentage cannot be more than 100': 'Percentage cannot be more than 100',
      'Search by percentage': 'Search by percentage',
      'Payment removal canceled': 'Payment removal canceled',
      // Product Edit Form Translations
      'Edit product': 'Edit product',
      'Save product': 'Save product',
      'Product active': 'Product active',
      'Disable the product for the public store': 'Disable the product for the public store',
      'Price': 'Price',
      'Product description': 'Product description',
      'View Product': 'View Product',
      'Back to Products': 'Back to Products',
      'Back to business': 'Back to business',
      'Basic Information': 'Basic Information',
      'Essential product details and pricing': 'Essential product details and pricing',
      'Detailed description of your product': 'Detailed description of your product',
      'Inventory Management': 'Inventory Management',
      'Configure how inventory is tracked for this product': 'Configure how inventory is tracked for this product',
      'Inventory Type': 'Inventory Type',
      'Simple Stock Tracking': 'Simple Stock Tracking',
      'Recipe-Based (Ingredients)': 'Recipe-Based (Ingredients)',
      'No Inventory Tracking': 'No Inventory Tracking',
      'Warehouse Product (Almacén)': 'Warehouse Product (Almacén)',
      'Linked Warehouse Product': 'Linked Warehouse Product',
      'Warehouse stock': 'Warehouse stock',
      'Stock is tracked by the linked warehouse product. Sales are allowed below zero.': 'Stock is tracked by the linked warehouse product. Sales are allowed below zero.',
      'Warehouse': 'Warehouse',
      'Select a warehouse product': 'Select a warehouse product',
      'Ingredients block the sale when stock is insufficient; warehouse items allow selling below zero': 'Ingredients block the sale when stock is insufficient; warehouse items allow selling below zero',
      'Use ingredients for bulk raw material (g, ml); use warehouse items for countable units shared with other products or modifiers': 'Use ingredients for bulk raw material (g, ml); use warehouse items for countable units shared with other products or modifiers',
      'Ingredients block sales at zero; warehouse items allow negative': 'Ingredients block sales at zero; warehouse items allow negative',
      'Inventory configured for "{name}"': 'Inventory configured for "{name}"',
      'Used in product sale': 'Used in product sale',
      'Restored from cancellation': 'Restored from cancellation',
      'Direct sale': 'Direct sale',
      'quantity': 'quantity',
      'Choose how to track inventory for this product': 'Choose how to track inventory for this product',
      'Current quantity in stock': 'Current quantity in stock',
      'Insufficient stock for product {productName}. Available: {available}, Required: {required}': 'Insufficient stock for product {productName}. Available: {available}, Required: {required}',
      'Unit of Measurement': 'Unit of Measurement',
      'Pieces': 'Pieces',
      'Grams': 'Grams',
      'Kilograms': 'Kilograms',
      'Milliliters': 'Milliliters',
      'Liters': 'Liters',
      'Boxes': 'Boxes',
      'Packs': 'Packs',
      'Recipe-Based Tracking': 'Recipe-Based Tracking',
      'Recipe-based products use ingredients for inventory tracking.': 'Recipe-based products use ingredients for inventory tracking.',
      'Manage Recipe & Ingredients': 'Manage Recipe & Ingredients',
      'No inventory tracking - suitable for services or digital products.': 'No inventory tracking - suitable for services or digital products.',
      'Product Modifiers': 'Product Modifiers',
      'Add customizable options and variations': 'Add customizable options and variations',
      'Product Photo': 'Product Photo',
      'Upload and manage product images': 'Upload and manage product images',
      'Organize product into categories': 'Organize product into categories',
      'No modifiers yet': 'No modifiers yet',
      'Add modifiers to customize this product': 'Add modifiers to customize this product',
      'Add your first modifier': 'Add your first modifier',
      'No options added yet': 'No options added yet',
      'Add first option': 'Add first option',
      'Set as default': 'Set as default',
      'What are modifiers?': 'What are modifiers?',
      'Modifiers allow customers to customize products with options like size, toppings, or extras.': 'Modifiers allow customers to customize products with options like size, toppings, or extras.',
      'Customer must choose one option (e.g., Size: Small, Medium, or Large)': 'Customer must choose one option (e.g., Size: Small, Medium, or Large)',
      'Multiple values': 'Multiple values',
      'Customer can select multiple options (e.g., Toppings: Cheese, Bacon, Onions)': 'Customer can select multiple options (e.g., Toppings: Cheese, Bacon, Onions)',
      'Customer must make a selection before adding to cart': 'Customer must make a selection before adding to cart',
      'Select table or client first': 'Select table or client first',
      'Select table or customer': 'Select table or customer',
      'Add options for customers to choose from (e.g., Small, Medium, Large)': 'Add options for customers to choose from (e.g., Small, Medium, Large)',
      'Tip: Use the menu button (⋮) in the header to add more options': 'Tip: Use the menu button (⋮) in the header to add more options',
      'Select Existing': 'Select Existing',
      'Attach to Product': 'Attach to Product',
      'No modifiers available to attach': 'No modifiers available to attach',
      'All modifiers are already attached to this product, or create a new one using the "Create New" tab': 'All modifiers are already attached to this product, or create a new one using the "Create New" tab',
      'This modifier is used by {count} products. Changes will apply to all.': 'This modifier is used by {count} products. Changes will apply to all.',
      'Used by': 'Used by',
      'product': 'product',
      'products': 'products',
      'Add Modifier': 'Add Modifier',
      'This modifier is used by {count} products. Deleting it will remove it from all products. Continue?': 'This modifier is used by {count} products. Deleting it will remove it from all products. Continue?',
      'Modifier attached successfully': 'Modifier attached successfully',
      'Manage product modifiers': 'Manage product modifiers',
      'Modifier created successfully': 'Modifier created successfully',
      'Modifier updated successfully': 'Modifier updated successfully',
      'Modifier deleted successfully': 'Modifier deleted successfully',
      'Do you want to permanently delete this modifier?': 'Do you want to permanently delete this modifier?',
      'No modifiers found': 'No modifiers found',
      'Update modifier': 'Update modifier',
      'Multiple': 'Multiple',
      'Not used by any products': 'Not used by any products',
      'Preview': 'Preview',
      'Used by Products': 'Used by Products',
      'No charge': 'No charge',
      'Failed to load modifier details': 'Failed to load modifier details',
      'Default price': 'Default price',
      'Override price': 'Override price',
      'Product price': 'Product price',
      'Sets a price override for this product only': 'Sets a price override for this product only',
      'Edit base price': 'Edit base price',
      'Failed to update base price': 'Failed to update base price',
      'Defines product price': 'Defines product price',
      'Price defined by modifier': 'Price defined by: {name}',
      'Pricing modifier': 'Pricing modifier',
      'Use single price': 'Use single price',
      'Select pricing modifier': 'Select pricing modifier',
      'Select modifier': 'Select modifier',
      'Select...': 'Select...',
      'Qty': 'Qty',
      'Add a required, single-select modifier first (e.g., Size)': 'Add a required, single-select modifier first (e.g., Size)',
      'Create a modifier to define prices by option (e.g., Size: Small $30, Medium $45)': 'Create a modifier to define prices by option (e.g., Size: Small $30, Medium $45)',
      'Search or create modifier...': 'Search or create modifier...',
      'Search or create category...': 'Search or create category...',
      'Search expense type...': 'Search expense type...',
      'Detach modifier': 'Detach modifier',
      'Modifier name (e.g., Size)': 'Modifier name (e.g., Size)',
      'Add options from the Modifiers section below': 'Add options from the Modifiers section below',
      'Save the product first, then configure pricing modifier on the edit page': 'Save the product first, then configure pricing modifier on the edit page',
      'Option': 'Option',
      'Select categories': 'Select categories',
      'Categories updated': 'Categories updated',
      'Failed to update categories': 'Failed to update categories',
      'All Categories': 'All Categories',
      'Filter by category': 'Filter by category',
      'No modifiers attached': 'No modifiers attached',
      'Price overrides saved': 'Price overrides saved',
      'Failed to load modifier prices': 'Failed to load modifier prices',
      'Failed to save price overrides': 'Failed to save price overrides',
      'Clear override': 'Clear override',
      'Default': 'Default',
      'modifier': 'modifier',
      'modifiers': 'modifiers',

      // Product Creation Help
      'Add a new product to your catalog with inventory tracking': 'Add a new product to your catalog with inventory tracking',
      'Recipe-based products use ingredients for inventory tracking. You can configure the recipe after creating the product.': 'Recipe-based products use ingredients for inventory tracking. You can configure the recipe after creating the product.',
      'Getting Started': 'Getting Started',
      'Tips for creating your product': 'Tips for creating your product',
      'Add a clear, descriptive product name': 'Add a clear, descriptive product name',
      'Set accurate pricing for your target market': 'Set accurate pricing for your target market',
      'Choose the right inventory tracking method': 'Choose the right inventory tracking method',
      'You can add photos and categories after creating the product': 'You can add photos and categories after creating the product',

      // Product Import Translations
      'Import Products': 'Import Products',
      'Bulk upload products from CSV file': 'Bulk upload products from CSV file',
      'Download CSV Template': 'Download CSV Template',
      'Step 1: Download Template': 'Step 1: Download Template',
      'Download the CSV template to see the required format': 'Download the CSV template to see the required format',
      'Step 2: Upload CSV File': 'Step 2: Upload CSV File',
      'Upload your CSV file with product data': 'Upload your CSV file with product data',
      'Choose CSV File': 'Choose CSV File',
      'Maximum file size: 1MB': 'Maximum file size: 1MB',
      'Step 3: Preview & Validate': 'Step 3: Preview & Validate',
      'Import Results': 'Import Results',
      'Import completed successfully': 'Import completed successfully',
      'products created': 'products created',
      'products skipped': 'products skipped',
      'categories created': 'categories created',
      'Row': 'Row',
      'Title': 'Title',
      'Valid': 'Valid',
      'Invalid': 'Invalid',
      'Ready': 'Ready',
      'Total rows': 'Total rows',
      'CSV Format': 'CSV Format',
      'Required Columns': 'Required Columns',
      'Product name (max 255 chars)': 'Product name (max 255 chars)',
      'Category name': 'Category name',
      'Price (format: 0.00)': 'Price (format: 0.00)',
      'Default Values': 'Default Values',
      'Active: Yes': 'Active: Yes',
      'Stock: 0': 'Stock: 0',
      'Inventory Type: Simple': 'Inventory Type: Simple',
      'Important Notes': 'Important Notes',
      'Duplicate products (by name) will be skipped': 'Duplicate products (by name) will be skipped',
      'Categories will be created automatically if they don\'t exist': 'Categories will be created automatically if they don\'t exist',
      'All imported products are active by default': 'All imported products are active by default',
      'Stock levels default to 0 and must be updated manually': 'Stock levels default to 0 and must be updated manually',
      'Maximum 500 products per import recommended': 'Maximum 500 products per import recommended',
      'Title is required': 'Title is required',
      'Title too long (max 255 chars)': 'Title too long (max 255 chars)',
      'Category is required': 'Category is required',
      'Valid price is required': 'Valid price is required',
      'Import completed: {created} created, {skipped} skipped': 'Import completed: {created} created, {skipped} skipped',
      'Import failed': 'Import failed',
      'View Products': 'View Products',

      'Edit Business': 'Edit Business',
      'POS Configuration': 'POS Configuration',
      'Service Mode': 'Service Mode',
      'Orders (Standard POS)': 'Orders (Standard POS)',
      'Checks (Restaurant/KDS)': 'Checks (Restaurant/KDS)',
      'Select service mode': 'Select service mode',
      'Orders and Checks modes are mutually exclusive': 'Orders and Checks modes are mutually exclusive',
      'Enable Combos': 'Enable Combos',
      'Show combos feature in POS interface': 'Show combos feature in POS interface',
      'Enable Custom Items': 'Enable Custom Items',
      'Show custom item button in POS interface': 'Show custom item button in POS interface',
      'Configure which features are enabled in your Point of Sale interface': 'Configure which features are enabled in your Point of Sale interface',
      'Optional Features': 'Optional Features',
      'System Configuration': 'System Configuration',
      'Configure system-wide settings for your Point of Sale': 'Configure system-wide settings for your Point of Sale',
      'POS Features': 'POS Features',
      'No categories or products available': 'No categories or products available',
      'Categories and products will appear here when you visit this store online first.': 'Categories and products will appear here when you visit this store online first.',
      'No store selected': 'No store selected',
      'Please visit a store first to use the POS system offline.': 'Please visit a store first to use the POS system offline.',
      'Login failed. Please try again.': 'Login failed. Please try again.',
      'Order Details': 'Order Details',
      'Order History': 'Order History',
      'Loading history...': 'Loading history...',
      'No history available': 'No history available',
      'This order has not been modified yet': 'This order has not been modified yet',
      'Order Created': 'Order Created',
      'Order Modified': 'Order Modified',
      'Status Changed': 'Status Changed',
      'Order Cancelled': 'Order Cancelled',
      'From': 'From',
      'To': 'To',
      'Total Change': 'Total Change',
      'Edits': 'Edits',
      'Retry': 'Retry',
      'Product Quantity Changes': 'Product Quantity Changes',
      'for stock reconciliation': 'for stock reconciliation',
      'Recipe Ingredient Changes': 'Recipe Ingredient Changes',
      'Production Capacity': 'Production Capacity',
      'max units with current stock': 'max units with current stock',
      'Cannot produce any units': 'Cannot produce any units',
      'Low production capacity': 'Low production capacity',
      'Good production capacity': 'Good production capacity',
      'Missing ingredients or insufficient stock': 'Missing ingredients or insufficient stock',
      'Consider restocking ingredients': 'Consider restocking ingredients',
      'Ingredient Usage': 'Ingredient Usage',
      'used': 'used',
      'restored': 'restored',
      'Warning: This order is approaching the edit limit. Only 1 edit(s) remaining.': 'Warning: This order is approaching the edit limit. Only 1 edit(s) remaining.',
      'Order has reached the maximum number of edits (5). Contact an administrator.': 'Order has reached the maximum number of edits (5). Contact an administrator.',
      'Loading order information...': 'Loading order information...',
      'Loading order details...': 'Loading order details...',
      'Reports': 'Reports',
      'Product Grid Layout': 'Product Grid Layout',
      'Product Testing': 'Product Testing',
      'Create a business': 'Create a business',
      'JWT Test': 'JWT Test',
      'Manage your business information and settings': 'Manage your business information and settings',
      'Manage your products and inventory': 'Manage your products and inventory',
      'Create and manage product combinations': 'Create and manage product combinations',
      'Manage combo options, groups and products': 'Manage combo options, groups and products',

      // Combo Creation Wizard
      'Create a new combo with multiple products and options': 'Create a new combo with multiple products and options',
      'Essential combo details and pricing': 'Essential combo details and pricing',
      'Choose a descriptive name for your combo': 'Choose a descriptive name for your combo',
      'Set the total price for this combo': 'Set the total price for this combo',
      'Detailed description of what is included in this combo': 'Detailed description of what is included in this combo',
      'After Creation': 'After Creation',
      'What you can do after creating your combo': 'What you can do after creating your combo',
      'Add Option Groups': 'Add Option Groups',
      'Create groups of selectable options for customization': 'Create groups of selectable options for customization',
      'Add Products': 'Add Products',
      'Include products from your catalog in each option group': 'Include products from your catalog in each option group',
      'Configure Options': 'Configure Options',
      'Set default selections and price variations': 'Set default selections and price variations',
      'Tips for creating your combo': 'Tips for creating your combo',
      'Choose an attractive combo name that describes the value': 'Choose an attractive combo name that describes the value',
      'Set a competitive price that offers savings over individual items': 'Set a competitive price that offers savings over individual items',
      'Add a clear description of what customers get': 'Add a clear description of what customers get',
      'You will configure option groups and products after creation': 'You will configure option groups and products after creation',
      'Combo Benefits': 'Combo Benefits',
      'Why combos are great for your business': 'Why combos are great for your business',
      'Increase average order value': 'Increase average order value',
      'Offer customers convenient meal solutions': 'Offer customers convenient meal solutions',
      'Promote slower-moving inventory items': 'Promote slower-moving inventory items',
      'Organize products into categories': 'Organize products into categories',
      'Track work shifts and employee hours': 'Track work shifts and employee hours',
      'Manage user access and permissions': 'Manage user access and permissions',
      'Configure payment methods and settings': 'Configure payment methods and settings',
      'Create and manage discount rules': 'Create and manage discount rules',
      'Manage customer information and contacts': 'Manage customer information and contacts',

      // Cache Management Translations
      'Clear cache': 'Clear cache',
      'will be cleared': 'will be cleared',
      'Cache': 'Cache',
      'Cache not cleared': 'Cache not cleared',
      'Cache cleared': 'Cache cleared',
      'Cache cleared successfully': 'Cache cleared successfully',
      'Clearing...': 'Clearing...',
      'Cache Management': 'Cache Management',
      'Clear application cache and temporary data': 'Clear application cache and temporary data',

      // Product Photos Translations
      'Product Images': 'Product Images',
      'Product Photos': 'Product Photos',
      'Manage product photos to showcase your items': 'Manage product photos to showcase your items',
      'Upload and manage product images with full-width gallery': 'Upload and manage product images with full-width gallery',
      'No images uploaded yet': 'No images uploaded yet',
      'Processing': 'Processing',
      'Upload product image': 'Upload product image',
      'Upload failed': 'Upload failed',
      'Failed to save photo': 'Failed to save photo',
      'Are you sure you want to remove this photo?': 'Are you sure you want to remove this photo?',
      'Failed to remove photo': 'Failed to remove photo',
      'Product image': 'Product image',
      'View image': 'View image',
      'of': 'of',
      'Previous image': 'Previous image',
      'Next image': 'Next image',
      'Drop image here': 'Drop image here',
      'Photo uploaded successfully': 'Photo uploaded successfully',
      'Photo removed successfully': 'Photo removed successfully',
      'Images reordered successfully': 'Images reordered successfully',
      'Failed to reorder images': 'Failed to reorder images',
      'Primary Image': 'Primary Image',
      'Upload Date': 'Upload Date',
      'Description': 'Description',

      // Offline PWA translations
      'You are offline': 'You are offline',
      'You are offline - showing cached data': 'You are offline - showing cached data',
      'Connection restored': 'Connection restored',
      'Syncing...': 'Syncing...',
      'Sync Orders': 'Sync Orders',
      'Please check your internet connection and try again': 'Please check your internet connection and try again',
      'Available Offline Features': 'Available Offline Features',
      'View cached products and menu': 'View cached products and menu',
      'Create orders (saved locally)': 'Create orders (saved locally)',
      'Review previous transactions': 'Review previous transactions',
      'Orders will sync when reconnected': 'Orders will sync when reconnected',
      'Try Again': 'Try Again',
      'Go to Store': 'Go to Store',
      'Order saved offline. Will sync when reconnected.': 'Order saved offline. Will sync when reconnected.',
      'Failed to save order offline': 'Failed to save order offline',
      'Ready for Offline': 'Ready for Offline',
      'Clear Cache': 'Clear Cache',
      'Compact': 'Compact',
      'Expanded': 'Expanded',
      'Offline mode prepared successfully': 'Offline mode prepared successfully',
      'Prepare Offline Mode': 'Prepare Offline Mode',
      'Current Orders': 'Current Orders',
      'Offline Orders': 'Offline Orders',
      'Orders': 'Orders',
      'Paid orders for this shift': 'Completed orders for this shift',
      'No orders found': 'No orders found',
      'Offline Order': 'Offline Order',
      'This order was created while offline': 'This order was created while offline',
      'No offline orders found.': 'No offline orders found.',

      // Cart action translations
      'Add one': 'Add one',
      'Remove one': 'Remove one',
      'Edit Combo': 'Edit Combo',
      'Edit Custom Combo': 'Edit Custom Combo',
      'Edit Product': 'Edit Product',
      'Preparing...': 'Preparing...',
      'No Shift Selected': 'No Shift Selected',
      'Please select a shift to view its details': 'Please select a shift to view its details',

      // Inventory Reports - English
      'Stock Levels': 'Stock Levels',
      'Current stock levels for all products and ingredients': 'Current stock levels for all products and ingredients',
      'Filter by Type': 'Filter by Type',
      'All Items': 'All Items',
      'Unit Value': 'Unit Value',
      'No items match your search criteria': 'No items match your search criteria',
      'No stock data available': 'No stock data available',
      'Export CSV': 'Export CSV',
      'Export XLS': 'Export XLS',
      'Export to CSV': 'Export to CSV',
      'Exporting...': 'Exporting...',
      'Sales data exported successfully': 'Sales data exported successfully',
      'Failed to export sales data': 'Failed to export sales data',
      'Check Sales': 'Check Sales',
      'In Combo': 'In Combo',
      'Failed to fetch check product sales': 'Failed to fetch check product sales',
      'Product Sales (Total)': 'Product Sales (Total)',
      'Failed to fetch sales by inventory': 'Failed to fetch sales by inventory',
      'Search product...': 'Search product...',
      'Group by product': 'Group by product',
      'Search by name...': 'Search by name...',
      'Low': 'Low',
      'Start typing to search products and combos': 'Start typing to search products and combos',
      'Searching for': 'Searching for',
      'Clear': 'Clear',
      'to close': 'to close',
      'to clear search': 'to clear search',

      // Print Translations
      'print': {
        receipt: {
          order: 'Order',
          date: 'Date',
          clientInfo: 'CLIENT INFO',
          name: 'Name',
          email: 'Email',
          phone: 'Phone',
          address: 'Address',
          city: 'City',
          state: 'State',
          postal: 'Postal',
          notes: 'Notes',
          item: 'Item',
          qty: 'Qty',
          price: 'Price',
          subtotal: 'Subtotal',
          discount: 'Discount',
          total: 'TOTAL',
          payment: 'Payment',
          thankYou: 'Thank you!',
          visitAgain: 'Visit us again!',
        },
      },
      'kds.send': 'Send to Kitchen',
      // ===== CHECKS MODULE TRANSLATIONS (for Nuxt Layer) =====
      // These translations are used by the layers/checks module
      // Copy this section when porting to Tauri app
      'Check Cart': 'Check Cart',
      '{count} items': '{count} items',
      'item': 'item',
      'items': 'items',
      'Save': 'Save',
      'Save Check': 'Save Check',
      'Send to Kitchen': 'Send to Kitchen',
      'Kitchen': 'Kitchen',
      'Check': 'Check',
      'No Active Check': 'No Active Check',
      'Select a table to start a new check': 'Select a table to start a new check',
      'Table': 'Table',
      'Park Check': 'Park Check',
      'Check saved successfully': 'Check saved successfully',
      'Unsent Items': 'Unsent Items',
      'Sent to Kitchen': 'Sent to Kitchen',
      'Modified': 'Modified',
      'Item modified after being sent to kitchen': 'Item modified after being sent to kitchen',
      'Cannot remove items already sent to kitchen': 'Cannot remove items already sent to kitchen',
      'Cannot modify items already sent to kitchen': 'Cannot modify items already sent to kitchen',
      'Cannot edit items already sent to kitchen': 'Cannot edit items already sent to kitchen',
      'Failed to save check': 'Failed to save check',
      'No active check': 'No active check',
      'Order sent to kitchen': 'Order sent to kitchen',
      'Failed to send to kitchen': 'Failed to send to kitchen',
      'Mark as Ready': 'Mark as Ready',
      'Preparing': 'Preparing',
      'Served': 'Served',
      'Voided': 'Voided',
      'Canceled': 'Canceled',
      'Ready Items': 'Ready Items',
      'Served Items': 'Served Items',
      'Voided Items': 'Voided Items',
      'Canceled Items': 'Canceled Items',
      'Void': 'Void',
      'Void Item': 'Void Item',
      'Void Reason': 'Void Reason',
      'customer_cancel': 'Customer cancelled',
      'kitchen_error': 'Kitchen error',
      'server_error': 'Server error',
      'allergy': 'Allergy',
      'other': 'Other',
      'customer_changed_mind': 'Customer changed mind',
      'wrong_item': 'Wrong item',
      'pricing_issue': 'Pricing issue',
      'Item already sent to kitchen. Use void instead.': 'Item already sent to kitchen. Use void instead.',
      'Can only void items that have been sent to kitchen': 'Can only void items that have been sent to kitchen',
      'Optional': 'Optional',
      'Add any additional notes...': 'Add any additional notes...',
      'No open checks': 'No open checks',
      'Check parked': 'Check parked',
      'Check parked - Table {tableNumber} available to reselect': 'Check parked - Table {tableNumber} available to reselect',
      'Collapse tables': 'Collapse tables',
      'Expand tables': 'Expand tables',
      'Park': 'Park',
      'Cuenta guardada exitosamente': 'Check saved successfully',
      'Table not found': 'Table not found',
      'Table {tableNumber} already has an open check': 'Table {tableNumber} already has an open check',
      'Open new check for table {tableNumber}?': 'Open new check for table {tableNumber}?',
      'Open Check': 'Open Check',
      'New Check': 'New Check',
      'Use {name} in new check': 'Use {name} in new check',
      '{name} already has an open check': '{name} already has an open check',
      'Open Orders': 'Open Orders',
      'Search customer...': 'Search customer...',
      'Walk-in': 'Walk-in',
      'Order identifier...': 'Order identifier...',
      'Loaded check {checkNumber}': 'Loaded check {checkNumber}',
      'Check closed successfully': 'Check closed successfully',
      'Item status updated': 'Item status updated',
      'Failed to close check': 'Failed to close check',
      'Editing closed check': 'Editing closed check',
      'changes will adjust inventory automatically': 'changes will adjust inventory automatically',
      'Label': 'Label',
      'Revisions': 'Revisions',
      'Revision History': 'Revision History',
      'Audit trail of all edits made to this check': 'Audit trail of all edits made to this check',
      'No revisions found': 'No revisions found',
      'This check has not been edited after closing.': 'This check has not been edited after closing.',
      'Check snapshot before edit': 'Check snapshot before edit',
      'Original': 'Original',
      'Back to Checks': 'Back to Checks',
      'Current State': 'Current State',
      'Columns': 'Columns',
      'Hide Tables': 'Hide Tables',
      'Show Tables': 'Show Tables',
      'Close Check': 'Close Check',
      'Cancel Check': 'Cancel Check',
      'Cancel this empty check? It can be reopened later.': 'Cancel this empty check? It can be reopened later.',
      'Yes, Cancel': 'Yes, Cancel',
      'Tax': 'Tax',
      'Tip': 'Tip',
      'Enter tax amount': 'Enter tax amount',
      'Enter discount amount': 'Enter discount amount',
      'Enter tip amount': 'Enter tip amount',
      'Other': 'Other',
      'Close & Pay': 'Close & Pay',
      'Subtotal': 'Subtotal',
      'Final Total': 'Final Total',
      'Cannot close an empty check': 'Cannot close an empty check',
      'Summary': 'Summary',
      'Surcharge': 'Surcharge',
      'Select payment method': 'Select payment method',
      'Select discount': 'Select discount',
      'Check was closed from another device': 'Check was closed from another device',
      'Cash Received': 'Cash Received',
      'Amount Received': 'Amount Received',
      'Change': 'Change',
      'Calculate Change': 'Calculate Change',
      'Insufficient cash amount': 'Insufficient cash amount',
      'Split payment': 'Split payment',
      'Remaining': 'Remaining',
      'Overpaid': 'Overpaid',
      'Use single payment': 'Use single payment',
      'Tendered': 'Tendered',
      'Applied': 'Applied',
      // ===== END CHECKS MODULE TRANSLATIONS =====

      // Missing translations for offline/recipes functionality
      'No products available': 'No products available',
      'No combos available': 'No combos available',
      'Combos will appear here when you visit this store online first.': 'Combos will appear here when you visit this store online first.',
      'Financial Summary': 'Financial Summary',
      'View all {count} items': 'View all {count} items',
      'Products will appear here when you visit this store online first.': 'Products will appear here when you visit this store online first.',
      'This page works offline with previously cached data.': 'This page works offline with previously cached data.',
      'Search recipes...': 'Search recipes...',
      'No recipes found': 'No recipes found',
      'Create products with recipe-based inventory to see them here': 'Create products with recipe-based inventory to see them here',
      'Filter by status': 'Filter by status',

      // Expenses translations
      'Expenses': 'Expenses',
      'Daily Expenses': 'Daily Expenses',
      'View and manage daily business expenses': 'View and manage daily business expenses',
      'Select Date': 'Select Date',
      'No expenses found for this date': 'No expenses found for this date',
      'No expenses found for this period': 'No expenses found for this period',
      'Expense Type': 'Expense Type',
      'Expense Date': 'Expense Date',
      'General': 'General',
      'Edit expense': 'Edit expense',
      'Cannot add expenses to closed shifts': 'Cannot add expenses to closed shifts',

      // Expense Types Management
      'Expense Types': 'Expense Types',
      'Add expense type': 'Add expense type',
      'No expense types found': 'No expense types found',
      'Enter expense type name': 'Enter expense type name',
      'Optional description': 'Optional description',
      'Inactive expense types are hidden from forms': 'Inactive expense types are hidden from forms',
      'Create expense type': 'Create expense type',
      'Update expense type': 'Update expense type',
      'Failed to create expense type': 'Failed to create expense type',
      'Failed to update expense type': 'Failed to update expense type',
      'Missing required data': 'Missing required data',
      'Please check the form data and try again': 'Please check the form data and try again',
      'Expense type created successfully': 'Expense type created successfully',
      'Expense type updated successfully': 'Expense type updated successfully',
      'Expense type deleted successfully': 'Expense type deleted successfully',
      'Cannot delete expense type that is in use': 'Cannot delete expense type that is in use',
      'Do you want to delete this expense type?': 'Do you want to delete this expense type?',
      'Confirmation': 'Confirmation',
      'Deactivate': 'Deactivate',
      'Activate': 'Activate',
      'Manage expense categories for your business': 'Manage expense categories for your business',
      'Edit expense type': 'Edit expense type',
      'Add new expense type': 'Add new expense type',
      'Parent expense type': 'Parent expense type',
      'None (top level)': 'None (top level)',
      'Only two levels of expense types are allowed': 'Only two levels of expense types are allowed',
      'Cannot delete a category that has subtypes': 'Cannot delete a category that has subtypes',
      'Adding subtypes makes this a category — it can no longer be chosen directly.': 'Adding subtypes makes this a category — it can no longer be chosen directly.',
      'Updated': 'Updated',
      'Expense deleted successfully': 'Expense deleted successfully',
      'Failed to load expenses': 'Failed to load expenses',

      // Fund Sources Management
      'Fund Sources': 'Fund Sources',
      'Cash source': 'Cash source',
      'Cash sources reduce the shift expected cash; card or transfer sources do not': 'Cash sources reduce the shift expected cash; card or transfer sources do not',
      'Fund source': 'Fund source',
      'Fund source is required': 'Fund source is required',
      'Search fund source...': 'Search fund source...',
      'No source': 'No source',
      'No fund sources found': 'No fund sources found',
      'Add fund source': 'Add fund source',
      'Add new fund source': 'Add new fund source',
      'Edit fund source': 'Edit fund source',
      'Create fund source': 'Create fund source',
      'Update fund source': 'Update fund source',
      'Enter fund source name': 'Enter fund source name',
      'Inactive fund sources are hidden from forms': 'Inactive fund sources are hidden from forms',
      'Manage where expense money is taken from': 'Manage where expense money is taken from',
      'Fund source created successfully': 'Fund source created successfully',
      'Fund source updated successfully': 'Fund source updated successfully',
      'Fund source deleted successfully': 'Fund source deleted successfully',
      'Failed to load fund sources': 'Failed to load fund sources',
      'Failed to create fund source': 'Failed to create fund source',
      'Failed to update fund source': 'Failed to update fund source',
      'Failed to delete fund source': 'Failed to delete fund source',
      'Cannot delete fund source that is in use': 'Cannot delete fund source that is in use',
      'Do you want to delete this fund source?': 'Do you want to delete this fund source?',

      // Dining Areas Translations
      'Dining Areas': 'Dining Areas',
      'Manage restaurant dining areas and sections': 'Manage restaurant dining areas and sections',
      'Add dining area': 'Add dining area',
      'Edit dining area': 'Edit dining area',
      'Add new dining area': 'Add new dining area',
      'Display Order': 'Display Order',
      'No dining areas found': 'No dining areas found',
      'Main Dining Room': 'Main Dining Room',
      'Optional description of the area': 'Optional description of the area',
      'Do you want to deactivate this dining area?': 'Do you want to deactivate this dining area?',
      'Do you want to permanently delete this dining area? This will remove the area assignment from all associated tables.': 'Do you want to permanently delete this dining area? This will remove the area assignment from all associated tables.',
      'Dining area created successfully': 'Dining area created successfully',
      'Dining area updated successfully': 'Dining area updated successfully',
      'Dining area activated successfully': 'Dining area activated successfully',
      'Dining area deleted successfully': 'Dining area deleted successfully',
      'Dining area deactivated successfully': 'Dining area deactivated successfully',
      'Failed to activate dining area': 'Failed to activate dining area',
      'Failed to load dining areas': 'Failed to load dining areas',
      'Failed to load dining area': 'Failed to load dining area',
      'Failed to create dining area': 'Failed to create dining area',
      'Failed to update dining area': 'Failed to update dining area',
      'Failed to delete dining area': 'Failed to delete dining area',
      'Failed to load dining area data': 'Failed to load dining area data',
      // Tables Translations
      'Tables': 'Tables',
      'Manage restaurant tables and seating': 'Manage restaurant tables and seating',
      'Add table': 'Add table',
      'Edit table': 'Edit table',
      'Add new table': 'Add new table',
      'Update table': 'Update table',
      'Table Number': 'Table Number',
      '1, A3, Booth 7': '1, A3, Booth 7',
      'Capacity': 'Capacity',
      'Sort Order': 'Sort Order',
      'Select dining area (optional)': 'Select dining area (optional)',
      'No tables found': 'No tables found',
      'Search tables...': 'Search tables...',
      'No tables available': 'No tables available',
      'Unassigned': 'Unassigned',
      'Occupied': 'Occupied',
      'Reserved': 'Reserved',
      'Cleaning': 'Cleaning',
      'Do you want to deactivate this table?': 'Do you want to deactivate this table?',
      'Do you want to permanently delete this table?': 'Do you want to permanently delete this table?',
      'Table created successfully': 'Table created successfully',
      'Table updated successfully': 'Table updated successfully',
      'Table activated successfully': 'Table activated successfully',
      'Table deleted successfully': 'Table deleted successfully',
      'Table deactivated successfully': 'Table deactivated successfully',
      'Table status updated successfully': 'Table status updated successfully',
      'Failed to activate table': 'Failed to activate table',
      'Failed to load tables': 'Failed to load tables',
      'Failed to load table': 'Failed to load table',
      'Failed to create table': 'Failed to create table',
      'Failed to update table': 'Failed to update table',
      'Failed to delete table': 'Failed to delete table',
      'Failed to update table status': 'Failed to update table status',
      'Failed to load table data': 'Failed to load table data',
      'Open New Check': 'Open New Check',
      'Failed to open check': 'Failed to open check',
      'guests': 'guests',
      // Servers Translations
      'Servers': 'Servers',
      'Manage restaurant servers and staff': 'Manage restaurant servers and staff',
      'Add server': 'Add server',
      'Edit server': 'Edit server',
      'Add new server': 'Add new server',
      'Update server': 'Update server',
      'Employee Number': 'Employee Number',
      'PIN Code': 'PIN Code',
      '4-6 digit PIN': '4-6 digit PIN',
      'PIN must be 4-6 digits': 'PIN must be 4-6 digits',
      'PIN must contain only digits': 'PIN must contain only digits',
      'Maria Garcia': 'Maria Garcia',
      'Handles To-Go Orders': 'Handles To-Go Orders',
      'Handles Delivery Orders': 'Handles Delivery Orders',
      'No servers found': 'No servers found',
      'Do you want to deactivate this server?': 'Do you want to deactivate this server?',
      'Do you want to permanently delete this server?': 'Do you want to permanently delete this server?',
      'Server created successfully': 'Server created successfully',
      'Server updated successfully': 'Server updated successfully',
      'Server activated successfully': 'Server activated successfully',
      'Server deleted successfully': 'Server deleted successfully',
      'Server deactivated successfully': 'Server deactivated successfully',
      'Failed to activate server': 'Failed to activate server',
      'Failed to load servers': 'Failed to load servers',
      'Failed to load server': 'Failed to load server',
      'Failed to create server': 'Failed to create server',
      'Failed to update server': 'Failed to update server',
      'Failed to delete server': 'Failed to delete server',
      'Failed to load server data': 'Failed to load server data',

      // Checks Translations
      'Checks': 'Checks',
      'Manage restaurant checks': 'Manage restaurant checks',
      'Add check': 'Add check',
      'Edit check': 'Edit check',
      'Add new check': 'Add new check',
      'Update check': 'Update check',
      'Check Number': 'Check Number',
      'Check Type': 'Check Type',
      'Select check type': 'Select check type',
      'Customer is optional. You can skip this step.': 'Customer is optional. You can skip this step.',
      'Customer name': 'Customer name',
      'Find Client': 'Find Client',
      'Dine In': 'Dine In',
      'To-Go': 'To-Go',
      'Third Party': 'Third Party',
      'Type': 'Type',
      'Open': 'Open',
      'Closed': 'Closed',
      'Cancelled': 'Cancelled',
      'Customer': 'Customer',
      'Customer Name': 'Customer Name',
      'Customer Phone': 'Customer Phone',
      'Guests': 'Guests',
      'Guest Count': 'Guest Count',
      'Kitchen Display': 'Kitchen Display',
      'KDS not enabled': 'KDS not enabled',
      'Kitchen Display System is not enabled for this business': 'Kitchen Display System is not enabled for this business',
      'Enable KDS (Kitchen Display System)': 'Enable KDS (Kitchen Display System)',
      'Show KDS screen and enable realtime kitchen sync': 'Show KDS screen and enable realtime kitchen sync',
      'Only available in Restaurant mode': 'Only available in Restaurant mode',
      'Opened At': 'Opened At',
      'Closed At': 'Closed At',
      'Updated At': 'Updated At',
      'Filter By': 'Filter By',
      'Filters applied': 'Filters applied',
      'Clear all': 'Clear all',
      'Select table': 'Select table',
      'Select server': 'Select server',
      'Optional notes': 'Optional notes',
      'No checks found': 'No checks found',
      'Do you want to permanently delete this check?': 'Do you want to permanently delete this check?',
      'Check created successfully': 'Check created successfully',
      'Check updated successfully': 'Check updated successfully',
      'Check deleted successfully': 'Check deleted successfully',
      'Failed to load checks': 'Failed to load checks',
      'Failed to load check': 'Failed to load check',
      'Failed to create check': 'Failed to create check',
      'Failed to update check': 'Failed to update check',
      'Failed to delete check': 'Failed to delete check',
      'Failed to load check data': 'Failed to load check data',
      'Delete Check': 'Delete Check',
      'Delete Order': 'Delete Order',
      'Do you want to delete this check? You can add a reason for the audit log.': 'Do you want to delete this check? You can add a reason for the audit log.',
      'Do you want to delete this order? You can add a reason for the audit log.': 'Do you want to delete this order? You can add a reason for the audit log.',
      'Are you sure you want to delete this item?': 'Are you sure you want to delete this item?',
      'Enter a reason for deletion...': 'Enter a reason for deletion...',
      'Deleted Checks': 'Deleted Checks',
      'Audit log of soft-deleted checks': 'Audit log of soft-deleted checks',
      'No deleted checks found': 'No deleted checks found',
      'Deleted By': 'Deleted By',
      'Delete Reason': 'Delete Reason',
      'Deleted At': 'Deleted At',
      'Restore': 'Restore',
      'Check restored successfully': 'Check restored successfully',
      'Failed to restore check': 'Failed to restore check',
      'Failed to load deleted checks': 'Failed to load deleted checks',
      'checks.deleteSuccess': 'Check deleted successfully',
      'checks.deleteError': 'Failed to delete check',
      'checks.deleteOfflineError': 'Cannot delete check while offline',
      'checks.deleteAuthError': 'Please sign in to delete checks',
      'Deleted Orders': 'Deleted Orders',
      'Audit log of soft-deleted orders': 'Audit log of soft-deleted orders',
      'No deleted orders found': 'No deleted orders found',
      'Order restored successfully': 'Order restored successfully',
      'Failed to restore order': 'Failed to restore order',
      'Failed to load deleted orders': 'Failed to load deleted orders',
      'pending': 'Pending',
      'preparing': 'Preparing',
      'ready': 'Ready',
      'served': 'Served',
      'not_sent': 'Not Sent',
      'sent_to_kitchen': 'Sent to Kitchen',
      'canceled': 'Canceled',
      'Send Email': 'Send Email',
      'Customer Email': 'Customer Email',
      'Send Receipt via Email': 'Send Receipt via Email',
      'Email sent successfully': 'Email sent successfully',
      'Failed to send email': 'Failed to send email',
      'Please enter an email address': 'Please enter an email address',
      'Please enter a valid email address': 'Please enter a valid email address',
      'Receipt': 'Receipt',
      'Email Testing': 'Email Testing',
      'Send Test Receipt': 'Send Test Receipt',
      'Send Test Email': 'Send Test Email',
      'Test Data Preview': 'Test Data Preview',
      'Test email sent successfully': 'Test email sent successfully',
      'Failed to send test email': 'Failed to send test email',
      'Confirming your email': 'Confirming your email',
      'Please wait while we verify your email address': 'Please wait while we verify your email address',
      'Confirmation Failed': 'Confirmation Failed',
      'Email Confirmed!': 'Email Confirmed!',
      'Redirecting to login': 'Redirecting to login',
      'Processing invitation': 'Processing invitation',
      'Please wait while we verify your invitation': 'Please wait while we verify your invitation',
      'The invitation link is invalid or has expired': 'The invitation link is invalid or has expired',
      'Failed to process invitation': 'Failed to process invitation',
      'Invalid invitation link': 'Invalid invitation link',
      'Failed to establish session': 'Failed to establish session',
      'Invitation accepted successfully': 'Invitation accepted successfully',
      'Invitation Failed': 'Invitation Failed',
      'Invitation Accepted': 'Invitation Accepted',
      'Redirecting to set your password': 'Redirecting to set your password',
      'Go to Login': 'Go to Login',
      'Account created successfully! Please check your email to confirm your account before logging in.': 'Account created successfully! Please check your email to confirm your account before logging in.',
      'Check Details': 'Check Details',
      'Check Info': 'Check Info',
      'Inventory Movements': 'Inventory Movements',
      'Download Image': 'Download Image',
      'Share': 'Share',
      'Failed to share receipt': 'Failed to share receipt',
      'Failed to generate image': 'Failed to generate image',
      'Transfer Table': 'Transfer Table',
      'Transfer': 'Transfer',
      'Save Notes': 'Save Notes',
      'Add notes': 'Add notes',
      'Add notes about this check': 'Add notes about this check',
      'Void Check': 'Void Check',
      'Receipt Preview': 'Receipt Preview',
      'Table transferred successfully': 'Table transferred successfully',
      'Notes saved successfully': 'Notes saved successfully',
      'Check voided successfully': 'Check voided successfully',
      'Failed to load check details': 'Failed to load check details',
      'Please enter customer email': 'Please enter customer email',
      'Items': 'Items',
      'Danger Zone': 'Danger Zone',
      'Receipt Actions': 'Receipt Actions',
      'No items in this check': 'No items in this check',
      'Total Checks': 'Total Checks',
      'First Check': 'First Check',
      'Last Check': 'Last Check',
      'Orders Income': 'Orders Income',
      'Checks Income': 'Checks Income',
      'Last Activity': 'Last Activity',
      'Total Tax': 'Total Tax',
      'Total Tips': 'Total Tips',

      // Financial Overview Translations
      'Financial Overview': 'Financial Overview',
      'View daily financial performance with sales and expense analytics': 'View daily financial performance with sales and expense analytics',
      'Today': 'Today',
      'Yesterday': 'Yesterday',
      'This Week': 'This Week',
      'This Month': 'This Month',
      'Date Range': 'Date Range',
      'Net Profit': 'Net Profit',
      'Net Loss': 'Net Loss',
      'Sales by Payment Method': 'Sales by Payment Method',
      'Expenses by Category': 'Expenses by Category',
      'Expenses by Fund Source': 'Expenses by Fund Source',
      'No category': 'No category',
      'Category Detail': 'Category Detail',
      'Sales Details': 'Sales Details',
      'Expense Details': 'Expense Details',
      'Payment Method': 'Payment Method',
      'All payment methods': 'All payment methods',
      'Category': 'Category',
      'No sales data available': 'No sales data available',
      'No expense data available': 'No expense data available',
      'No sales data found': 'No sales data found',
      'No expense data found': 'No expense data found',
      'Failed to load financial data': 'Failed to load financial data',
      'Select date range': 'Select date range',

      // Custom Item Translations
      'Artículo Personalizado': 'Custom Item',
      'Enter item name': 'Enter item name',
      'Enter price': 'Enter price',
      'Agregar al Pedido': 'Add to Order',
      'Custom item added': 'Custom item added',
      'Price is required': 'Price is required',
      'Price must be at least 0.01': 'Price must be at least 0.01',
      'Quantity is required': 'Quantity is required',
      'Quantity must be at least 1': 'Quantity must be at least 1',
      'Color': 'Color',

      // Category Colors
      'Slate': 'Slate',
      'Blue': 'Blue',
      'Emerald': 'Emerald',
      'Amber': 'Amber',
      'Red': 'Red',
      'Orange': 'Orange',
      'Purple': 'Purple',
      'Teal': 'Teal',
      'Rose': 'Rose',
      'Lime': 'Lime',
      'Indigo': 'Indigo',
      'Cyan': 'Cyan',
      'Yellow': 'Yellow',
      'Black': 'Black',

      // Order Email Translations
      'Send Order via Email': 'Send Order via Email',

      // KDS Station Translations
      'Station': 'Station',
      'Select Station': 'Select Station',
      'KDS Stations': 'KDS Stations',
      'Station Name': 'Station Name',
      'Station Type': 'Station Type',
      'Bar': 'Bar',
      'Expo': 'Expo',
      'No station selected': 'No station selected',
      'Please select a KDS station to view orders': 'Please select a KDS station to view orders',
      'Assign product categories to KDS stations for item routing': 'Assign product categories to KDS stations for item routing',
      'Assign Categories': 'Assign Categories',
      'Available Categories': 'Available Categories',
      'Assigned Categories': 'Assigned Categories',
      'Save Assignments': 'Save Assignments',
      'No KDS stations found': 'No KDS stations found',
      'Create stations in the database first': 'Create stations in the database first',
      'Category assignments saved successfully': 'Category assignments saved successfully',
      'Failed to load KDS stations': 'Failed to load KDS stations',
      'Failed to load station categories': 'Failed to load station categories',
      'Failed to save category assignments': 'Failed to save category assignments',
      'Add new KDS station': 'Add new KDS station',
      'Edit KDS station': 'Edit KDS station',
      'Add KDS station': 'Add KDS station',
      'Update KDS station': 'Update KDS station',
      'Manage kitchen display system stations': 'Manage kitchen display system stations',
      'Do you want to deactivate this KDS station?': 'Do you want to deactivate this KDS station?',
      'Do you want to permanently delete this KDS station?': 'Do you want to permanently delete this KDS station?',
      'KDS station created successfully': 'KDS station created successfully',
      'KDS station updated successfully': 'KDS station updated successfully',
      'KDS station activated successfully': 'KDS station activated successfully',
      'KDS station deactivated successfully': 'KDS station deactivated successfully',
      'KDS station deleted successfully': 'KDS station deleted successfully',
      'Kitchen Main': 'Kitchen Main',
      'All': 'All',

      // Super Admin Translations
      'Super Admin': 'Super Admin',
      'Super Admin Dashboard': 'Super Admin Dashboard',
      'All Businesses': 'All Businesses',
      'All Users': 'All Users',
      'Change Password': 'Change Password',
      'Change password for': 'Change password for',
      'New Password': 'New Password',
      'Enter new password': 'Enter new password',
      'Minimum 6 characters': 'Minimum 6 characters',
      'Update Password': 'Update Password',
      'Password updated successfully': 'Password updated successfully',
      'Password must be at least 6 characters': 'Password must be at least 6 characters',
      'Failed to update password': 'Failed to update password',
      'Set Your Password': 'Set Your Password',
      'Create a secure password for your account': 'Create a secure password for your account',
      'Confirm Password': 'Confirm Password',
      'Passwords do not match': 'Passwords do not match',
      'Password set successfully': 'Password set successfully',
      'No active session': 'No active session',
      'Your session has expired': 'Your session has expired',
      'Please sign in again to continue': 'Please sign in again to continue',
      'Session restored': 'Session restored',
      'Sign in to continue': 'Sign in to continue',
      'No business assigned to this account': 'No business assigned to this account',
      'Failed to restore session. Please try again.': 'Failed to restore session. Please try again.',
      'Please enter a valid email': 'Please enter a valid email',
      'Enter your password': 'Enter your password',
      'Repeat your password': 'Repeat your password',
      'Set Password': 'Set Password',
      'Forgot your password?': 'Forgot your password?',
      'Reset Password': 'Reset Password',
      'Enter your email to receive a reset link': 'Enter your email to receive a reset link',
      'Send Reset Link': 'Send Reset Link',
      'Reset link sent': 'Reset link sent',
      'Check your email for the reset link': 'Check your email for the reset link',
      'Password reset successfully': 'Password reset successfully',
      'Invalid reset link': 'Invalid reset link',
      'The reset link is invalid or has expired': 'The reset link is invalid or has expired',
      'Failed to verify reset link': 'Failed to verify reset link',
      'Verifying reset link': 'Verifying reset link',
      'New password should be different from the old password': 'New password should be different from the old password',
      'You do not have any business assigned yet': 'You do not have any business assigned yet',
      'Select a Business': 'Select a Business',
      'You have access to multiple businesses. Select one to continue.': 'You have access to multiple businesses. Select one to continue.',
      'Loading your businesses': 'Loading your businesses',
      'Failed to load businesses': 'Failed to load businesses',
      'Failed to load business configuration': 'Failed to load business configuration',
      'Failed to initialize business data': 'Failed to initialize business data',
      'Failed to select business': 'Failed to select business',
      'Business selected successfully': 'Business selected successfully',
      'Processing magic link': 'Processing magic link',
      'Please wait while we verify your login': 'Please wait while we verify your login',
      'The magic link is invalid or has expired': 'The magic link is invalid or has expired',
      'Failed to process magic link': 'Failed to process magic link',
      'Invalid magic link': 'Invalid magic link',
      'Login Successful': 'Login Successful',
      'Authenticated successfully': 'Authenticated successfully',
      'Failed to load business data': 'Failed to load business data',
      'No Business Assigned': 'No Business Assigned',
      'Please contact your administrator to get access to a business': 'Please contact your administrator to get access to a business',
      'Add Business': 'Add Business',
      'Back': 'Back',
      'Business Name': 'Business Name',
      'Debug redirect URL': 'Debug redirect URL',
      'When set, users are redirected here after login': 'When set, users are redirected here after login',
      'Owner User ID': 'Owner User ID',
      'Optional - leave empty to create business without owner': 'Optional - leave empty to create business without owner',
      'Select unassigned user': 'Select unassigned user',
      'Only users without business assignments shown': 'Only users without business assignments shown',
      'Total Businesses': 'Total Businesses',
      'Total Users': 'Total Users',
      'Business created successfully': 'Business created successfully',
      'Business updated successfully': 'Business updated successfully',
      'Create User & Business': 'Create User & Business',
      'Owner Information': 'Owner Information',
      'Owner Name': 'Owner Name',
      'Owner Email': 'Owner Email',
      'Admin has full access, Employee has limited access': 'Admin has full access, Employee has limited access',
      'Invitation will be sent to this email': 'Invitation will be sent to this email',
      'Business Description': 'Business Description',
      'Service Type': 'Service Type',
      'Counter for quick service, Restaurant for table service': 'Counter for quick service, Restaurant for table service',
      '(Optional)': '(Optional)',
      'Business Email': 'Business Email',
      'Creating...': 'Creating...',
      'Business created and linked to existing user': 'Business created and linked to existing user',
      'User invited and business created successfully': 'User invited and business created successfully',
      'Failed to create user and business': 'Failed to create user and business',
      'Confirm': 'Confirm',
      'User removed from business': 'User removed from business',
      'Remove from Business': 'Remove from Business',
      'Delete User': 'Delete User',
      'User deleted successfully': 'User deleted successfully',
      'Failed to delete user': 'Failed to delete user',
      'Add User': 'Add User',
      'Add User to Business': 'Add User to Business',
      'User must already exist in the system': 'User must already exist in the system',
      'User added to business': 'User added to business',
      'Failed to add user': 'Failed to add user',
      'Filter by email': 'Filter by email',
      'Business': 'Business',
      'Loading businesses...': 'Loading businesses...',
      'Business Usage Metrics': 'Business Usage Metrics',
      'Usage Metrics': 'Usage Metrics',
      'Avg Orders/Day': 'Avg Orders/Day',
      'Avg Order Value': 'Avg Order Value',
      'Avg Daily Revenue': 'Avg Daily Revenue',
      'Total Orders': 'Total Orders',
      'Active Days': 'Active Days',
      'Total Revenue': 'Total Revenue',
      'First Order': 'First Order',
      'Last Order': 'Last Order',
      'Failed to fetch business metrics': 'Failed to fetch business metrics',
      'Failed to fetch users': 'Failed to fetch users',

      // Subscription & Billing Translations
      'Subscription Status': 'Subscription Status',
      'Trial': 'Trial',
      'Active': 'Active',
      'Payment Due': 'Payment Due',
      'Paused': 'Paused',
      'Churn': 'Churn',
      'Owner': 'Owner',
      'Next Billing Date': 'Next Billing Date',
      'Days Overdue': 'Days Overdue',
      'days': 'days',
      'businesses': 'businesses',
      'Mark as Paid': 'Mark as Paid',
      'Pause': 'Pause',
      'Unpause': 'Unpause',
      'Business paused successfully': 'Business paused successfully',
      'Business unpaused successfully': 'Business unpaused successfully',
      'Edit Subscription': 'Edit Subscription',
      'Due Date': 'Due Date',
      'Exempt': 'Exempt',
      'Exempt from automatic billing': 'Exempt from automatic billing',
      'Subscription updated successfully': 'Subscription updated successfully',
      'Failed to update subscription': 'Failed to update subscription',
      'Grace period expires 7 days after this date': 'Grace period expires 7 days after this date',
      'Business Service Paused': 'Business Service Paused',
      'This business has been paused due to unpaid subscription': 'This business has been paused due to unpaid subscription',
      'Your service has been temporarily suspended. To reactivate your account:': 'Your service has been temporarily suspended. To reactivate your account:',
      'Contact our support team to process your payment': 'Contact our support team to process your payment',
      'Once payment is received, your service will be reactivated immediately': 'Once payment is received, your service will be reactivated immediately',
      'All your data remains secure and will be available upon reactivation': 'All your data remains secure and will be available upon reactivation',
      'Business reactivated successfully': 'Business reactivated successfully',
      'Failed to mark payment as received': 'Failed to mark payment as received',
      'Payment overdue - Service will be paused soon': 'Payment overdue - Service will be paused soon',
      'Payment due - Service will be paused in 1 day': 'Payment due - Service will be paused in 1 day',
      'Payment due - Service will be paused in {days} days': 'Payment due - Service will be paused in {days} days',
      'Please contact support to process your payment': 'Please contact support to process your payment',
      'Subscription Settings': 'Subscription Settings',
      'Initial Subscription Status': 'Initial Subscription Status',
      'Trial for new businesses, Active if payment already received': 'Trial for new businesses, Active if payment already received',
      'Subscription Start Date': 'Subscription Start Date',
      'Date when billing cycle begins': 'Date when billing cycle begins',
      'Billing Day of Month': 'Billing Day of Month',
      'Day of each month when payment is due (default: 20)': 'Day of each month when payment is due (default: 20)',
      'Created by': 'Created by',
      'Edited by': 'Edited by',

      // Tienda (Public Store) Translations
      'Store not found': 'Store not found',
      'The store you are looking for does not exist.': 'The store you are looking for does not exist.',
      'Loading store...': 'Loading store...',
      'Search products...': 'Search products...',
      'No products found': 'No products found',
      'Your cart is empty': 'Your cart is empty',
      'Your cart': 'Your cart',
      'Proceed to checkout': 'Proceed to checkout',
      'Add to cart': 'Add to cart',
      'Update': 'Update',
      'Multiple': 'Multiple',
      'Order summary': 'Order summary',
      'Your information': 'Your information',
      'Your name': 'Your name',
      'Your phone number': 'Your phone number',
      'Delivery address (optional)': 'Delivery address (optional)',
      'Special instructions (optional)': 'Special instructions (optional)',
      'Place order': 'Place order',
      'Failed to place order. Please try again.': 'Failed to place order. Please try again.',
      'An error occurred. Please try again.': 'An error occurred. Please try again.',
      'Order confirmed!': 'Order confirmed!',
      'Thank you for your order. We will prepare it as soon as possible.': 'Thank you for your order. We will prepare it as soon as possible.',
      'Order number': 'Order number',
      'You will receive a notification when your order is ready.': 'You will receive a notification when your order is ready.',
      'Continue shopping': 'Continue shopping',
    },
    es: {
      'welcome': 'Bienvenido',
      'Manage Business': 'Gestionar Negocio',
      'Business Information': 'Información del Negocio',
      'Business Photo': 'Foto del Negocio',
      'Address Information': 'Información de Dirección',
      'Business Details': 'Detalles del Negocio',
      'All Products': 'Todos los productos',
      'Filter by Category': 'Filtrar por categoría',
      'Select': 'Seleccionar',
      'Select Category': 'Seleccionar categoría',
      'Miscellaneous': 'Varios',
      'Access your store': 'Accede a tu tienda',
      'Build using': 'Construido usando',
      'Payment Method': 'Método de pago',
      'All payment methods': 'Todos los métodos de pago',
      'Edit Client': 'Editar cliente',
      'Add Client': 'Añadir cliente',
      'Cart total': 'Total del carrito',
      'Products': 'Productos',
      'No products available': 'No hay productos disponibles',
      'No combos available': 'No hay combos disponibles',
      'Combos will appear here when you visit this store online first.': 'Los combos aparecerán aquí cuando visites esta tienda en línea primero.',
      'Financial Summary': 'Resumen Financiero',
      'View all {count} items': 'Ver todos los {count} artículos',
      'Products will appear here when you visit this store online first.': 'Los productos aparecerán aquí cuando visites esta tienda en línea primero.',
      'No categories or products available': 'No hay categorías o productos disponibles',
      'Categories and products will appear here when you visit this store online first.': 'Las categorías y productos aparecerán aquí cuando visites esta tienda en línea primero.',
      'No store selected': 'No hay tienda seleccionada',
      'Please visit a store first to use the POS system offline.': 'Por favor visita una tienda primero para usar el sistema POS sin conexión.',
      'Login failed. Please try again.': 'Error al iniciar sesión. Por favor intenta de nuevo.',
      'This page works offline with previously cached data.': 'Esta página funciona sin conexión con datos previamente almacenados.',
      'Search recipes...': 'Buscar recetas...',
      'No recipes found': 'No se encontraron recetas',
      'Create products with recipe-based inventory to see them here': 'Crea productos con inventario basado en recetas para verlos aquí',
      'Filter by status': 'Filtrar por estado',
      'Cart': 'Carrito',
      'Client': 'Cliente',
      'Clear client': 'Limpiar cliente',
      'Orders': 'Pedidos',
      'Paid orders for this shift': 'Órdenes completadas de este turno',
      'No orders found': 'No se encontraron órdenes',
      'Closed checks for this shift': 'Cuentas cerradas de este turno',
      'Current Orders': 'Órdenes Actuales',
      'Offline Orders': 'Órdenes Offline',
      'Offline Order': 'Orden Offline',
      'This order was created while offline': 'Esta orden fue creada sin conexión',
      'No offline orders found.': 'No se encontraron órdenes offline.',
      'Log out': 'Cerrar sesión',
      'Grid': 'Cuadrícula',
      'Sign in': 'Iniciar sesión',
      'Generate order': 'Generar pedido',
      'Save changes': 'Guardar cambios',
      'Back to store': 'Volver a la tienda',
      'Generate': 'Generar',
      'Clear cart': 'Limpiar carrito',
      'Hide edit': 'Ocultar edición',
      'Show edit': 'Mostrar edición',
      'Select extras': 'Seleccionar extras',
      'Add to cart': 'Añadir al carrito',
      'Options': 'Opciones',
      'Customize': 'Personalizar',
      'Add': 'Añadir',
      'Remove': 'Eliminar',
      'Edit': 'Editar',
      'Save': 'Guardar',
      'Cancel': 'Cancelar',
      'Add one': 'Añadir uno',
      'Remove one': 'Quitar uno',
      'Edit Combo': 'Editar Combo',
      'Edit Custom Combo': 'Editar Combo Personalizado',
      'Edit Product': 'Editar Producto',
      'Preparing...': 'Preparando...',
      'No Shift Selected': 'Ningún Turno Seleccionado',
      'Please select a shift to view its details': 'Por favor selecciona un turno para ver sus detalles',
      'Customize combo': 'Personalizar combo',
      'Combo': 'Combo',
      'Add custom combo to cart': 'Añadir combo personalizado al carrito',
      'Order details': 'Detalles del pedido',
      'Created': 'Creado',
      'Order': 'Pedido',
      'Order status': 'Estado del pedido',
      'New': 'Nuevo',
      'Paid': 'Pagado',
      'Ready': 'Listo',
      'Completed': 'Completado',
      'Create account': 'Crear cuenta',
      'Client details': 'Detalles del cliente',
      'Name': 'Nombre',
      'Email': 'Correo electrónico',
      'Phone': 'Teléfono',
      'Address': 'Dirección',
      'Comments': 'Comentarios',
      'Clear details': 'Limpiar detalles',
      'Delivery': 'Entrega',
      'Delivery address': 'Dirección de entrega',
      'City': 'Ciudad',
      'State': 'Estado',
      'Zip': 'Código postal',
      'Country': 'País',
      'Save client': 'Guardar cliente',
      'Delete client': 'Eliminar cliente',
      'Delete order': 'Eliminar pedido',
      'Delete product': 'Eliminar producto',
      'Delete combo': 'Eliminar combo',
      'Delete extras': 'Eliminar extras',
      'Delete all': 'Eliminar todo',
      'Delete': 'Eliminar',
      'Delete product from cart': 'Eliminar producto del carrito',
      'Delete combo from cart': 'Eliminar combo del carrito',
      'Delete extras from cart': 'Eliminar extras del carrito',
      'Delete all from cart': 'Eliminar todo del carrito',
      'Delete order from cart': 'Eliminar pedido del carrito',
      'Delete all orders': 'Eliminar todos los pedidos',
      'Username / Password': 'Nombre de usuario y contraseña',
      'Magic link': 'Enlace mágico',
      'Please provide your email': 'Por favor, proporciona tu correo electrónico',
      'Please provide your password': 'Por favor, proporciona tu contraseña',
      'Password': 'Contraseña',
      'Send magic link': 'Enviar enlace mágico',
      'Login': 'Iniciar sesión',
      'Go to POS': 'Ir al punto de venta',
      'Go to point of sale': 'Ir al punto de venta',
      'Sign into your account': 'Inicia sesión en tu cuenta',
      'Created ago': 'Creado hace',
      'Order total': 'Total del pedido',
      'Status': 'Estado',
      'demo': 'Demo',
      'trial': 'Prueba',
      'active': 'Activo',
      'payment_due': 'Pago pendiente',
      'paused': 'Pausado',
      'churn': 'Cancelado',
      'Actions': 'Acciones',
      'View': 'Ver',
      'Add new product': 'Añadir nuevo producto',
      'Categories': 'Categorías',
      'Active': 'Activo',
      'Photo': 'Foto',
      'Product saved': 'Producto guardado',
      'What would you like to do next?': '¿Qué te gustaría hacer ahora?',
      'Keep editing': 'Seguir editando',
      'Create new product': 'Crear nuevo producto',
      'Create new product or service': 'Crear nuevo producto o servicio',
      'Enter a name to get started. You can configure price, inventory and more on the next step.': 'Ingresa un nombre para comenzar. Puedes configurar precio, inventario y más en el siguiente paso.',
      'e.g. Cappuccino, Haircut, Cheesecake...': 'ej. Cappuccino, Corte de cabello, Cheesecake...',
      'Back to products': 'Volver a productos',
      'Product name': 'Nombre del producto',
      'Create product': 'Crear producto',
      'View store': 'Ver tienda',
      'Business': 'Negocio',
      'Sign out': 'Cerrar sesión',
      'Switch business': 'Cambiar negocio',
      'Total sales': 'Ventas totales',
      'Cash sales': 'Ventas en efectivo',
      'Sales by Payment Method': 'Ventas por Método de Pago',
      'Loading shift details...': 'Cargando detalles del turno...',
      'orders': 'órdenes',
      'Products sold': 'Productos vendidos',
      'Sales by payment': 'Ventas por pago',
      'Product': 'Producto',
      'Quantity': 'Cantidad',
      'Order ID': 'ID del pedido',
      'Created at': 'Creado el',
      'Products in order': 'Productos en el pedido',
      'No sales this day': 'No hay ventas este día',
      'Payment': 'Pago',
      'Total': 'Total',
      'Combos': 'Combos',
      'Edit product': 'Editar producto',
      'Save product': 'Guardar producto',
      'Product active': 'Producto activo',
      'Disable the product for the public store': 'Desactiva el producto para la tienda pública',
      'Price': 'Precio',
      'Product description': 'Descripción del producto',
      'View Product': 'Ver Producto',
      'Back to Products': 'Volver a Productos',
      'Back to shifts': 'Volver a turnos',
      'Back to business': 'Volver a negocio',
      'Basic Information': 'Información Básica',
      'Essential product details and pricing': 'Detalles esenciales del producto y precios',
      'Detailed description of your product': 'Descripción detallada de tu producto',
      'Inventory Management': 'Gestión de Inventario',
      'Configure how inventory is tracked for this product': 'Configura cómo se rastrea el inventario para este producto',
      'Inventory Type': 'Tipo de Inventario',
      'Simple Stock Tracking': 'Seguimiento Simple de Stock',
      'Recipe-Based (Ingredients)': 'Basado en Recetas (Ingredientes)',
      'No Inventory Tracking': 'Sin Seguimiento de Inventario',
      'Warehouse Product (Almacén)': 'Producto de Almacén',
      'Linked Warehouse Product': 'Producto de Almacén vinculado',
      'Warehouse stock': 'Stock de almacén',
      'Stock is tracked by the linked warehouse product. Sales are allowed below zero.': 'El stock se controla con el producto de almacén vinculado. Se permiten ventas por debajo de cero.',
      'Warehouse': 'Almacén',
      'Select a warehouse product': 'Selecciona un producto de almacén',
      'Ingredients block the sale when stock is insufficient; warehouse items allow selling below zero': 'Los ingredientes bloquean la venta cuando no hay stock suficiente; los productos de almacén permiten vender por debajo de cero',
      'Use ingredients for bulk raw material (g, ml); use warehouse items for countable units shared with other products or modifiers': 'Usa ingredientes para materia prima a granel (g, ml); usa productos de almacén para unidades contables compartidas con otros productos o modificadores',
      'Ingredients block sales at zero; warehouse items allow negative': 'Los ingredientes bloquean ventas en cero; los productos de almacén permiten negativos',
      'Inventory configured for "{name}"': 'Inventario configurado para "{name}"',
      'Used in product sale': 'Usado en venta de producto',
      'Restored from cancellation': 'Restaurado por cancelación',
      'Direct sale': 'Venta directa',
      'quantity': 'cantidad',
      'Choose how to track inventory for this product': 'Elige cómo rastrear el inventario para este producto',
      'Current Stock': 'Stock Actual',
      'Current quantity in stock': 'Cantidad actual en stock',
      'Unit of Measurement': 'Unidad de Medida',
      'Pieces': 'Piezas',
      'Grams': 'Gramos',
      'Kilograms': 'Kilogramos',
      'Milliliters': 'Mililitros',
      'Liters': 'Litros',
      'Boxes': 'Cajas',
      'Packs': 'Paquetes',
      'Recipe-Based Tracking': 'Seguimiento Basado en Recetas',
      'Recipe-based products use ingredients for inventory tracking.': 'Los productos basados en recetas usan ingredientes para el seguimiento de inventario.',
      'Manage Recipe & Ingredients': 'Gestionar Receta e Ingredientes',
      'No inventory tracking - suitable for services or digital products.': 'Sin seguimiento de inventario - adecuado para servicios o productos digitales.',
      'Product Modifiers': 'Modificadores del Producto',
      'Add customizable options and variations': 'Añadir opciones personalizables y variaciones',
      'Product Photo': 'Foto del Producto',
      'Upload and manage product images': 'Subir y gestionar imágenes del producto',
      'Organize product into categories': 'Organizar producto en categorías',
      'Default': 'Por defecto',
      'Make default': 'Hacer por defecto',
      'Add option': 'Añadir opción',
      'Option name': 'Nombre de la opción',
      'Is default': 'Es por defecto',
      'Description': 'Descripción',
      'Plese use 0 or 0.00 format': 'Por favor, usa el formato 0 o 0.00',
      'Add extra': 'Añadir extra',
      'Extra name': 'Nombre del extra',
      'Please provide a description for this extra': 'Por favor, proporciona una descripción para este extra',
      'Add extras': 'Añadir extras',
      'Extras': 'Extras',
      'Images': 'Imágenes',
      'Upload images': 'Subir imágenes',
      'Upload': 'Subir',
      'Upload images for this product': 'Subir imágenes para este producto',
      'Category added': 'Categoría añadida',
      'Category added to product': 'Categoría añadida al producto',
      'Failed to add category': 'Error al añadir categoría',
      'Category removed': 'Categoría eliminada',
      'Category removed from product': 'Categoría eliminada del producto',
      'Add category to product': 'Añadir categoría al producto',
      'Select category': 'Seleccionar categoría',
      'Cancel combo customization': 'Cancelar personalización del combo',
      'Update': 'Actualizar',
      'Custom': 'Personalizado',
      'Product updated': 'Producto actualizado',
      'Yes': 'Sí',
      'To go': 'Para llevar',
      'Loading your orders': 'Cargando tus pedidos',
      'Discounts': 'Descuentos',
      'Applied discount': 'Descuento aplicado',
      'Price before discount': 'Precio antes del descuento',
      'Discount': 'Descuento',
      'Combo name': 'Nombre del combo',
      'Combos sold': 'Combos vendidos',
      'Print': 'Imprimir',
      'Back to orders': 'Volver a pedidos',
      'View order': 'Ver pedido',
      'Total extras': 'Total de extras',
      'Sale type': 'Tipo de venta',
      'Option': 'Opción',
      'Price variation': 'Variación de precio',
      'Sales by product': 'Ventas por producto',
      'Payment method': 'Método de pago',
      'Reports': 'Reportes',
      'Totals': 'Totales',
      'Standalone product sales': 'Ventas de productos independientes',
      'Product totals': 'Totales de productos',
      'Combo product sales': 'Productos de combos',
      'Custom combo product sales': 'Productos de combos personalizados',
      'Custom combo': 'Combo personalizado',
      'Custom Combo': 'Combo personalizado',
      'Inventory': 'Inventario',
      'By category': 'Por categoría',
      'Category': 'Categoría',
      'Create new category': 'Crear nueva categoría',
      'Category Name': 'Nombre de la categoría',
      'Add new category': 'Añadir nueva categoría',
      'Category name': 'Nombre de la categoría',
      'Add category': 'Añadir categoría',
      'Edit category': 'Editar categoría',
      'Edit Category': 'Editar categoría',
      'will be removed': 'será eliminado',
      'Delete confirmation': 'Confirmación de eliminación',
      'Rejected': 'Rechazado',
      'No': 'No',
      'Deletion canceled': 'Eliminación cancelada',
      'Category removed successfully': 'Categoría eliminada con éxito',
      'Failed to load categories': 'Error al cargar categorías',
      'Category created successfully': 'Categoría creada con éxito',
      'Failed to create category: ': 'Error al crear categoría: ',
      'Category updated successfully': 'Categoría actualizada con éxito',
      'Failed to update category: ': 'Error al actualizar categoría: ',
      'Failed to delete category: ': 'Error al eliminar categoría: ',
      'No categories found': 'No se encontraron categorías',
      'Search by description': 'Buscar por descripción',
      'this cannot be reverted': 'esto no se puede revertir',
      'Delete product confirmation': 'Confirmación de eliminación de producto',
      'Product deletion canceled': 'Eliminación de producto cancelada',
      'Create new combo': 'Crear nuevo combo',
      'Combo deleted': 'Combo eliminado',
      'Combo deleted successfully': 'Combo eliminado con éxito',
      'Error deleting combo': 'Error al eliminar combo',
      'The combo': 'El combo',
      'will be deleted': 'será eliminado',
      'Combo delete confirmation': 'Confirmación de eliminación de combo',
      'Add new combo': 'Añadir nuevo combo',
      'Back to combos': 'Volver a combos',
      'Combo price': 'Precio del combo',
      'Create combo': 'Crear combo',
      'Edit combo': 'Editar combo',
      'Product added correctly': 'Producto añadido correctamente',
      'Error adding product': 'Error al añadir producto',
      'Error getting the products': 'Error al obtener los productos',
      'Products loaded correctly': 'Productos cargados correctamente',
      'Add products': 'Añadir productos',
      'Add products to': 'Añadir productos a',
      'Save option': 'Guardar opción',
      'Add Products': 'Añadir productos',
      'Select combo product': 'Seleccionar producto de combo',
      'Edit combo basic information': 'Editar información básica del combo',
      'Add option group': 'Añadir grupo de opciones',
      'Option group name': 'Nombre del grupo',
      'Edit combo name': 'Editar nombre del combo',
      'Edit description': 'Editar descripción',
      'Update combo': 'Actualizar combo',
      'Issues getting the combo information': 'Problemas al obtener la información del combo',
      'Issues editing the combo information': 'Problemas al editar la información del combo',
      'Edit business information': 'Editar información del negocio',
      'Delete business photo': 'Eliminar foto del negocio',
      'Business image': 'Imagen del negocio',
      'Back': 'Atrás',
      'Address line': 'Línea de dirección',
      'Postal code': 'Código postal',
      'Business description': 'Descripción del negocio',
      'Save business': 'Guardar negocio',
      'Confirmed': 'Confirmado',
      'You have removed the product': 'Has eliminado el producto',
      'Product created': 'Producto creado',
      'Product has been created successfully': 'Producto creado con éxito',
      'Welcome': 'Bienvenido',
      'Email sent': 'Correo electrónico enviado',
      'If your email is registered you soon will receive an email that will enable you to login into your account': 'Si tu correo está registrado pronto recibirás un correo que te permitirá iniciar sesión en tu cuenta',
      'You have been authenticated, you are being redirecting automatically, please wait...': 'Has sido autenticado, estás siendo redirigido automáticamente, por favor espera...',
      'Logging out': 'Cerrando sesión',
      'Please wait while we sign you out': 'Por favor espera mientras cerramos tu sesión',
      'Switching business': 'Cambiando de negocio',
      'Clearing data': 'Limpiando datos',
      'Please wait while we load your businesses': 'Por favor espera mientras cargamos tus negocios',
      'Logout': 'Cerrar sesión',
      'Failed to get users': 'Error al obtener usuarios',
      'Role': 'Rol',
      'Admin': 'Administrador',
      'Employee': 'Empleado',
      'Employee Sales': 'Ventas por Empleado',
      'Product Sales': 'Ventas de Productos',
      'Units sold': 'Unidades vendidas',
      'Unit Price': 'Precio unitario',
      'Revenue': 'Ingresos',
      'All employees': 'Todos los empleados',
      'Include categories': 'Incluir categorías',
      'Gross total': 'Total bruto',
      'Excluded': 'Excluido',
      'Commissionable total': 'Total comisionable',
      'Unit price': 'Precio unitario',
      'Included': 'Incluido',
      'Custom products': 'Productos personalizados',
      'Remove access': 'Eliminar acceso',
      'Access Denied': 'Acceso Denegado',
      'You do not have permission to access this area': 'No tienes permisos para acceder a esta área',
      'This section is restricted to Admin users only': 'Esta sección está restringida solo para usuarios Administradores',
      'Go to your dashboard': 'Ir a tu panel',
      'Sign in with a different account': 'Iniciar sesión con otra cuenta',
      'Signed in as': 'Sesión iniciada como',
      'Users': 'Usuarios',
      'User removal canceled': 'Eliminación de usuario cancelada',
      'Invite new user': 'Invitar nuevo usuario',
      'Failed to load users': 'Error al cargar usuarios',
      'User invited successfully': 'Usuario invitado con éxito',
      'Failed to invite user: ': 'Error al invitar usuario: ',
      'User updated successfully': 'Usuario actualizado con éxito',
      'Failed to update user: ': 'Error al actualizar usuario: ',
      'User removed successfully': 'Usuario eliminado con éxito',
      'Failed to remove user: ': 'Error al eliminar usuario: ',
      'Delete user confirmation': 'Confirmación de eliminar usuario',
      'No users found': 'No se encontraron usuarios',
      'Search by name': 'Buscar por nombre',
      'Search by email': 'Buscar por correo',
      'Search by role': 'Buscar por rol',
      'Send Invitation': 'Enviar Invitación',
      'Select role': 'Seleccionar rol',
      'Name is required': 'El nombre es requerido',
      'Name must be at least 3 characters': 'El nombre debe tener al menos 3 caracteres',
      'Email is required': 'El correo es requerido',
      'Role is required': 'El rol es requerido',
      'Invalid email format': 'Formato de correo inválido',
      'Enter full name': 'Ingrese nombre completo',
      'Enter email address': 'Ingrese dirección de email',
      'Failed to remove user': 'Error al eliminar usuario',
      'Edit permissions': 'Editar permisos',
      'User permissions': 'Permisos de usuario',
      'View shift financials': 'Ver datos financieros del turno',
      'View stock levels': 'Ver niveles de stock',
      'Update stock': 'Actualizar stock',
      'See current stock levels': 'Ver niveles de stock actuales',
      'Use the Update Inventory button to submit your count': 'Usa el botón Actualizar Inventario para enviar tu conteo',
      'Failed to update permissions: ': 'Error al actualizar permisos: ',
      'You cannot remove yourself': 'No puedes eliminarte a ti mismo',
      'You don\'t have any products yet': 'Aún no tienes productos',
      'Photo added': 'Foto añadida',
      'Photo added to the business': 'Foto añadida al negocio',
      'Business ID not found': 'ID del negocio no encontrado',
      'Upload business photo': 'Subir foto del negocio',
      'Business photo': 'Foto del negocio',
      'Upload your business photo': 'Sube la foto de tu negocio',
      'Drag and drop or click to select': 'Arrastra y suelta o haz clic para seleccionar',
      'File too large': 'Archivo demasiado grande',
      'Invalid file type': 'Tipo de archivo inválido',
      'Maximum file size': 'Tamaño máximo de archivo',
      'Allowed formats': 'Formatos permitidos',
      'Replace photo': 'Reemplazar foto',
      'Photo upload failed': 'Error al subir foto',
      'Uploading': 'Subiendo',
      'Delete business image': 'Eliminar imagen del negocio',
      'Image deleted': 'Imagen eliminada',
      'Image not deleted': 'Imagen no eliminada',
      'Business information updated': 'Información del negocio actualizada',
      'Business updated': 'Negocio actualizado',
      'Access your business': 'Accede a tu negocio',
      'Payment methods': 'Métodos de pago',

      // Print Server Configuration Translations
      'Print Server Configuration': 'Configuración del Servidor de Impresión',
      'Configure your local print server settings': 'Configura los ajustes de tu servidor de impresión local',
      'Local Print Server': 'Servidor de Impresión Local',
      'Enable Local Print Server': 'Habilitar Servidor de Impresión Local',
      'Enabled': 'Habilitado',
      'Disabled': 'Deshabilitado',
      'When enabled, orders will be sent to your local print server first': 'Cuando esté habilitado, las órdenes se enviarán primero a tu servidor de impresión local',
      'Print Server URL': 'URL del Servidor de Impresión',
      'Enter the full URL including protocol (http:// or https://)': 'Ingresa la URL completa incluyendo el protocolo (http:// o https://)',
      'Test Connection': 'Probar Conexión',
      'Save Configuration': 'Guardar Configuración',
      'Reset to Default': 'Restablecer Valores',
      'Print server configuration saved': 'Configuración del servidor de impresión guardada',
      'Failed to save configuration': 'Error al guardar la configuración',
      'Please enter a print server URL': 'Por favor ingresa una URL del servidor de impresión',
      'Connection successful': 'Conexión exitosa',
      'Connection failed. Please check the URL and try again.': 'Conexión fallida. Por favor verifica la URL e intenta de nuevo.',
      'Print server is reachable and responding correctly': 'El servidor de impresión es accesible y responde correctamente',
      'Unable to connect to print server. Please verify the URL and network connection.': 'No se puede conectar al servidor de impresión. Por favor verifica la URL y la conexión de red.',
      'Setup Instructions': 'Instrucciones de Configuración',
      '1. Make sure your print server is running on the local network': '1. Asegúrate de que tu servidor de impresión esté ejecutándose en la red local',
      '2. Verify the IP address and port number are correct': '2. Verifica que la dirección IP y el número de puerto sean correctos',
      '3. Test the connection before saving the configuration': '3. Prueba la conexión antes de guardar la configuración',
      '4. The print server should respond to /health endpoint': '4. El servidor de impresión debe responder al endpoint /health',

      'ID': 'ID',
      'Remove payment method': 'Eliminar método de pago',
      'Delete payment method': 'Eliminar método de pago',
      'Add payment method': 'Añadir método de pago',
      'Back to payment methods': 'Volver a métodos de pago',
      'Add new payment method': 'Añadir nuevo método de pago',
      'Create payment method': 'Crear método de pago',
      'Please add payment methods': 'Por favor agregue métodos de pago',
      'Payment created': 'Pago creado',
      'Payment deleted': 'Pago eliminado',
      'Image': 'Imagen',
      'Remove Photo': 'Eliminar foto',
      'Payment method created successfully': 'Método de pago creado con éxito',
      'Payment method could not be created': 'No se pudo crear el método de pago',
      'Payment method updated successfully': 'Método de pago actualizado con éxito',
      'Payment method removed successfully': 'Método de pago eliminado con éxito',
      'Payment method deleted successfully': 'Método de pago eliminado exitosamente',
      'Do you want to delete this payment method permanently?': '¿Quieres eliminar este método de pago permanentemente?',
      'Delete Payment Method': 'Eliminar Método de Pago',
      'Failed to load payment methods': 'Error al cargar métodos de pago',
      'Failed to load images': 'Error al cargar imágenes',
      'Recipe Stock Management': 'Gestión de Stock de Recetas',
      'Manage ingredients and recipe-based stock': 'Gestionar ingredientes y stock basado en recetas',
      'Used in Products': 'Usado en Productos',
      'Not used in any recipes': 'No usado en ninguna receta',
      'Unknown': 'Desconocido',
      'Update Inventory': 'Actualizar Inventario',
      'Receive Stock': 'Recibir Inventario',
      'Stock Count': 'Conteo de Inventario',
      'Use Receive Stock to add inventory or Stock Count to submit your physical count': 'Usa Recibir Inventario para agregar inventario o Conteo de Inventario para enviar tu conteo físico',
      'Counted Stock': 'Stock Contado',
      'Enter count': 'Ingresar conteo',
      'Show counted only': 'Solo mostrar contados',
      '{counted} of {total} counted': '{counted} de {total} contados',
      'No items counted yet': 'No se han contado artículos aún',
      'Submit Count': 'Enviar Conteo',
      'Optional notes about this count': 'Notas opcionales sobre este conteo',
      'New Stock': 'Nuevo Stock',
      'Set total': 'Establecer total',
      'Add/Subtract': 'Agregar/Restar',
      'Reason': 'Razón',
      'Adjustment Reason': 'Razón del Ajuste',
      'Physical count': 'Conteo físico',
      'Physical Count': 'Conteo Físico',
      'Receiving goods': 'Recepción de mercancía',
      'Adjustment': 'Ajuste',
      'adjustment': 'Ajuste',
      'Sale': 'Venta',
      'sale': 'Venta',
      'Restock': 'Reabastecimiento',
      'restock': 'Reabastecimiento',
      'Waste': 'Desperdicio',
      'waste': 'Desperdicio',
      'Return': 'Devolución',
      'return': 'Devolución',
      'venta': 'Venta',
      'receiving': 'Recepción',
      'physical_count': 'Conteo físico',
      'Search items...': 'Buscar artículos...',
      'Show modified only': 'Mostrar solo modificados',
      'Undo changes': 'Deshacer cambios',
      'Difference': 'Diferencia',
      'Select reason': 'Seleccionar razón',
      'Notes': 'Notas',
      'Optional notes about this adjustment': 'Notas opcionales sobre este ajuste',
      'Back to Stock Levels': 'Volver a Niveles de Stock',
      'Unit cannot be changed after product creation to maintain inventory integrity': 'La unidad no se puede cambiar después de la creación del producto para mantener la integridad del inventario',
      '{count} items will be updated': '{count} artículos serán actualizados',
      'No changes detected': 'No se detectaron cambios',
      'Update Stock': 'Actualizar Stock',
      'Stock updated successfully': 'Stock actualizado exitosamente',
      'Failed to update inventory': 'Error al actualizar inventario',
      'No items found': 'No se encontraron artículos',
      'No inventory items available': 'No hay artículos de inventario disponibles',
      'Failed to create payment method: ': 'Error al crear método de pago: ',
      'Failed to update payment method: ': 'Error al actualizar método de pago: ',
      'Failed to delete payment method: ': 'Error al eliminar método de pago: ',
      'No payment methods found': 'No se encontraron métodos de pago',
      'Edit payment method': 'Editar método de pago',
      'Update payment method': 'Actualizar método de pago',
      'Enter the percentage as a decimal (e.g., 2.5 for 2.5%)': 'Ingrese el porcentaje como decimal (ej. 2.5 para 2.5%)',
      'Must be a valid number': 'Debe ser un número válido',
      'Percentage cannot be less than 0': 'El porcentaje no puede ser menor a 0',
      'Percentage cannot be more than 100': 'El porcentaje no puede ser mayor a 100',
      'Search by percentage': 'Buscar por porcentaje',
      'Add discount': 'Añadir descuento',
      'Percentage': 'Porcentaje',
      'Discount could not be created': 'No se pudo crear el descuento',
      'Back to discounts': 'Volver a descuentos',
      'Create discount': 'Crear descuento',
      'Add new discount': 'Añadir nuevo descuento',
      'Discount created': 'Descuento creado',
      'Discount created successfully': 'Descuento creado con éxito',
      'Discount updated successfully': 'Descuento actualizado con éxito',
      'Discount deleted successfully': 'Descuento eliminado con éxito',
      'Edit discount': 'Editar descuento',
      'Update discount': 'Actualizar descuento',
      'No discounts found': 'No se encontraron descuentos',
      'Failed to create discount: ': 'Error al crear descuento: ',
      'Failed to update discount: ': 'Error al actualizar descuento: ',
      'Failed to delete discount: ': 'Error al eliminar descuento: ',
      'Percentage is required': 'El porcentaje es requerido',
      'Percentage must be a number': 'El porcentaje debe ser un número',
      'Remove discount': 'Eliminar descuento',
      'Delete discount': 'Eliminar descuento',
      'Discount deleted': 'Descuento eliminado',
      'Discount deletion canceled': 'Eliminación de descuento cancelada',
      'Success': 'Exito',
      'Order deleted': 'Pedido eliminado',
      'Failed to fetch orders': 'Error al obtener pedidos',
      'Order status updated': 'Estado del pedido actualizado',
      'Failed to update order status': 'Error al actualizar el estado del pedido',
      'Failed to delete order': 'No se pudo eliminar el pedido',
      'Clear cache': 'Limpiar caché',
      'will be cleared': 'será limpiada',
      'Cache': 'Caché',
      'Cache not cleared': 'Caché no limpiada',
      'Cache cleared': 'Caché limpiada',
      'Cache cleared successfully': 'Caché limpiada exitosamente',
      'Clearing...': 'Limpiando...',
      'Cache Management': 'Gestión de caché',
      'Clear application cache and temporary data': 'Limpiar caché de la aplicación y datos temporales',
      'Active product': 'Producto activo',
      'If the product is active, it will be displayed immediately in the store': 'Si el producto está activo, se mostrará inmediatamente en la tienda',
      'Failed to get discounts': 'No se pudieron obtener los descuentos',
      'Error': 'Error',
      'Failed to delete discount': 'No se pudo eliminar el descuento',
      'Add client': 'Agregar cliente',
      'Address line 1': 'Dirección línea 1',
      'Address line 2': 'Dirección línea 2',
      'Client deleted': 'Cliente eliminado',
      'Failed to delete client': 'No se pudo eliminar el cliente',
      'Clients': 'Clientes',
      'Failed to get customers': 'No se pudieron obtener los clientes',
      'Customer deleted': 'Cliente eliminado',
      'Delete customer': 'Eliminar cliente',
      'Failed to delete customer': 'No se pudo eliminar el cliente',
      'Customer deletion canceled': 'Eliminación de cliente cancelada',
      'Customers': 'Clientes',
      'Add customer': 'Agregar cliente',
      'Customer created': 'Cliente creado',
      'Customer created successfully': 'Cliente creado exitosamente',
      'Customer could not be created': 'No se pudo crear el cliente',
      'Add new customer': 'Añadir nuevo cliente',
      'Back to customers': 'Volver a clientes',
      'Create customer': 'Crear cliente',
      'Postal Code': 'Código Postal',
      'Address Line 1': 'Dirección Línea 1',
      'Address Line 2': 'Dirección Línea 2',
      'Customer could not be fetched': 'No se pudo obtener el cliente',
      'Customer updated': 'Cliente actualizado',
      'Customer updated successfully': 'Cliente actualizado con éxito',
      'Customer could not be updated': 'No se pudo actualizar el cliente',
      'Update customer': 'Actualizar cliente',
      'Edit customer': 'Editar cliente',
      'Error fetching customers': 'Error al obtener clientes',
      'Loading': 'Cargando',
      'Loading...': 'Cargando...',
      'Loading products...': 'Cargando productos...',
      'Loading categories and products...': 'Cargando categorías y productos...',
      'Loading combos...': 'Cargando combos...',
      'Counter (Standard POS)': 'Counter (Punto de Venta Estándar)',
      'Restaurant (Tables/KDS)': 'Restaurante (Mesas/KDS)',
      'POS configuration updated successfully': 'Configuración de POS actualizada exitosamente',
      'KDS': 'KDS',
      'Date': 'Fecha',
      'Special instructions': 'Instrucciones especiales',
      'Add any special requests or instructions': 'Agregue cualquier solicitud o instrucción especial',
      'Loading shift data': 'Cargando datos del turno',
      'A shift is already open by {userName}': 'Ya hay un turno abierto por {userName}',
      'Unknown user': 'Usuario desconocido',
      'Used for product ID: {productId}, quantity: {quantity}': 'Usado para producto ID: {productId}, cantidad: {quantity}',
      'No customers found': 'No se encontraron clientes',
      'Search by phone': 'Buscar por teléfono',
      'Not specified': 'No especificado',
      'View Customer': 'Ver Cliente',
      'Contact Information': 'Información de contacto',
      'Not provided': 'No proporcionado',
      'Customer Details': 'Detalles del cliente',
      'Customer ID': 'ID del cliente',
      'Created At': 'Creado el',
      'Last Modified': 'Última modificación',
      'Created By': 'Creado por',
      'Updated By': 'Actualizado por',
      'Business ID': 'ID de negocio',
      'Loading customer details...': 'Cargando detalles del cliente...',
      'Edit Customer': 'Editar cliente',
      'Delete Customer': 'Eliminar cliente',
      'Search by name / phone / email': 'Buscar por nombre / teléfono / correo electrónico',
      'Save in database': 'Guardar en sistema',
      'User ID': 'ID de usuario',
      'Clear user details': 'Limpiar detalles del usuario',
      'Address 1': 'Dirección 1',
      'Address 2': 'Dirección 2',
      'Update user in database': 'Actualizar usuario en sistema',
      'User saved successfully.': 'Usuario guardado exitosamente.',
      'User could not be saved.': 'No se pudo guardar el usuario.',
      'User updated successfully.': 'Usuario actualizado exitosamente.',
      'Move all from new to ready': 'Mover todos de nuevo a listo',
      'Move all from ready to completed': 'Mover todos de listo a completado',
      'open': 'abierto',
      'in_progress': 'en progreso',
      'closed': 'cerrado',
      'revised': 'revisado',
      'voided': 'anulado',
      'edit_started': 'Edición iniciada',
      'admin_edit': 'Edición de admin',
      'Open shift': 'Abrir turno',
      'notes': 'notas',
      'User': 'Usuario',
      'Opening cash amount': 'Monto en efectivo de apertura',
      'Start shift': 'Iniciar turno',
      'Shift': 'Turno',
      'Shift opened successfully': 'Turno abierto exitosamente',
      'Close shift': 'Cerrar turno',
      'Closing notes': 'Notas de cierre',
      'Closing cash amount': 'Monto en efectivo de cierre',
      'Failed to open shift': 'Error al abrir el turno',
      'Expected cash amount': 'Monto de efectivo esperado',
      'Diff cash amount': 'Diferencia en efectivo',
      'Shift closed successfully': 'Turno cerrado exitosamente',
      'Please open a shift to create an order': 'Por favor, abra un turno para crear un pedido',
      'Shift closing error': 'Error al cerrar el turno',
      'purchase': 'compra',
      'payment': 'pago',
      'refund': 'reembolso',
      'Provider payment': 'pago a proveedor',
      'Transaction type': 'Tipo de transacción',
      'Add transaction': 'Añadir transacción',
      'Amount': 'Cantidad',
      'Transaction created successfully': 'Transacción creada exitosamente',
      'Failed to create transaction': 'Error al crear la transacción',
      'Shift ID': 'ID de Turno',
      'Start shift first': 'Por favor, comience el turno primero',
      'Transaction': 'Transacción',
      'Total amount of transactions': 'Cantidad total de transacciones',
      'Open shift amount': 'Monto inicial del turno',
      'Product photo': 'Foto del producto',
      'Add product': 'Añadir producto',
      'Shift expense created successfully': 'Gasto del turno creado exitosamente',
      'Failed to create shift expense': 'Error al crear el gasto del turno',
      'Expense type': 'Tipo de Gasto',
      'Expense type is required': 'El tipo de gasto es obligatorio',
      'Expense Date': 'Fecha de Gasto',
      'Add expense': 'Agregar Gasto',
      'Failed to get shift transactions': 'Error al obtener las transacciones del turno',
      'Total expenses': 'Gastos totales',
      'View shift': 'Ver Turno',
      'Shift expenses': 'Gastos del turno',
      'Expected theoric cash': 'Efectivo en caja esperada',
      'Shift expense updated successfully': 'Gasto del turno actualizado exitosamente',
      'Failed to update shift expense': 'Error al actualizar el gasto del turno',
      'Shift ID is required': 'Se requiere ID del turno',
      'Edit shift expense': 'Editar gasto del turno',
      'Expense ID': 'ID del gasto',
      'Update expense': 'Actualizar gasto',
      'Add new expense': 'Agregar nuevo gasto',
      'Do you want to delete this record?': '¿Desea eliminar este registro?',
      'Record deleted': 'Registro eliminado',
      'You have rejected': 'Has rechazado',
      'No expenses found': 'No se encontraron gastos',
      'Save details (temporarily)': 'Guardar detalles (temporalmente)',
      'Use for this order': 'Usar para este pedido',
      'Save as new customer': 'Guardar como nuevo cliente',
      'Update customer info': 'Actualizar información del cliente',
      'Validation Failed': 'Validación Fallida',
      'Shifts': 'Turnos',
      'Please check the entered expense details and try again': 'Por favor revise los detalles del gasto ingresado e intente nuevamente',
      'Shift status': 'Estado del Turno',
      'Shift start date': 'Fecha de Inicio del Turno',
      'Shift end date': 'Fecha de Fin del Turno',
      'Cash difference': 'Diferencia de Efectivo',
      'Cash': 'Efectivo',
      'Opening notes': 'Notas de Apertura',
      'Error fetching data': 'Error al obtener datos',
      'Start Time': 'Hora de Inicio',
      'End Time': 'Hora de Fin',
      'Shift fetched successfully': 'Turno obtenido con éxito',
      'No shifts found': 'No se encontraron turnos',
      'Failed to load shifts': 'Error al cargar turnos',
      'Shift removed successfully': 'Turno eliminado exitosamente',
      'Failed to delete shift: ': 'Error al eliminar turno: ',
      'New shift': 'Nuevo turno',
      'Open new shift': 'Abrir nuevo turno',
      'Search by ID': 'Buscar por ID',
      'Search by status': 'Buscar por estado',
      'Search by amount': 'Buscar por monto',
      'Start Date': 'Fecha de Inicio',
      'End Date': 'Fecha de Fin',
      'Opening Cash': 'Efectivo Inicial',
      'Closing Cash': 'Efectivo Final',
      'Showing {first} to {last} of {totalRecords} entries': 'Mostrando {first} a {last} de {totalRecords} registros',

      // Shift Details Page Translations
      'Shift Details': 'Detalles del Turno',
      'View detailed information about this shift and manage expenses': 'Ver información detallada sobre este turno y gestionar gastos',
      'Shift Information': 'Información del Turno',
      'Basic shift details and status': 'Detalles básicos del turno y estado',
      'Expenses Management': 'Gestión de Gastos',
      'Track and manage shift expenses': 'Rastrear y gestionar gastos del turno',
      'Start adding expenses to track shift costs': 'Comience agregando gastos para rastrear los costos del turno',
      'Quick Actions': 'Acciones Rápidas',
      'Common shift operations': 'Operaciones comunes del turno',
      'Print shift report': 'Imprimir reporte del turno',
      'Shift Summary': 'Resumen del Turno',
      'Financial overview': 'Resumen financiero',
      'Total Sales': 'Ventas Totales',
      'Orders Total': 'Total Órdenes',
      'Checks Total': 'Total Cuentas',
      'Total Expenses': 'Gastos Totales',
      'Cash Difference': 'Diferencia de Efectivo',

      'Created by': 'Creado por',
      'Edited by': 'Editado por',
      'Group name': 'Nombre del Grupo',
      'Selection Required': 'Selección Requerida',
      'Please select an item to continue': 'Por favor seleccione un artículo para continuar',
      'Modifiers': 'Modificadores',
      'Price change': 'Cambio de precio',
      'Add modifier': 'Agregar modificador',
      'Allow multiple': 'Permitir múltiples',
      'Allow multiple values': 'Permitir múltiples valores',
      'Required': 'Requerido',
      'Force modifier to be required': 'Forzar que el modificador sea requerido',
      'Create': 'Crear',
      'Modifier name': 'Nombre del modificador',
      'Edit modifier': 'Editar modificador',
      'Delete modifier': 'Eliminar modificador',
      'Single value': 'Valor único',
      'Not required': 'No requerido',
      'New modifier option': 'Nueva opción de modificador',
      'Option Created': 'Opción creada',
      'Modifier option has been added successfully': 'La opción de modificador se ha añadido correctamente',
      'No modifiers yet': 'Sin modificadores aún',
      'Select Existing': 'Seleccionar Existente',
      'Attach to Product': 'Adjuntar al Producto',
      'No modifiers available to attach': 'No hay modificadores disponibles para adjuntar',
      'All modifiers are already attached to this product, or create a new one using the "Create New" tab': 'Todos los modificadores ya están adjuntos a este producto, o crea uno nuevo usando la pestaña "Crear Nuevo"',
      'This modifier is used by {count} products. Changes will apply to all.': 'Este modificador es usado por {count} productos. Los cambios se aplicarán a todos.',
      'Used by': 'Usado por',
      'product': 'producto',
      'products': 'productos',
      'Add Modifier': 'Agregar Modificador',
      'This modifier is used by {count} products. Deleting it will remove it from all products. Continue?': 'Este modificador es usado por {count} productos. Eliminarlo lo quitará de todos los productos. ¿Continuar?',
      'Modifier attached successfully': 'Modificador adjuntado exitosamente',
      'Manage product modifiers': 'Administrar modificadores de productos',
      'Modifier created successfully': 'Modificador creado exitosamente',
      'Modifier updated successfully': 'Modificador actualizado exitosamente',
      'Modifier deleted successfully': 'Modificador eliminado exitosamente',
      'Do you want to permanently delete this modifier?': '¿Desea eliminar este modificador permanentemente?',
      'No modifiers found': 'No se encontraron modificadores',
      'Update modifier': 'Actualizar modificador',
      'Multiple': 'Múltiple',
      'Not used by any products': 'No usado por ningún producto',
      'Preview': 'Vista Previa',
      'Used by Products': 'Usado por Productos',
      'No charge': 'Sin cargo',
      'Failed to load modifier details': 'Error al cargar detalles del modificador',
      'Default price': 'Precio base',
      'Override price': 'Precio personalizado',
      'Product price': 'Precio del producto',
      'Sets a price override for this product only': 'Establece un precio personalizado solo para este producto',
      'Edit base price': 'Editar precio base',
      'Failed to update base price': 'Error al actualizar precio base',
      'Defines product price': 'Define precio del producto',
      'Price defined by modifier': 'Precio definido por: {name}',
      'Pricing modifier': 'Modificador de precio',
      'Use single price': 'Usar precio único',
      'Select pricing modifier': 'Seleccionar modificador de precio',
      'Select modifier': 'Seleccionar modificador',
      'Select...': 'Seleccionar...',
      'Qty': 'Cant.',
      'Add a required, single-select modifier first (e.g., Size)': 'Primero agrega un modificador requerido de valor único (ej: Tamaño)',
      'Create a modifier to define prices by option (e.g., Size: Small $30, Medium $45)': 'Crea un modificador para definir precios por opción (ej: Tamaño: Chico $30, Mediano $45)',
      'Search or create modifier...': 'Buscar o crear modificador...',
      'Search or create category...': 'Buscar o crear categoría...',
      'Search expense type...': 'Buscar tipo de gasto...',
      'Detach modifier': 'Desvincular modificador',
      'Modifier name (e.g., Size)': 'Nombre del modificador (ej: Tamaño)',
      'Add options from the Modifiers section below': 'Agrega opciones desde la sección de Modificadores abajo',
      'Save the product first, then configure pricing modifier on the edit page': 'Guarda el producto primero, luego configura el modificador de precio en la página de edición',
      'Select categories': 'Seleccionar categorías',
      'Categories updated': 'Categorías actualizadas',
      'Failed to update categories': 'Error al actualizar categorías',
      'All Categories': 'Todas las Categorías',
      'Filter by category': 'Filtrar por categoría',
      'No modifiers attached': 'Sin modificadores adjuntos',
      'Price overrides saved': 'Precios personalizados guardados',
      'Failed to load modifier prices': 'Error al cargar precios de modificadores',
      'Failed to save price overrides': 'Error al guardar precios personalizados',
      'Clear override': 'Limpiar personalización',
      'modifier': 'modificador',
      'modifiers': 'modificadores',
      'Add modifiers to customize this product': 'Agrega modificadores para personalizar este producto',
      'Add your first modifier': 'Agrega tu primer modificador',
      'No options added yet': 'Sin opciones agregadas aún',
      'Add first option': 'Agregar primera opción',
      'Set as default': 'Establecer como predeterminado',
      'What are modifiers?': '¿Qué son los modificadores?',
      'Modifiers allow customers to customize products with options like size, toppings, or extras.': 'Los modificadores permiten a los clientes personalizar productos con opciones como tamaño, ingredientes o extras.',
      'Customer must choose one option (e.g., Size: Small, Medium, or Large)': 'El cliente debe elegir una opción (ej: Tamaño: Pequeño, Mediano o Grande)',
      'Multiple values': 'Valores múltiples',
      'Customer can select multiple options (e.g., Toppings: Cheese, Bacon, Onions)': 'El cliente puede seleccionar múltiples opciones (ej: Ingredientes: Queso, Tocino, Cebolla)',
      'Customer must make a selection before adding to cart': 'El cliente debe hacer una selección antes de agregar al carrito',
      'Select table or client first': 'Selecciona mesa o cliente primero',
      'Select table or customer': 'Selecciona mesa o cliente',
      'Add options for customers to choose from (e.g., Small, Medium, Large)': 'Agrega opciones para que los clientes elijan (ej: Pequeño, Mediano, Grande)',
      'Tip: Use the menu button (⋮) in the header to add more options': 'Consejo: Usa el botón de menú (⋮) en el encabezado para agregar más opciones',

      // Product Creation Help
      'Add a new product to your catalog with inventory tracking': 'Agrega un nuevo producto a tu catálogo con seguimiento de inventario',
      'Recipe-based products use ingredients for inventory tracking. You can configure the recipe after creating the product.': 'Los productos basados en recetas usan ingredientes para el seguimiento del inventario. Puedes configurar la receta después de crear el producto.',
      'Getting Started': 'Primeros pasos',
      'Tips for creating your product': 'Consejos para crear tu producto',
      'Add a clear, descriptive product name': 'Agrega un nombre de producto claro y descriptivo',
      'Set accurate pricing for your target market': 'Establece precios precisos para tu mercado objetivo',
      'Choose the right inventory tracking method': 'Elige el método de seguimiento de inventario adecuado',
      'You can add photos and categories after creating the product': 'Puedes agregar fotos y categorías después de crear el producto',

      // Product Import Translations
      'Import Products': 'Importar Productos',
      'Bulk upload products from CSV file': 'Carga masiva de productos desde archivo CSV',
      'Download CSV Template': 'Descargar Plantilla CSV',
      'Step 1: Download Template': 'Paso 1: Descargar Plantilla',
      'Download the CSV template to see the required format': 'Descarga la plantilla CSV para ver el formato requerido',
      'Step 2: Upload CSV File': 'Paso 2: Subir Archivo CSV',
      'Upload your CSV file with product data': 'Sube tu archivo CSV con datos de productos',
      'Choose CSV File': 'Elegir Archivo CSV',
      'Maximum file size: 1MB': 'Tamaño máximo de archivo: 1MB',
      'Step 3: Preview & Validate': 'Paso 3: Previsualizar y Validar',
      'Import Results': 'Resultados de Importación',
      'Import completed successfully': 'Importación completada exitosamente',
      'products created': 'productos creados',
      'products skipped': 'productos omitidos',
      'categories created': 'categorías creadas',
      'Row': 'Fila',
      'Title': 'Título',
      'Valid': 'Válido',
      'Invalid': 'Inválido',
      'Total rows': 'Total de filas',
      'CSV Format': 'Formato CSV',
      'Required Columns': 'Columnas Requeridas',
      'Product name (max 255 chars)': 'Nombre del producto (máx 255 caracteres)',
      'Price (format: 0.00)': 'Precio (formato: 0.00)',
      'Default Values': 'Valores Predeterminados',
      'Active: Yes': 'Activo: Sí',
      'Stock: 0': 'Stock: 0',
      'Inventory Type: Simple': 'Tipo de Inventario: Simple',
      'Important Notes': 'Notas Importantes',
      'Duplicate products (by name) will be skipped': 'Los productos duplicados (por nombre) serán omitidos',
      'Categories will be created automatically if they don\'t exist': 'Las categorías se crearán automáticamente si no existen',
      'All imported products are active by default': 'Todos los productos importados están activos por defecto',
      'Stock levels default to 0 and must be updated manually': 'Los niveles de stock son 0 por defecto y deben actualizarse manualmente',
      'Maximum 500 products per import recommended': 'Se recomienda un máximo de 500 productos por importación',
      'Title is required': 'El título es requerido',
      'Title too long (max 255 chars)': 'Título demasiado largo (máx 255 caracteres)',
      'Category is required': 'La categoría es requerida',
      'Valid price is required': 'Se requiere un precio válido',
      'Import completed: {created} created, {skipped} skipped': 'Importación completada: {created} creados, {skipped} omitidos',
      'Import failed': 'Importación fallida',
      'View Products': 'Ver Productos',

      'Edit Business': 'Editar Negocio',
      'POS Configuration': 'Configuración del POS',
      'Service Mode': 'Modo de Servicio',
      'Orders (Standard POS)': 'Órdenes (POS Estándar)',
      'Checks (Restaurant/KDS)': 'Cuentas (Restaurante/KDS)',
      'Select service mode': 'Selecciona modo de servicio',
      'Orders and Checks modes are mutually exclusive': 'Los modos de Órdenes y Cuentas son mutuamente excluyentes',
      'Enable Combos': 'Habilitar Combos',
      'Show combos feature in POS interface': 'Mostrar función de combos en interfaz POS',
      'Enable Custom Items': 'Habilitar Artículos Personalizados',
      'Show custom item button in POS interface': 'Mostrar botón de artículo personalizado en interfaz POS',
      'Configure which features are enabled in your Point of Sale interface': 'Configura qué funciones están habilitadas en tu interfaz de Punto de Venta',
      'Optional Features': 'Funciones Opcionales',
      'System Configuration': 'Configuración del Sistema',
      'Configure system-wide settings for your Point of Sale': 'Configura ajustes generales del sistema para tu Punto de Venta',
      'POS Features': 'Funciones del POS',
      'Order Details': 'Detalles del Pedido',
      'Order History': 'Historial del Pedido',
      'Loading history...': 'Cargando historial...',
      'No history available': 'No hay historial disponible',
      'This order has not been modified yet': 'Este pedido aún no ha sido modificado',
      'Order Created': 'Pedido Creado',
      'Order Modified': 'Pedido Modificado',
      'Status Changed': 'Estado Cambiado',
      'Order Cancelled': 'Pedido Cancelado',
      'From': 'De',
      'To': 'A',
      'Total Change': 'Cambio Total',
      'Edits': 'Ediciones',
      'Retry': 'Reintentar',
      'Product Quantity Changes': 'Cambios en Cantidades de Productos',
      'for stock reconciliation': 'para reconciliación de inventario',
      'Recipe Ingredient Changes': 'Cambios en Ingredientes de Receta',
      'Ingredient Usage': 'Uso de Ingredientes',
      'used': 'usado',
      'restored': 'restaurado',
      'Warning: This order is approaching the edit limit. Only 1 edit(s) remaining.': 'Advertencia: Este pedido se está acercando al límite de ediciones. Solo queda(n) 1 edición(es).',
      'Order has reached the maximum number of edits (5). Contact an administrator.': 'El pedido ha alcanzado el número máximo de ediciones (5). Contacta a un administrador.',
      'Loading order information...': 'Cargando información del pedido...',
      'Loading order details...': 'Cargando detalles del pedido...',
      'Product Grid Layout': 'Diseño de Cuadrícula de Productos',
      'Product Testing': 'Pruebas de Productos',
      'Create a business': 'Crear un negocio',
      'JWT Test': 'Prueba JWT',
      'Manage your business information and settings': 'Gestiona la información y configuración de tu negocio',
      'Manage your products and inventory': 'Gestiona tus productos e inventario',
      'Create and manage product combinations': 'Crea y gestiona combinaciones de productos',
      'Manage combo options, groups and products': 'Gestiona opciones, grupos y productos de combos',

      // Combo Creation Wizard
      'Create a new combo with multiple products and options': 'Crea un nuevo combo con múltiples productos y opciones',
      'Essential combo details and pricing': 'Detalles esenciales del combo y precios',
      'Choose a descriptive name for your combo': 'Elige un nombre descriptivo para tu combo',
      'Set the total price for this combo': 'Establece el precio total para este combo',
      'Detailed description of what is included in this combo': 'Descripción detallada de lo que se incluye en este combo',
      'After Creation': 'Después de la creación',
      'What you can do after creating your combo': 'Qué puedes hacer después de crear tu combo',
      'Add Option Groups': 'Agregar grupos de opciones',
      'Create groups of selectable options for customization': 'Crea grupos de opciones seleccionables para personalización',
      'Include products from your catalog in each option group': 'Incluye productos de tu catálogo en cada grupo de opciones',
      'Configure Options': 'Configurar opciones',
      'Set default selections and price variations': 'Establece selecciones predeterminadas y variaciones de precio',
      'Tips for creating your combo': 'Consejos para crear tu combo',
      'Choose an attractive combo name that describes the value': 'Elige un nombre atractivo para el combo que describa el valor',
      'Set a competitive price that offers savings over individual items': 'Establece un precio competitivo que ofrezca ahorros sobre artículos individuales',
      'Add a clear description of what customers get': 'Agrega una descripción clara de lo que obtienen los clientes',
      'You will configure option groups and products after creation': 'Configurarás grupos de opciones y productos después de la creación',
      'Combo Benefits': 'Beneficios del combo',
      'Why combos are great for your business': 'Por qué los combos son geniales para tu negocio',
      'Increase average order value': 'Aumenta el valor promedio del pedido',
      'Offer customers convenient meal solutions': 'Ofrece a los clientes soluciones de comida convenientes',
      'Promote slower-moving inventory items': 'Promociona artículos de inventario de movimiento lento',
      'Organize products into categories': 'Organiza productos en categorías',
      'Track work shifts and employee hours': 'Rastrea turnos de trabajo y horas de empleados',
      'Manage user access and permissions': 'Gestiona acceso de usuarios y permisos',
      'Configure payment methods and settings': 'Configura métodos de pago y ajustes',
      'Create and manage discount rules': 'Crea y gestiona reglas de descuento',
      'Manage customer information and contacts': 'Gestiona información y contactos de clientes',
      'Surcharge percentage': 'Porcentaje de cargo extra',
      'Product added successfully': 'Producto añadido correctamente',
      'Products fetched successfully': 'Productos obtenidos correctamente',
      'Product sales': 'Ventas por producto',
      'Dashboard': 'Panel de control',
      'Point of sale': 'Punto de venta',
      'Order generated successfully': 'Pedido generado correctamente',

      // Navigation Groups
      'POS & Orders': 'POS y Pedidos',
      'Financial': 'Financiero',
      'Counter': 'Mostrador',
      'Restaurant': 'Restaurante',
      'Edit Order': 'Editar pedido',
      'Edit order': 'Editar pedido',
      'Examples: Size, Add-ons, Protein Type, Cooking Style': 'Ejemplos: Tamaño, Complementos, Tipo de Proteína, Estilo de Cocción',
      'Modifier Types': 'Tipos de Modificadores',
      'Variations': 'Variaciones',
      'Product choices included in price (Size, Protein)': 'Opciones de producto incluidas en el precio (Tamaño, Proteína)',
      'Add-ons': 'Complementos',
      'Optional extras that cost more (Extra Cheese, Premium ingredients)': 'Extras opcionales que cuestan más (Queso Extra, Ingredientes Premium)',
      'Enable for add-ons where customers can select multiple items': 'Habilitar para complementos donde los clientes pueden seleccionar múltiples artículos',
      'Force selection - typically true for variations, false for add-ons': 'Forzar selección - típicamente verdadero para variaciones, falso para complementos',
      'Examples: Small, Medium, Large, Extra Cheese, Bacon': 'Ejemplos: Pequeño, Mediano, Grande, Queso Extra, Tocino',
      'Pricing Guide': 'Guía de Precios',
      'Use 0.00 (included in base price)': 'Usar 0.00 (incluido en el precio base)',
      'Use actual price (e.g., 2.50 for extra cheese)': 'Usar precio real (ej., 2.50 para queso extra)',
      'Price Change': 'Cambio de Precio',
      'Use 0.00 for variations, actual price for add-ons (e.g., 2.50)': 'Usar 0.00 para variaciones, precio real para complementos (ej., 2.50)',
      'Product Sales (Total)': 'Ventas de Productos (Total)',
      'Direct Product Sales': 'Ventas de Productos Directos',
      'Combo Product Sales': 'Ventas de Productos en Combos',
      'Combo Sales Analysis': 'Análisis de Ventas de Combos',
      'Check Sales': 'Ventas por Cuenta',
      'In Combo': 'En combo',
      'Failed to fetch check product sales': 'Error al cargar ventas por cuenta',
      'Search product...': 'Buscar producto...',
      'Group by product': 'Agrupar por producto',
      'Total Sold': 'Total Vendido',
      'Standard': 'Estándar',
      'Customized': 'Personalizado',
      'Customization Rate': 'Tasa de Personalización',
      'Expand to customize': 'Expandir para personalizar',
      // Missing critical translations
      'Account created please check your email.': 'Cuenta creada, por favor revisa tu correo electrónico.',
      'Account created successfully! Please check your email to confirm your account before logging in.': '¡Cuenta creada exitosamente! Por favor revisa tu correo para confirmar tu cuenta antes de iniciar sesión.',
      'Confirming your email': 'Confirmando tu correo',
      'Please wait while we verify your email address': 'Por favor espera mientras verificamos tu dirección de correo',
      'Confirmation Failed': 'Confirmación Fallida',
      'Email Confirmed!': '¡Correo Confirmado!',
      'Redirecting to login': 'Redirigiendo al inicio de sesión',
      'Back to Login': 'Volver al Inicio de Sesión',
      'Processing invitation': 'Procesando invitación',
      'Please wait while we verify your invitation': 'Por favor espera mientras verificamos tu invitación',
      'The invitation link is invalid or has expired': 'El enlace de invitación es inválido o ha expirado',
      'Failed to process invitation': 'Error al procesar la invitación',
      'Invalid invitation link': 'Enlace de invitación inválido',
      'Failed to establish session': 'Error al establecer la sesión',
      'Invitation accepted successfully': 'Invitación aceptada exitosamente',
      'Invitation Failed': 'Invitación Fallida',
      'Invitation Accepted': 'Invitación Aceptada',
      'Redirecting to set your password': 'Redirigiendo para establecer tu contraseña',
      'Go to Login': 'Ir al Inicio de Sesión',
      'Business ID is not available.': 'El ID del negocio no está disponible.',
      'Combo could not be created.': 'No se pudo crear el combo.',
      'Combo has been created successfully.': 'El combo se ha creado exitosamente.',
      'Combo option group removed successfully': 'Grupo de opciones de combo eliminado exitosamente',
      'Combo updated correctly': 'Combo actualizado correctamente',
      'Customer delete canceled': 'Eliminación de cliente cancelada',
      'Customer delete failed': 'Error al eliminar cliente',
      'Create a business first in the business details page': 'Crea un negocio primero en la página de detalles del negocio',
      'Expense ID is required': 'Se requiere ID del gasto',
      'Failed to fetch shift in progress': 'Error al obtener turno en progreso',
      'Failed to update product': 'Error al actualizar producto',
      'Price updated': 'Precio actualizado',
      'Inventory type updated': 'Tipo de inventario actualizado',
      'Product status updated': 'Estado del producto actualizado',
      'One time code sent please check your email, now you are being redirected': 'Código de una vez enviado, por favor revisa tu correo electrónico, ahora estás siendo redirigido',
      'Please check your email for the magic link': 'Por favor revisa tu correo electrónico para el enlace mágico',
      'Record deleted successfully': 'Registro eliminado exitosamente',
      'User could not be saved': 'No se pudo guardar el usuario',
      'Validation failed. Please check the entered details and try again.': 'Validación fallida. Por favor revisa los detalles ingresados e intenta nuevamente.',
      'You have been authenticated': 'Has sido autenticado',
      // High priority business logic translations
      // Medium priority status messages
      'Product created successfully': 'Producto creado exitosamente',
      'Product updated successfully': 'Producto actualizado exitosamente',
      'Product updated successfully!': 'Producto actualizado exitosamente!',
      'Photo removed successfully': 'Foto eliminada exitosamente',
      'Drop image here': 'Suelta la imagen aquí',
      'Photo uploaded successfully': 'Foto subida exitosamente',
      'Modifier has been deleted successfully': 'El modificador se ha eliminado exitosamente',
      'Modifier option has been updated successfully': 'La opción de modificador se ha actualizado exitosamente',
      'The product modifier was successfully added': 'El modificador de producto se añadió exitosamente',
      'The product modifier was successfully updated': 'El modificador de producto se actualizó exitosamente',
      'Updated option set as default': 'Opción actualizada establecida como predeterminada',
      'Unable to delete modifier. Please try again': 'No se pudo eliminar el modificador. Por favor intenta nuevamente',
      'Product removed successfully': 'Producto eliminado exitosamente',
      'Extra added successfully': 'Extra añadido exitosamente',
      'Extra deleted successfully': 'Extra eliminado exitosamente',
      'Combo options added successfully': 'Opciones de combo añadidas exitosamente',
      'Combo updated successfully!': 'Combo actualizado exitosamente!',
      'Custom combo updated successfully!': 'Combo personalizado actualizado exitosamente!',
      'Order updated successfully': 'Pedido actualizado exitosamente',
      'Connected to': 'Conectado a',
      'Deleted successfully': 'Eliminado exitosamente',
      'This combo is not available for editing.': 'Este combo no está disponible para edición.',
      // Status and display keys
      'DD tt': 'DD tt',
      'Error processing order': 'Error al procesar pedido',
      'Failed to fetch combo analysis': 'Error al obtener análisis de combo',
      'Failed to fetch combo product sales': 'Error al obtener ventas de productos de combo',
      'Failed to fetch direct product sales': 'Error al obtener ventas directas de productos',
      'Failed to fetch sales by inventory': 'Error al obtener ventas por inventario',
      'Failed to fetch sales by payment.': 'Error al obtener ventas por pago.',
      'is default': 'es por defecto',
      'is default modifier': 'es modificador por defecto',
      'Missing data': 'Datos faltantes',
      'N/A': 'N/A',
      'Open shift failedl': 'Error al abrir turno',
      'Product not found in cart': 'Producto no encontrado en el carrito',
      'Combo not found in cart': 'Combo no encontrado en el carrito',
      'Table': 'Mesa',
      'Toast': 'Notificación',
      'Invalid date': 'Fecha inválida',
      'Validation error': 'Error de validación',
      'Edit option': 'Editar opción',
      'Option deleted': 'Opción eliminada',
      'Payment removal canceled': 'Eliminación de pago cancelada',
      'Error authenticating the user': 'Error al autenticar al usuario',
      'Error closing shift': 'Error al cerrar turno',
      'Error deleting category': 'Error al eliminar categoría',
      'Error fetching orders': 'Error al obtener pedidos',
      'Error getting combos': 'Error al obtener combos',
      'Failed to create modifier option': 'Error al crear opción de modificador',
      'Failed to create modifier. Please try again.': 'Error al crear modificador. Por favor intenta nuevamente.',
      'Failed to fetch business': 'Error al obtener negocio',
      'Failed to fetch sales by product': 'Error al obtener ventas por producto',
      'Failed to fetch users': 'Error al obtener usuarios',
      'Failed to update business': 'Error al actualizar negocio',
      'Failed to update modifier option': 'Error al actualizar opción de modificador',
      'Failed to update modifier. Please try again.': 'Error al actualizar modificador. Por favor intenta nuevamente.',
      'Failed to update product data': 'Error al actualizar datos del producto',
      'Examples': 'Ejemplos',
      'Start': 'Inicio',

      // Inventory Management Translations
      // Dashboard & Navigation
      'Inventory Overview': 'Resumen de Inventario',
      'View full inventory': 'Ver inventario completo',
      'All inventory levels are healthy': 'Todos los niveles de inventario están saludables',
      'No inventory data available': 'No hay datos de inventario disponibles',
      'Low Stock Alerts': 'Alertas de Stock Bajo',
      'View all low stock items': 'Ver todos los artículos con stock bajo',
      'Low Stock Items': 'Artículos con Stock Bajo',

      // Product & Ingredient Management
      'Initial Stock': 'Stock Inicial',
      'Starting quantity in stock': 'Cantidad inicial en stock',
      // Ingredient Management
      'Ingredients Management': 'Gestión de Ingredientes',
      'Manage your recipe ingredients and stock levels': 'Gestiona los ingredientes de tus recetas y niveles de stock',
      'Create New Ingredient': 'Crear Nuevo Ingrediente',
      'Add a new ingredient for recipe-based products': 'Agregar un nuevo ingrediente para productos basados en recetas',
      'Back to Ingredients': 'Volver a Ingredientes',
      'Ingredient Name': 'Nombre del Ingrediente',
      'Enter the name of the ingredient': 'Ingresa el nombre del ingrediente',
      'Cost per Unit': 'Costo por Unidad',
      'Cost of one unit (optional)': 'Costo de una unidad (opcional)',
      'Reorder Point': 'Punto de Reorden',
      'Alert when stock falls below this level': 'Alerta cuando el stock caiga por debajo de este nivel',
      'Supplier Information': 'Información del Proveedor',
      'Supplier Name': 'Nombre del Proveedor',
      'Name of the supplier (optional)': 'Nombre del proveedor (opcional)',
      'Contact Person': 'Persona de Contacto',
      'Main contact at supplier': 'Contacto principal en el proveedor',
      'Email Address': 'Dirección de Email',
      'Supplier email address': 'Dirección de email del proveedor',
      'Phone Number': 'Número de Teléfono',
      'Supplier phone number': 'Número de teléfono del proveedor',
      'Supplier Notes': 'Notas del Proveedor',
      'Additional notes about this supplier': 'Notas adicionales sobre este proveedor',
      'Active Ingredient': 'Ingrediente Activo',
      'If active, this ingredient can be used in recipes': 'Si está activo, este ingrediente puede usarse en recetas',
      'Create Ingredient': 'Crear Ingrediente',
      'Save Ingredient': 'Guardar Ingrediente',
      'Add Ingredient': 'Agregar Ingrediente',
      'Search ingredients...': 'Buscar ingredientes...',
      'No ingredients found': 'No se encontraron ingredientes',
      'Edit ingredient': 'Editar ingrediente',
      'Delete ingredient': 'Eliminar ingrediente',
      'Are you sure you want to delete this ingredient?': '¿Estás seguro de que quieres eliminar este ingrediente?',
      'Ingredient created successfully': 'Ingrediente creado exitosamente',
      'Ingredient updated successfully': 'Ingrediente actualizado exitosamente',
      'Ingredient deleted successfully': 'Ingrediente eliminado exitosamente',
      'Failed to load ingredients': 'Error al cargar ingredientes',
      'Failed to load ingredient data': 'Error al cargar datos del ingrediente',
      'Failed to delete ingredient': 'Error al eliminar ingrediente',
      'Please check the form for errors': 'Por favor revisa el formulario en busca de errores',

      // Modifier Inventory Config
      'Inventory deductions for': 'Descuentos de inventario para',
      'No inventory deductions configured': 'Sin descuentos de inventario configurados',
      'Configure inventory deductions': 'Configurar descuentos de inventario',
      'Deduction added': 'Descuento agregado',
      'Deduction removed': 'Descuento eliminado',
      'Failed to load modifier inventory': 'Error al cargar el inventario del modificador',
      'Failed to add deduction': 'Error al agregar descuento',
      'Failed to remove deduction': 'Error al eliminar descuento',
      'Select an ingredient': 'Selecciona un ingrediente',
      'Select a stock item': 'Selecciona un producto de almacén',
      'New ingredient': 'Nuevo ingrediente',
      'New stock item': 'Nuevo producto de almacén',
      'Explore ingredients': 'Explorar ingredientes',
      'Explore stock items': 'Explorar productos de almacén',

      // Recipe — stock item support
      'No stock items available': 'No hay productos de almacén disponibles',
      'Manage Stock Items': 'Gestionar Productos de Almacén',
      'Stock Item': 'Producto de Almacén',

      // Stock Items Management
      'Stock Items': 'Productos de Almacén',
      'Manage warehouse stock items used in modifier inventory': 'Gestiona los productos de almacén usados en el inventario de modificadores',
      'Add Stock Item': 'Agregar Producto de Almacén',
      'Create Stock Item': 'Crear Producto de Almacén',
      'Edit Stock Item': 'Editar Producto de Almacén',
      'Item Name': 'Nombre del Producto',
      'Enter the name of the stock item': 'Ingresa el nombre del producto de almacén',
      'No stock items found': 'No se encontraron productos de almacén',
      'Edit stock item': 'Editar producto de almacén',
      'Delete stock item': 'Eliminar producto de almacén',
      'Do you want to delete this stock item permanently?': '¿Deseas eliminar este producto de almacén permanentemente?',
      'Delete Stock Item': 'Eliminar Producto de Almacén',
      'Stock item created successfully': 'Producto de almacén creado exitosamente',
      'Stock item updated successfully': 'Producto de almacén actualizado exitosamente',
      'Stock item deleted successfully': 'Producto de almacén eliminado exitosamente',
      'Failed to create stock item': 'Error al crear producto de almacén',
      'Failed to update stock item': 'Error al actualizar producto de almacén',
      'Failed to delete stock item': 'Error al eliminar producto de almacén',
      'Failed to load stock items': 'Error al cargar productos de almacén',
      'Cannot delete stock item with remaining stock. Current stock: {stock} {unit}': 'No se puede eliminar el producto con stock restante. Stock actual: {stock} {unit}',
      'Search stock items...': 'Buscar productos de almacén...',

      // Ingredient Edit & Stock Management
      'Edit Ingredient': 'Editar Ingrediente',
      'Manage ingredient details and stock levels': 'Gestionar detalles del ingrediente y niveles de stock',
      'Ingredient Details': 'Detalles del Ingrediente',
      'Stock Status': 'Estado del Stock',
      'Use stock adjustment to change this value': 'Usa el ajuste de stock para cambiar este valor',
      'Adjust Stock': 'Ajustar Stock',
      'Stock adjusted successfully': 'Stock ajustado exitosamente',
      'Reason for Adjustment': 'Razón para el Ajuste',
      'Explain why the stock is being adjusted': 'Explica por qué se está ajustando el stock',
      'New Stock Quantity': 'Nueva Cantidad de Stock',
      'Current stock': 'Stock actual',
      'Recent Movements': 'Movimientos Recientes',
      'No movements recorded yet': 'Aún no se han registrado movimientos',
      'Not set': 'No establecido',

      // Recipe Management
      'Recipe Management': 'Gestión de Recetas',
      'Define the ingredients required for this product': 'Define los ingredientes requeridos para este producto',
      'Back to Product': 'Volver al Producto',
      'Save Recipe': 'Guardar Receta',
      'Recipe Ingredients': 'Ingredientes de la Receta',
      'No ingredients added yet': 'Aún no se han agregado ingredientes',
      'Click "Add Ingredient" to start building your recipe': 'Haz clic en "Agregar Ingrediente" para comenzar a construir tu receta',
      'Quantity Needed': 'Cantidad Necesaria',
      'Unit': 'Unidad',
      'optional': 'opcional',
      'Any special notes for this ingredient...': 'Cualquier nota especial para este ingrediente...',
      'Product Information': 'Información del Producto',
      'Recipe Status': 'Estado de la Receta',
      'Has Recipe': 'Tiene Receta',
      'No Recipe': 'Sin Receta',
      'Recipe-Based': 'Basado en Recetas',
      'Simple': 'Simple',
      'Cost Analysis': 'Análisis de Costos',
      'Total Ingredients': 'Total de Ingredientes',
      'Recipe Tips': 'Consejos de Recetas',
      'Add all ingredients needed to make one unit of this product': 'Agrega todos los ingredientes necesarios para hacer una unidad de este producto',
      'Stock will be deducted from ingredients when this product is sold': 'El stock se deducirá de los ingredientes cuando se venda este producto',
      'Make sure ingredient stock levels are sufficient': 'Asegúrate de que los niveles de stock de ingredientes sean suficientes',
      'You can adjust ingredient stock from the ingredients page': 'Puedes ajustar el stock de ingredientes desde la página de ingredientes',
      'Select Ingredient': 'Seleccionar Ingrediente',
      'Choose an ingredient to add to this recipe:': 'Elige un ingrediente para agregar a esta receta:',
      'No ingredients available': 'No hay ingredientes disponibles',
      'Create First Ingredient': 'Crear Primer Ingrediente',
      'Stock': 'Stock',
      'Available': 'Disponible',
      'This ingredient is already in the recipe': 'Este ingrediente ya está en la receta',
      'Please add at least one ingredient to the recipe': 'Por favor agrega al menos un ingrediente a la receta',
      'Recipe saved successfully': 'Receta guardada exitosamente',
      'Failed to load recipe data': 'Error al cargar datos de la receta',
      'Insufficient stock': 'Stock insuficiente',
      'Insufficient stock for product {productName}. Available: {available}, Required: {required}': 'Stock insuficiente para el producto {productName}. Disponible: {available}, Requerido: {required}',
      'Low stock': 'Stock bajo',
      'Stock OK': 'Stock OK',
      'No stock yet': 'Sin stock aún',
      'Refresh': 'Actualizar',
      'Refresh ingredients list': 'Actualizar lista de ingredientes',
      'Stock Calculator': 'Calculadora de Stock',
      'Units to Make': 'Unidades a Hacer',
      'Can Make': 'Se Puede Hacer',
      'View Detailed Requirements': 'Ver Requerimientos Detallados',
      'Stock Requirements Calculator': 'Calculadora de Requerimientos de Stock',
      'Sufficient Stock': 'Stock Suficiente',
      'Max Units Possible': 'Máximo de Unidades Posibles',
      'Max Units from Stock': 'Máx. Unidades del Stock',
      'Shortage': 'Faltante',
      'Sufficient': 'Suficiente',
      'OK': 'OK',
      'Need More': 'Necesita Más',
      'Close': 'Cerrar',

      // Inventory Reports
      'Inventory Reports': 'Reportes de Inventario',
      'Overview of your inventory status and movements': 'Resumen del estado de tu inventario y movimientos',
      'Low Stock Report': 'Reporte de Stock Bajo',
      'Movement History': 'Historial de Movimientos',
      'Back to Reports': 'Volver a Reportes',
      'Stock Levels': 'Niveles de Stock',
      'Current stock levels for all products and ingredients': 'Niveles de stock actuales para todos los productos e ingredientes',
      'Filter by Type': 'Filtrar por Tipo',
      'All Items': 'Todos los Artículos',
      'Unit Value': 'Valor Unitario',
      'No items match your search criteria': 'No hay artículos que coincidan con tus criterios de búsqueda',
      'No stock data available': 'No hay datos de stock disponibles',
      'Export CSV': 'Exportar CSV',
      'Export XLS': 'Exportar XLS',
      'Export to CSV': 'Exportar a CSV',
      'Exporting...': 'Exportando...',
      'Sales data exported successfully': 'Datos de ventas exportados exitosamente',
      'Failed to export sales data': 'Error al exportar datos de ventas',
      'Search by name...': 'Buscar por nombre...',
      'Low': 'Bajo',
      'Start typing to search products and combos': 'Comienza a escribir para buscar productos y combos',
      'Searching for': 'Buscando',
      'Clear': 'Limpiar',
      'to close': 'para cerrar',
      'to clear search': 'para limpiar búsqueda',
      'Stock Status Overview': 'Resumen del Estado del Stock',
      'Total Products': 'Total de Productos',
      'With inventory tracking': 'Con seguimiento de inventario',
      'In your inventory': 'En tu inventario',
      'Current inventory worth': 'Valor actual del inventario',
      'Normal Stock': 'Stock Normal',
      'Critical Stock': 'Stock Crítico',
      'Items that need attention due to low stock levels': 'Artículos que necesitan atención debido a niveles de stock bajo',
      'Total Items': 'Total de Artículos',
      'All Types': 'Todos los Tipos',
      'Filter by type': 'Filtrar por tipo',
      'Item': 'Artículo',
      'Edit item': 'Editar artículo',
      'Adjust stock': 'Ajustar stock',
      'No low stock items found': 'No se encontraron artículos con stock bajo',
      'Failed to load low stock report': 'Error al cargar reporte de stock bajo',
      'Failed to load inventory reports': 'Error al cargar reportes de inventario',

      // Movement History & Analytics
      'Complete history of all inventory movements': 'Historial completo de todos los movimientos de inventario',
      'Total Movements': 'Total de Movimientos',
      'Stock Increases': 'Aumentos de Stock',
      'Stock Decreases': 'Disminuciones de Stock',
      'Latest Activity': 'Última Actividad',
      'Date & Time': 'Fecha y Hora',
      'Type': 'Tipo',
      'Stock After': 'Stock Después',
      'Reference': 'Referencia',
      'No movements found': 'No se encontraron movimientos',
      'No recent movements': 'Sin movimientos recientes',
      'View all movements': 'Ver todos los movimientos',
      'View All Movements': 'Ver Todos los Movimientos',
      'Failed to load movement history': 'Error al cargar historial de movimientos',

      // Product Labels & Status
      'Ingredient': 'Ingrediente',
      'Normal': 'Normal',
      'Critical': 'Crítico',
      'Reorder': 'Reordenar',
      // Stock Status (lowercase versions)
      'normal': 'Normal',
      'critical': 'Crítico',
      'low': 'Stock Bajo',
      'reorder': 'Reordenar',
      // Movement Types (lowercase versions)
      'cancellation': 'Cancelación',
      'value': 'valor',
      'Value': 'Valor',
      'Supplier': 'Proveedor',
      'Manage Products': 'Gestionar Productos',
      'Manage Ingredients': 'Gestionar Ingredientes',

      // POS Integration
      'Out of Stock': 'Sin Stock',

      // Stock Adjustment Dialog
      'Adjust Ingredient Stock': 'Ajustar Stock del Ingrediente',
      'Enter the new total stock quantity': 'Ingresa la nueva cantidad total de stock',
      'Optional reason for this adjustment': 'Razón opcional para este ajuste',
      'Current': 'Actual',
      'Adjust': 'Ajustar',

      // Recipe Store Success Messages
      'Recipe updated successfully': 'Receta actualizada exitosamente',
      'Ingredient added to recipe': 'Ingrediente agregado a la receta',
      'Ingredient removed from recipe': 'Ingrediente eliminado de la receta',
      'Recipe ingredient updated': 'Ingrediente de receta actualizado',
      'Adjusted from recipe page': 'Ajustado desde la página de recetas',

      // Recipe Store Error Messages
      'Failed to load recipe': 'Error al cargar la receta',
      'Failed to save recipe': 'Error al guardar la receta',
      'Failed to add ingredient': 'Error al agregar ingrediente',
      'Failed to remove ingredient': 'Error al eliminar ingrediente',
      'Failed to update recipe ingredient': 'Error al actualizar ingrediente de receta',
      'Failed to adjust stock': 'Error al ajustar el stock',
      'Failed to refresh ingredients': 'Error al actualizar ingredientes',
      'Ingredient already exists in recipe': 'El ingrediente ya existe en la receta',
      // Ingredients Store Success Messages
      'Bulk stock adjustment completed': 'Ajuste masivo de stock completado',
      'Ingredients exported successfully': 'Ingredientes exportados exitosamente',

      // Ingredients Store Error Messages
      'Failed to create ingredient': 'Error al crear ingrediente',
      'Failed to update ingredient': 'Error al actualizar ingrediente',
      'Failed to complete bulk adjustment': 'Error al completar ajuste masivo',
      'Failed to export ingredients': 'Error al exportar ingredientes',

      // Inventory Store Success Messages
      'Stock movement logged': 'Movimiento de stock registrado',
      'Inventory updated successfully': 'Inventario actualizado exitosamente',
      'Bulk operation completed successfully': 'Operación masiva completada exitosamente',
      'Stock report generated successfully': 'Reporte de stock generado exitosamente',
      'Movement report generated successfully': 'Reporte de movimientos generado exitosamente',
      'Low stock alert resolved': 'Alerta de stock bajo resuelta',
      'Reorder reminder created': 'Recordatorio de reorden creado',

      // Inventory Store Error Messages
      'Failed to load inventory summary': 'Error al cargar resumen de inventario',
      'Failed to load low stock items': 'Error al cargar elementos con stock bajo',
      'Failed to load inventory movements': 'Error al cargar movimientos de inventario',
      'Failed to log stock movement': 'Error al registrar movimiento de stock',
      'Failed to complete bulk operation': 'Error al completar operación masiva',
      'Failed to generate stock report': 'Error al generar reporte de stock',
      'Failed to generate movement report': 'Error al generar reporte de movimientos',
      'Failed to resolve alert': 'Error al resolver alerta',
      'Failed to create reorder reminder': 'Error al crear recordatorio de reorden',

      // Confirmation Messages
      'Do you want to remove this ingredient from the recipe?': '¿Quieres eliminar este ingrediente de la receta?',
      'Do you want to delete this ingredient permanently?': '¿Quieres eliminar este ingrediente permanentemente?',
      'This action cannot be undone': 'Esta acción no se puede deshacer',
      'Remove from recipe': 'Eliminar de la receta',
      'Are you sure?': '¿Estás seguro?',
      'Delete Ingredient': 'Eliminar Ingrediente',

      // Dialog Headers
      'Add Ingredient to Recipe': 'Agregar Ingrediente a la Receta',
      'Remove Ingredient': 'Eliminar Ingrediente',
      'Edit Recipe': 'Editar Receta',
      'Stock Adjustment': 'Ajuste de Stock',
      'New Ingredient': 'Nuevo Ingrediente',

      // Stock Status
      'Reorder Required': 'Reorden Requerida',
      'Low Stock': 'Stock Bajo',
      'Stock adjustment': 'Ajuste de stock',

      // Movement Types
      'Cancellation': 'Cancelación',

      // General Terms
      'Cost': 'Costo',
      'Insufficient': 'Insuficiente',
      'Inactive': 'Inactivo',
      'Search': 'Buscar',
      'Filter': 'Filtrar',
      'Export': 'Exportar',
      'Import': 'Importar',
      'Bulk': 'Masivo',
      'Report': 'Reporte',
      'Summary': 'Resumen',
      'Details': 'Detalles',
      'History': 'Historial',
      'Movements': 'Movimientos',
      'Alerts': 'Alertas',
      'Notifications': 'Notificaciones',
      'Ingredients': 'Ingredientes',
      'Product Name': 'Nombre del Producto',
      'Total Cost': 'Costo Total',
      'Clear Filters': 'Limpiar Filtros', // Added this
      'All Stock': 'Todo el Stock',
      'Active Only': 'Solo Activo',
      'Show All': 'Mostrar Todo',
      'Low Stock Only': 'Solo Bajo Stock',
      'In Stock': 'En Stock',
      'Stock Valude': 'Valor de Stock',
      'Last Updated': 'Ultima Actualizacion',
      'Simple Stock': 'Stock Simple',
      'No Inventory': 'Sin Inventario',
      'None': 'Ninguno',
      'tracking': 'seguimiento',
      'net': 'red',
      'No tracking': 'Sin seguimiento',
      'Recipe': 'Receta',
      'Recipe-based': 'Basado en receta',
      'Recipes': 'Recetas',
      'Showing {first} to {last} of {totalRecords} recipes': 'Mostrando {first} a {last} de {totalRecords} recetas',
      'Profit Margin': 'Margen de Beneficio',
      'Loading recipes...': 'Cargando recetas...',
      'Manage all product recipes and their ingredients': 'Gestionar todas las recetas de productos y sus ingredientes',
      'Create Product': 'Crear Producto',
      'View/Edit Recipe': 'Ver/Editar Receta',
      'Export Stock Report': 'Exportar Reporte de Inventario',
      'Export Movement Report': 'Exportar Reporte de Movimientos',
      'Total Value': 'Valor Total',
      'Mark as resolved': 'Marcar como resuelto',
      'Create reorder reminder': 'Crear recordatorio de reorden',
      'All Status': 'Todos los Estados',
      'Simple Stock Management': 'Gestión Simple de Inventario',
      'Manage products with direct stock tracking': 'Gestionar productos con seguimiento directo de inventario',
      'Recipe Stock': 'Inventario de Recetas',
      'Bulk Stock Operation': 'Operación de Inventario en Lote',
      'Add Product': 'Agregar Producto',
      'All': 'Todos',
      'Filter by Status': 'Filtrar por Estado',
      'No simple stock products found': 'No se encontraron productos de inventario simple',
      'Search products...': 'Buscar productos...',
      'Stock Value': 'Valor de Inventario',
      'Production Capacity': 'Capacidad de Producción',
      'max units with current stock': 'unidades máximas con inventario actual',
      'Cannot produce any units': 'No se pueden producir unidades',
      'Low production capacity': 'Capacidad de producción baja',
      'Good production capacity': 'Buena capacidad de producción',
      'Missing ingredients or insufficient stock': 'Ingredientes faltantes o inventario insuficiente',
      'Consider restocking ingredients': 'Considera reabastecer ingredientes',

      // Customer Management Translations
      'Full Name': 'Nombre Completo',

      'State/Province': 'Estado/Provincia',
      'Additional Information': 'Información Adicional',
      'Any additional notes about this customer': 'Cualquier nota adicional sobre este cliente',
      'Create a new customer profile with contact and address information': 'Crear un nuevo perfil de cliente con información de contacto y dirección',
      'Update customer information and address details': 'Actualizar información del cliente y detalles de dirección',
      'Loading customer information...': 'Cargando información del cliente...',

      'View and manage customer information': 'Ver y gestionar información del cliente',
      'System Information': 'Información del Sistema',
      'Full Address': 'Dirección Completa',
      'No address provided': 'No se proporcionó dirección',
      'Customer Not Found': 'Cliente No Encontrado',
      'The requested customer could not be found.': 'El cliente solicitado no pudo ser encontrado.',
      'System': 'Sistema',
      // Store Translations - Inventory

      'Failed to load simple stock products': 'Error al cargar productos de inventario simple',
      'Failed to load ingredient stock products': 'Error al cargar productos de inventario de ingredientes',

      // Store Translations - Customers
      'Failed to load customers': 'Error al cargar clientes',
      'Validation errors: ': 'Errores de validación: ',
      'Failed to create customer: ': 'Error al crear cliente: ',
      'Failed to update customer: ': 'Error al actualizar cliente: ',
      'Do you want to delete this customer permanently?': '¿Quieres eliminar este cliente permanentemente?',
      'Customer deleted successfully': 'Cliente eliminado exitosamente',
      'Customers exported successfully': 'Clientes exportados exitosamente',
      'Failed to export customers': 'Error al exportar clientes',
      'Customers updated successfully': 'Clientes actualizados exitosamente',
      'Failed to update customers': 'Error al actualizar clientes',
      'Do you want to delete these customers permanently?': '¿Quieres eliminar estos clientes permanentemente?',
      'Delete Customers': 'Eliminar Clientes',
      'Customers deleted successfully': 'Clientes eliminados exitosamente',
      'Failed to delete customers': 'Error al eliminar clientes',
      'Order is being updated...': 'El pedido se está actualizando...',
      'You are editing existing order': 'Estás editando un pedido existente',
      'View original order': 'Ver pedido original',
      'Cancel Editing': 'Cancelar Edición',

      // Login Page Translations
      'Welcome back': 'Bienvenido de vuelta',
      'New to tapy.?': '¿Nuevo en tapy.?',
      'Current Language': 'Idioma Actual',
      'Switch Language': 'Cambiar Idioma',
      'language': 'Idioma',
      'selectLanguage': 'Seleccionar Idioma',
      'You have been authenticated, loading your business data...': 'Has sido autenticado, cargando los datos de tu negocio...',
      'Home': 'Inicio',
      'Features': 'Características',
      'Pricing': 'Precios',
      'Contact': 'Contacto',
      'tapy.': 'tapy.',
      'Contact us': 'Contáctanos',
      'Business Management': 'Gestión de Negocios',
      'Business Management Made Simple': 'Gestión de Negocios Simplificada',
      'Streamline your orders, inventory, and customer management with our all-in-one solution.': 'Optimiza tus pedidos, inventario y gestión de clientes con nuestra solución integral.',
      'Key Features': 'Características Principales',
      'Order Management': 'Gestión de Pedidos',
      'Inventory Tracking': 'Seguimiento de Inventario',
      'Customer Database': 'Base de Datos de Clientes',
      'Real-time Analytics': 'Análisis en Tiempo Real',
      'Failed to send magic link': 'Error al enviar enlace mágico',
      'Invalid email or password': 'Correo electrónico o contraseña inválidos',
      'Failed to login': 'Error al iniciar sesión',
      // Contact Form Translations
      'Contact Us': 'Contáctanos',
      'We\'d love to hear from you': 'Nos encantaría saber de ti',
      'Enter your full name': 'Ingresa tu nombre completo',
      'Please provide your full name': 'Por favor proporciona tu nombre completo',
      'Enter your phone number': 'Ingresa tu número de teléfono',
      'Optional - We may call you for urgent matters': 'Opcional - Podemos llamarte para asuntos urgentes',
      'Enter your email address': 'Ingresa tu dirección de correo electrónico',
      'Please provide a valid email address': 'Por favor proporciona una dirección de correo válida',
      'Message': 'Mensaje',
      'Tell us how we can help you...': 'Cuéntanos cómo podemos ayudarte...',
      'Please describe your inquiry or feedback': 'Por favor describe tu consulta o comentario',
      'Send Message': 'Enviar Mensaje',
      'Need immediate help?': '¿Necesitas ayuda inmediata?',
      'Call us directly': 'Llámanos directamente',
      'Thank you for your message! We will get back to you soon.': '¡Gracias por tu mensaje! Te responderemos pronto.',
      'Failed to send message. Please try again.': 'Error al enviar mensaje. Por favor intenta de nuevo.',
      'Contact Us - tapy.': 'Contáctanos - tapy.',
      'Get in touch with the tapy. team. We are here to help with your restaurant management needs.': 'Ponte en contacto con el equipo de tapy. Estamos aquí para ayudarte con tus necesidades de gestión de restaurante.',

      // Thank You Page Translations
      'Thank You!': '¡Gracias!',
      'Message Sent Successfully': 'Mensaje Enviado Exitosamente',
      'Message Received': 'Mensaje Recibido',
      'We\'ve received your message and will get back to you within 24 hours. Our team is excited to help with your restaurant management needs.': 'Hemos recibido tu mensaje y te responderemos dentro de 24 horas. Nuestro equipo está emocionado de ayudarte con tus necesidades de gestión de restaurante.',
      'Back to Contact': 'Volver a Contacto',
      'Go to Homepage': 'Ir al Inicio',
      'What happens next?': '¿Qué pasa después?',
      'Our team will review your message': 'Nuestro equipo revisará tu mensaje',
      'We\'ll respond within 24 hours': 'Responderemos dentro de 24 horas',
      'Check your email for our response': 'Revisa tu correo para nuestra respuesta',
      'Thank you for contacting tapy.. We have received your message and will get back to you soon.': 'Gracias por contactar a tapy. Hemos recibido tu mensaje y te responderemos pronto.',
      'Back to Panel': 'Volver al Panel',

      // Marketing Page Translations
      'Streamline your restaurant operations with tapy.. Manage orders, track inventory, and build customer relationships with our all-in-one restaurant management solution designed specifically for food service businesses.': 'Optimiza las operaciones de tu restaurante con tapy. Gestiona pedidos, rastrea inventario y construye relaciones con clientes con nuestra solución integral de gestión diseñada específicamente para negocios de servicios alimentarios.',
      'Get Started': 'Comenzar',
      'Learn More': 'Saber Más',
      'Smart Order Management': 'Gestión Inteligente de Pedidos',
      'Handle dine-in, takeout, and delivery orders seamlessly with our intuitive interface': 'Maneja pedidos para comer en el lugar, para llevar y entregas sin problemas con nuestra interfaz intuitiva',
      'Real-Time Inventory Tracking': 'Seguimiento de Inventario en Tiempo Real',
      'Monitor ingredient levels, set automatic reorder points, and never run out of key items': 'Monitorea niveles de ingredientes, establece puntos de reorden automático y nunca te quedes sin artículos clave',
      'Customer Relationship Management': 'Gestión de Relaciones con Clientes',
      'Build lasting relationships with detailed customer profiles and order history': 'Construye relaciones duraderas con perfiles detallados de clientes e historial de pedidos',
      'Choose Your Plan': 'Elige Tu Plan',
      'Flexible pricing for restaurants of all sizes': 'Precios flexibles para restaurantes de todos los tamaños',
      'Start with our free trial and scale as your business grows.': 'Comienza con nuestra prueba gratuita y escala mientras tu negocio crece.',
      'Ready to Transform Your Restaurant?': '¿Listo para Transformar tu Restaurante?',
      'Our team is ready to help you streamline your restaurant operations.': 'Nuestro equipo está listo para ayudarte a optimizar las operaciones de tu restaurante.',
      'Get in Touch': 'Ponte en Contacto',
      'Navigate to home section': 'Navegar a la sección de inicio',
      'Navigate to features section': 'Navegar a la sección de características',
      'Navigate to pricing section': 'Navegar a la sección de precios',
      'Navigate to contact section': 'Navegar a la sección de contacto',
      'Businesses': 'Negocios',
      'Navigate to businesses section': 'Navegar a la sección de negocios',
      'A POS for every business': 'Un punto de venta para cada negocio',
      'Restaurants': 'Restaurantes',
      'Ice cream shops': 'Heladerías',
      'Coffee shops': 'Cafeterías',
      'Hair salons': 'Peluquerías',
      'Flower shops': 'Florerías',
      'Manage orders and tables for your restaurant': 'Administra pedidos y mesas de tu restaurante',
      'Control your ice cream and popsicle inventory': 'Controla tu inventario de helados y paletas',
      'Track your coffee and beverage sales': 'Lleva el control de ventas de café y bebidas',
      'Schedule appointments and manage clients': 'Agenda citas y administra tus clientes',
      'Manage orders and flower arrangements': 'Administra pedidos y arreglos florales',
      'Learn more': 'Ver más',
      'Coming soon': 'Próximamente',
      'Main navigation menu': 'Menú de navegación principal',
      'Open navigation menu': 'Abrir menú de navegación',
      'Close navigation menu': 'Cerrar menú de navegación',
      'Go to login page': 'Ir a la página de inicio de sesión',
      'Go to contact page': 'Ir a la página de contacto',

      // Marketing Page Content
      // Hero Section
      '#1 Business Management Solution': 'Solución #1 de Gestión de Negocios',
      'Restaurant Management': 'Gestión de Restaurantes',
      'Made Simple': 'Simplificada',
      'Streamline your business operations with {brand}. Manage sales, track inventory, and print tickets from a tablet with our {solution} designed for any type of business.': 'Simplifica las operaciones de tu negocio con {brand}. Cobra, controla tu inventario e imprime tickets desde una tablet con nuestra {solution} diseñada para cualquier tipo de negocio.',
      'all-in-one solution': 'solución integral',
      'Start Free Trial': 'Iniciar Prueba Gratuita',
      'Watch Demo': 'Ver Demostración',
      'Write to us': 'Escríbenos',
      'Uptime': 'Tiempo Activo',
      'Support': 'Soporte',

      // Features Section
      'Why Choose {brand}?': '¿Por qué elegir {brand}?',
      'Discover the powerful features that make restaurant management effortless': 'Descubre las características poderosas que hacen que la gestión de restaurantes sea sin esfuerzo',
      'Handle dine-in, takeout, and delivery orders seamlessly with our intuitive interface. Track order status in real-time and ensure customer satisfaction.': 'Maneja pedidos para comer en el lugar, para llevar y entregas sin problemas con nuestra interfaz intuitiva. Rastrea el estado de los pedidos en tiempo real y asegura la satisfacción del cliente.',
      'Monitor ingredient levels, set automatic reorder points, and never run out of key items. Reduce waste and optimize your supply chain effortlessly.': 'Monitorea niveles de ingredientes, establece puntos de reorden automático y nunca te quedes sin artículos clave. Reduce desperdicios y optimiza tu cadena de suministro sin esfuerzo.',
      'Build lasting relationships with detailed customer profiles and order history. Personalize experiences and increase customer loyalty.': 'Construye relaciones duraderas con perfiles detallados de clientes e historial de pedidos. Personaliza experiencias e incrementa la lealtad del cliente.',

      // Features Section 2
      'Complete Business Management': 'Gestión Completa del Negocio',
      'Everything you need to run your restaurant efficiently and profitably': 'Todo lo que necesitas para manejar tu restaurante de manera eficiente y rentable',
      'Business Management Interface': 'Interfaz de Gestión de Negocio',
      'Product Management': 'Gestión de Productos',
      'Complete product catalog with categories, pricing, and inventory. Support for variations, modifiers, and menu customization.': 'Catálogo completo de productos con categorías, precios e inventario. Soporte para variaciones, modificadores y personalización de menú.',
      'Financial Management': 'Gestión Financiera',
      'Sales reporting and analytics, revenue tracking by period, payment processing, and comprehensive financial performance insights.': 'Informes de ventas y análisis, seguimiento de ingresos por período, procesamiento de pagos e información integral del rendimiento financiero.',
      'Business Configuration': 'Configuración del Negocio',
      'Restaurant settings and preferences, tax configuration, pricing rules, business hours, and customizable workflows.': 'Configuraciones y preferencias del restaurante, configuración de impuestos, reglas de precios, horarios comerciales y flujos de trabajo personalizables.',

      // Features Section 3
      'Advanced Operations & Insights': 'Operaciones Avanzadas e Información',
      'Powerful tools to manage your team, analyze performance, and stay informed': 'Herramientas poderosas para gestionar tu equipo, analizar rendimiento y mantenerte informado',
      'Analytics and Management Interface': 'Interfaz de Análisis y Gestión',
      'User & Staff Management': 'Gestión de Usuarios y Personal',
      'Multi-user access with role-based permissions, staff scheduling, user authentication, and team collaboration tools.': 'Acceso multiusuario con permisos basados en roles, programación de personal, autenticación de usuarios y herramientas de colaboración en equipo.',
      'Analytics & Reporting': 'Análisis e Informes',
      'Sales performance dashboards, customer insights and trends, inventory reports, and business intelligence forecasting.': 'Tableros de rendimiento de ventas, información e tendencias de clientes, informes de inventario y pronósticos de inteligencia empresarial.',
      'Smart Notifications': 'Notificaciones Inteligentes',
      'Real-time alerts and updates, system notifications for important events, and automated reminders to keep you informed.': 'Alertas y actualizaciones en tiempo real, notificaciones del sistema para eventos importantes y recordatorios automatizados para mantenerte informado.',

      // Contact Section
      'Ready to Get Started?': '¿Listo para Comenzar?',
      'Transform Your Restaurant': 'Transforma tu Restaurante',
      'Starting Today': 'Comenzando Hoy',
      'Join hundreds of restaurants already using {brand} to streamline their operations and increase profitability.': 'Únete a cientos de restaurantes que ya usan {brand} para optimizar sus operaciones e incrementar la rentabilidad.',
      'Schedule Demo': 'Agendar Demostración',
      'Email Support': 'Soporte por Email',
      'Get answers to your questions within 24 hours': 'Obtén respuestas a tus preguntas dentro de 24 horas',
      'Phone Support': 'Soporte Telefónico',
      'Speak with our experts Monday - Friday, 9 AM - 6 PM PST': 'Habla con nuestros expertos lunes - viernes, 9 AM - 6 PM PST',
      'Live Demo': 'Demostración en Vivo',
      'See {brand} in action with a personalized demonstration': 'Ve {brand} en acción con una demostración personalizada',
      'Book Demo': 'Reservar Demostración',
      'Trusted by restaurants worldwide': 'Confiado por restaurantes en todo el mundo',
      'Restaurant Management Interface': 'Interfaz de Gestión de Restaurantes',

      // Pricing Section
      'Simple, Transparent Pricing': 'Precios Simples y Transparentes',
      'Choose Your {plan}': 'Elige tu {plan}',
      'Perfect Plan': 'Plan Perfecto',
      'Flexible pricing for restaurants of all sizes. Start with our free trial and scale as your business grows.': 'Precios flexibles para restaurantes de todos los tamaños. Comienza con nuestra prueba gratuita y escala conforme crece tu negocio.',
      'Monthly': 'Mensual',
      'Annual': 'Anual',
      'Save 20%': 'Ahorra 20%',
      'Starter': 'Inicial',
      'Perfect for small cafes and food trucks': 'Perfecto para pequeños cafés y food trucks',
      '14-day free trial': '14 días de prueba gratuita',
      'Up to 100 menu items': 'Hasta 100 elementos del menú',
      'Basic order management': 'Gestión básica de pedidos',
      'Customer database': 'Base de datos de clientes',
      'Email support': 'Soporte por email',
      'Most Popular': 'Más Popular',
      'Professional': 'Profesional',
      'Ideal for full-service restaurants': 'Ideal para restaurantes de servicio completo',
      'Everything in Starter': 'Todo lo del plan Inicial',
      'Unlimited menu items': 'Elementos del menú ilimitados',
      'Advanced inventory management': 'Gestión avanzada de inventario',
      'Sales analytics & reports': 'Análisis de ventas e informes',
      'Priority support': 'Soporte prioritario',
      'Enterprise': 'Empresarial',
      'For restaurant chains and franchises': 'Para cadenas de restaurantes y franquicias',
      'Tailored to your needs': 'Adaptado a tus necesidades',
      'Everything in Professional': 'Todo lo del plan Profesional',
      'Advanced reporting & analytics': 'Reportes y análisis avanzados',
      'Custom integrations': 'Integraciones personalizadas',
      'Dedicated account manager': 'Gerente de cuenta dedicado',
      'White-label options': 'Opciones de marca blanca',
      'Contact Sales': 'Contactar Ventas',

      // Steps Section
      'Get Started in 3 Simple Steps': 'Comienza en 3 Pasos Simples',
      'Setting up your restaurant management system has never been easier. Follow these simple steps to transform your operations and start seeing results immediately.': 'Configurar tu sistema de gestión de restaurante nunca ha sido más fácil. Sigue estos simples pasos para transformar tus operaciones y comenzar a ver resultados inmediatamente.',
      'Sign Up for an Account': 'Crea una Cuenta',
      'Create a new account to access our restaurant management system and start managing your business efficiently.': 'Crea una nueva cuenta para acceder a nuestro sistema de gestión de restaurante y comenzar a administrar tu negocio eficientemente.',
      'Set Up Your Menu': 'Configura tu Menú',
      'Easily add and organize your menu items with images, descriptions, and prices to streamline your sales process.': 'Agrega y organiza fácilmente los elementos de tu menú con imágenes, descripciones y precios para optimizar tu proceso de ventas.',
      'Start Taking Orders': 'Comienza a Tomar Pedidos',
      'Use our intuitive interface to process orders, track inventory, and manage customer relationships seamlessly.': 'Usa nuestra interfaz intuitiva para procesar pedidos, rastrear inventario y gestionar relaciones con clientes sin problemas.',

      // Testimonials Section
      'What Our Customers Say': 'Lo que Dicen Nuestros Clientes',
      'Discover how restaurants worldwide are transforming their operations with {brand}.': 'Descubre cómo restaurantes en todo el mundo están transformando sus operaciones con {brand}.',
      'Maria Rodriguez': 'María Rodríguez',
      'Owner, La Mesa Restaurant': 'Propietaria, Restaurante La Mesa',
      'This software has revolutionized the way we manage our orders and inventory. It\'s user-friendly and has increased our efficiency tenfold.': 'Este software ha revolucionado la forma en que gestionamos nuestros pedidos e inventario. Es fácil de usar y ha aumentado nuestra eficiencia diez veces.',
      'James Chen': 'James Chen',
      'Manager, Fusion Bistro': 'Gerente, Fusion Bistro',
      'I highly recommend this restaurant management system to any business looking to streamline their operations. It\'s intuitive and has excellent customer support.': 'Recomiendo altamente este sistema de gestión de restaurante a cualquier negocio que busque optimizar sus operaciones. Es intuitivo y tiene excelente soporte al cliente.',
      'Sophie Laurent': 'Sophie Laurent',
      'Owner, Artisan Bakery': 'Propietaria, Panadería Artesanal',
      'Our sales have soared since implementing this system. It\'s easy to use and has all the features we need to run our bakery efficiently.': 'Nuestras ventas se han disparado desde que implementamos este sistema. Es fácil de usar y tiene todas las características que necesitamos para operar nuestra panadería eficientemente.',
      'Antonio Silva': 'Antonio Silva',
      'Owner, Urban Taphouse': 'Propietario, Urban Taphouse',
      'I can\'t imagine running my restaurant without this software. It has simplified our transactions and inventory management, saving us time and money.': 'No puedo imaginar operar mi restaurante sin este software. Ha simplificado nuestras transacciones y gestión de inventario, ahorrándonos tiempo y dinero.',

      // Features2 Section
      'Intuitive Interface': 'Interfaz Intuitiva',
      'Our restaurant management software offers a user-friendly interface that is easy to navigate, making order processing quick and efficient.': 'Nuestro software de gestión de restaurante ofrece una interfaz fácil de usar que es simple de navegar, haciendo el procesamiento de pedidos rápido y eficiente.',
      'Smart Inventory Management': 'Gestión Inteligente de Inventario',
      'Efficiently manage your inventory with our software, track stock levels, receive low stock alerts, and streamline ordering processes.': 'Gestiona eficientemente tu inventario con nuestro software, rastrea niveles de stock, recibe alertas de stock bajo y optimiza procesos de pedidos.',
      'Advanced Analytics': 'Análisis Avanzados',
      'Gain valuable insights into your business performance with detailed reports, track trends, and make informed decisions.': 'Obtén información valiosa sobre el rendimiento de tu negocio con reportes detallados, rastrea tendencias y toma decisiones informadas.',
      'Restaurant Management Dashboard': 'Panel de Gestión de Restaurante',

      // Footer Section
      'Subscribe to our newsletter for the latest updates on new features and product releases.': 'Suscríbete a nuestro boletín para las últimas actualizaciones sobre nuevas características y lanzamientos de productos.',
      'Enter your email': 'Ingresa tu email',
      'Subscribe to Newsletter': 'Suscribirse al Boletín',
      'Company': 'Empresa',
      'About Us': 'Acerca de Nosotros',
      'FAQs': 'Preguntas Frecuentes',
      'Blog': 'Blog',
      'Demo': 'Demostración',
      'Sign Up': 'Registrarse',
      'Follow Us': 'Síguenos',
      '© {year} {company}. All rights reserved.': '© {year} {company}. Todos los derechos reservados.',
      'Privacy Policy': 'Política de Privacidad',
      'Terms of Service': 'Términos de Servicio',
      'Cookie Policy': 'Política de Cookies',
      'Designed by {company}': 'Diseñado por {company}',
      '500+ Restaurants': '500+ Restaurantes',
      '99.9% Uptime': '99.9% Tiempo de Actividad',
      '24/7 Support': 'Soporte 24/7',
      'Choose Your Perfect Plan': 'Elige tu plan perfecto',

      // Product Photos Translations
      'Product Images': 'Imágenes del Producto',
      'Product Photos': 'Fotos del Producto',
      'Manage product photos to showcase your items': 'Gestiona fotos del producto para mostrar tus artículos',
      'Upload and manage product images with full-width gallery': 'Sube y gestiona imágenes del producto con galería de ancho completo',
      'No images uploaded yet': 'Aún no se han subido imágenes',
      'Processing': 'Procesando',
      'Upload product image': 'Subir imagen del producto',
      'Upload failed': 'Error al subir',
      'Failed to save photo': 'Error al guardar foto',
      'Are you sure you want to remove this photo?': '¿Estás seguro de que quieres eliminar esta foto?',
      'Failed to remove photo': 'Error al eliminar foto',
      'Product image': 'Imagen del producto',
      'View image': 'Ver imagen',
      'of': 'de',
      'Previous image': 'Imagen anterior',
      'Next image': 'Imagen siguiente',
      'Images reordered successfully': 'Imágenes reordenadas exitosamente',
      'Failed to reorder images': 'Error al reordenar imágenes',
      'Primary Image': 'Imagen Principal',
      'Upload Date': 'Fecha de Subida',

      // Offline PWA translations
      'You are offline': 'Estás sin conexión',
      'You are offline - showing cached data': 'Estás sin conexión - mostrando datos en caché',
      'Connection restored': 'Conexión restaurada',
      'Syncing...': 'Sincronizando...',
      'Sync Orders': 'Sincronizar Órdenes',
      'Please check your internet connection and try again': 'Por favor verifica tu conexión a internet e intenta de nuevo',
      'Available Offline Features': 'Funciones Disponibles Sin Conexión',
      'View cached products and menu': 'Ver productos y menú en caché',
      'Create orders (saved locally)': 'Crear órdenes (guardadas localmente)',
      'Review previous transactions': 'Revisar transacciones anteriores',
      'Orders will sync when reconnected': 'Las órdenes se sincronizarán al reconectarse',
      'Try Again': 'Intentar de Nuevo',
      'Go to Store': 'Ir a la Tienda',
      'Order saved offline. Will sync when reconnected.': 'Orden guardada sin conexión. Se sincronizará al reconectarse.',
      'Failed to save order offline': 'Error al guardar orden sin conexión',
      'Ready for Offline': 'Listo para Trabajo Sin Conexión',
      'Clear Cache': 'Limpiar Caché',
      'Compact': 'Compacto',
      'Expanded': 'Expandido',
      'Offline mode prepared successfully': 'Modo sin conexión preparado exitosamente',
      'Prepare Offline Mode': 'Preparar Modo Sin Conexión',

      // Expenses translations
      'Expenses': 'Gastos',
      'Daily Expenses': 'Gastos Diarios',
      'View and manage daily business expenses': 'Ver y gestionar gastos diarios del negocio',
      'Select Date': 'Seleccionar Fecha',
      'No expenses found for this date': 'No se encontraron gastos para esta fecha',
      'No expenses found for this period': 'No se encontraron gastos para este período',
      'Expense Type': 'Tipo de Gasto',
      'Edit expense': 'Editar gasto',
      'Cannot add expenses to closed shifts': 'No se pueden agregar gastos a turnos cerrados',

      // Expense Types Management
      'Expense Types': 'Tipos de Gastos',
      'Add expense type': 'Agregar tipo de gasto',
      'No expense types found': 'No se encontraron tipos de gastos',
      'Enter expense type name': 'Ingresa el nombre del tipo de gasto',
      'Optional description': 'Descripción opcional',
      'Inactive expense types are hidden from forms': 'Los tipos de gastos inactivos se ocultan de los formularios',
      'Create expense type': 'Crear tipo de gasto',
      'Update expense type': 'Actualizar tipo de gasto',
      'Failed to create expense type': 'Error al crear tipo de gasto',
      'Failed to update expense type': 'Error al actualizar tipo de gasto',
      'Missing required data': 'Faltan datos requeridos',
      'Please check the form data and try again': 'Por favor verifica los datos del formulario e intenta de nuevo',
      'Expense type created successfully': 'Tipo de gasto creado exitosamente',
      'Expense type updated successfully': 'Tipo de gasto actualizado exitosamente',
      'Expense type deleted successfully': 'Tipo de gasto eliminado exitosamente',
      'Cannot delete expense type that is in use': 'No se puede eliminar un tipo de gasto que está en uso',
      'Do you want to delete this expense type?': '¿Quieres eliminar este tipo de gasto?',
      'Confirmation': 'Confirmación',
      'Deactivate': 'Desactivar',
      'Activate': 'Activar',
      'Manage expense categories for your business': 'Administra las categorías de gastos para tu negocio',
      'Edit expense type': 'Editar tipo de gasto',
      'Add new expense type': 'Agregar nuevo tipo de gasto',
      'Parent expense type': 'Tipo de gasto padre',
      'None (top level)': 'Ninguno (nivel superior)',
      'Only two levels of expense types are allowed': 'Solo se permiten dos niveles de tipos de gasto',
      'Cannot delete a category that has subtypes': 'No se puede eliminar una categoría que tiene subtipos',
      'Adding subtypes makes this a category — it can no longer be chosen directly.': 'Agregar subtipos convierte esto en una categoría — ya no se puede elegir directamente.',
      'Updated': 'Actualizado',
      'Expense deleted successfully': 'Gasto eliminado exitosamente',
      'Failed to load expenses': 'Error al cargar gastos',

      // Fund Sources Management
      'Fund Sources': 'Orígenes de Fondos',
      'Cash source': 'Origen en efectivo',
      'Cash sources reduce the shift expected cash; card or transfer sources do not': 'Los orígenes en efectivo reducen el efectivo esperado del turno; los de tarjeta o transferencia no',
      'Fund source': 'Origen de fondos',
      'Fund source is required': 'El origen de fondos es obligatorio',
      'Search fund source...': 'Buscar origen de fondos...',
      'No source': 'Sin origen',
      'No fund sources found': 'No se encontraron orígenes de fondos',
      'Add fund source': 'Agregar origen de fondos',
      'Add new fund source': 'Agregar nuevo origen de fondos',
      'Edit fund source': 'Editar origen de fondos',
      'Create fund source': 'Crear origen de fondos',
      'Update fund source': 'Actualizar origen de fondos',
      'Enter fund source name': 'Ingresa el nombre del origen de fondos',
      'Inactive fund sources are hidden from forms': 'Los orígenes de fondos inactivos se ocultan de los formularios',
      'Manage where expense money is taken from': 'Administra de dónde se toma el dinero de los gastos',
      'Fund source created successfully': 'Origen de fondos creado exitosamente',
      'Fund source updated successfully': 'Origen de fondos actualizado exitosamente',
      'Fund source deleted successfully': 'Origen de fondos eliminado exitosamente',
      'Failed to load fund sources': 'Error al cargar los orígenes de fondos',
      'Failed to create fund source': 'Error al crear el origen de fondos',
      'Failed to update fund source': 'Error al actualizar el origen de fondos',
      'Failed to delete fund source': 'Error al eliminar el origen de fondos',
      'Cannot delete fund source that is in use': 'No se puede eliminar un origen de fondos que está en uso',
      'Do you want to delete this fund source?': '¿Deseas eliminar este origen de fondos?',

      // Dining Areas Translations
      'Dining Areas': 'Áreas de Comedor',
      'Manage restaurant dining areas and sections': 'Administra las áreas y secciones del restaurante',
      'Add dining area': 'Agregar área de comedor',
      'Edit dining area': 'Editar área de comedor',
      'Add new dining area': 'Agregar nueva área de comedor',
      'Display Order': 'Orden de Visualización',
      'No dining areas found': 'No se encontraron áreas de comedor',
      'Main Dining Room': 'Comedor Principal',
      'Optional description of the area': 'Descripción opcional del área',
      'Do you want to deactivate this dining area?': '¿Deseas desactivar esta área de comedor?',
      'Do you want to permanently delete this dining area? This will remove the area assignment from all associated tables.': '¿Deseas eliminar permanentemente esta área de comedor? Esto eliminará la asignación del área de todas las mesas asociadas.',
      'Dining area created successfully': 'Área de comedor creada exitosamente',
      'Dining area updated successfully': 'Área de comedor actualizada exitosamente',
      'Dining area activated successfully': 'Área de comedor activada exitosamente',
      'Dining area deleted successfully': 'Área de comedor eliminada exitosamente',
      'Dining area deactivated successfully': 'Área de comedor desactivada exitosamente',
      'Failed to activate dining area': 'Error al activar área de comedor',
      'Failed to load dining areas': 'Error al cargar áreas de comedor',
      'Failed to load dining area': 'Error al cargar área de comedor',
      'Failed to create dining area': 'Error al crear área de comedor',
      'Failed to update dining area': 'Error al actualizar área de comedor',
      'Failed to delete dining area': 'Error al eliminar área de comedor',
      'Failed to load dining area data': 'Error al cargar datos del área de comedor',
      // Tables Translations
      'Tables': 'Mesas',
      'Manage restaurant tables and seating': 'Administra las mesas y lugares del restaurante',
      'Add table': 'Agregar mesa',
      'Edit table': 'Editar mesa',
      'Add new table': 'Agregar nueva mesa',
      'Update table': 'Actualizar mesa',
      'Table Number': 'Número de Mesa',
      '1, A3, Booth 7': '1, A3, Cabina 7',
      'Capacity': 'Capacidad',
      'Sort Order': 'Orden',
      'Select dining area (optional)': 'Seleccionar área de comedor (opcional)',
      'No tables found': 'No se encontraron mesas',
      'Search tables...': 'Buscar mesas...',
      'No tables available': 'No hay mesas disponibles',
      'Unassigned': 'Sin asignar',
      'Occupied': 'Ocupada',
      'Reserved': 'Reservada',
      'Cleaning': 'Limpiando',
      'Do you want to deactivate this table?': '¿Deseas desactivar esta mesa?',
      'Do you want to permanently delete this table?': '¿Deseas eliminar permanentemente esta mesa?',
      'Table created successfully': 'Mesa creada exitosamente',
      'Table updated successfully': 'Mesa actualizada exitosamente',
      'Table activated successfully': 'Mesa activada exitosamente',
      'Table deleted successfully': 'Mesa eliminada exitosamente',
      'Table deactivated successfully': 'Mesa desactivada exitosamente',
      'Table status updated successfully': 'Estado de mesa actualizado exitosamente',
      'Failed to activate table': 'Error al activar mesa',
      'Failed to load tables': 'Error al cargar mesas',
      'Failed to load table': 'Error al cargar mesa',
      'Failed to create table': 'Error al crear mesa',
      'Failed to update table': 'Error al actualizar mesa',
      'Failed to delete table': 'Error al eliminar mesa',
      'Failed to update table status': 'Error al actualizar estado de mesa',
      'Failed to load table data': 'Error al cargar datos de la mesa',
      'Open new check for table {tableNumber}?': '¿Abrir nueva cuenta para {tableNumber}?',
      'Open Check': 'Abrir Cuenta',
      'Open New Check': 'Abrir Nueva Cuenta',
      'New Check': 'Nueva Cuenta',
      'Use {name} in new check': 'Usar {name} en nueva cuenta',
      '{name} already has an open check': '{name} ya tiene una cuenta abierta',
      'Open Orders': 'Ordenes Abiertas',
      'Search customer...': 'Buscar cliente...',
      'Walk-in': 'Sin cliente',
      'Order identifier...': 'Identificador de orden...',
      'Table not found': 'Mesa no encontrada',
      'Check closed successfully': 'Cuenta cerrada exitosamente',
      'Item status updated': 'Estado del artículo actualizado',
      'Failed to open check': 'Error al abrir cuenta',
      'Failed to close check': 'Error al cerrar cuenta',
      'Editing closed check': 'Editando cuenta cerrada',
      'changes will adjust inventory automatically': 'los cambios ajustarán el inventario automáticamente',
      'Label': 'Etiqueta',
      'Revisions': 'Revisiones',
      'Revision History': 'Historial de revisiones',
      'Audit trail of all edits made to this check': 'Auditoría de todos los cambios realizados en esta cuenta',
      'No revisions found': 'Sin revisiones',
      'This check has not been edited after closing.': 'Esta cuenta no ha sido editada después de cerrarse.',
      'Check snapshot before edit': 'Estado de la cuenta antes de la edición',
      'Original': 'Original',
      'Back to Checks': 'Volver a cuentas',
      'Current State': 'Estado actual',
      'Columns': 'Columnas',
      'guests': 'comensales',
      'Table {tableNumber} already has an open check': '{tableNumber} ya tiene una cuenta abierta',
      'Loaded check {checkNumber}': 'Cuenta {checkNumber} cargada',
      // Servers Translations
      'Servers': 'Meseros',
      'Manage restaurant servers and staff': 'Administra los meseros y personal del restaurante',
      'Add server': 'Agregar mesero',
      'Edit server': 'Editar mesero',
      'Add new server': 'Agregar nuevo mesero',
      'Update server': 'Actualizar mesero',
      'Employee Number': 'Número de Empleado',
      'PIN Code': 'Código PIN',
      '4-6 digit PIN': 'PIN de 4-6 dígitos',
      'PIN must be 4-6 digits': 'El PIN debe tener 4-6 dígitos',
      'PIN must contain only digits': 'El PIN debe contener solo dígitos',
      'Maria Garcia': 'Maria Garcia',
      'Handles To-Go Orders': 'Maneja Órdenes Para Llevar',
      'Handles Delivery Orders': 'Maneja Órdenes de Entrega',
      'No servers found': 'No se encontraron meseros',
      'Do you want to deactivate this server?': '¿Deseas desactivar este mesero?',
      'Do you want to permanently delete this server?': '¿Deseas eliminar permanentemente este mesero?',
      'Server created successfully': 'Mesero creado exitosamente',
      'Server updated successfully': 'Mesero actualizado exitosamente',
      'Server activated successfully': 'Mesero activado exitosamente',
      'Server deleted successfully': 'Mesero eliminado exitosamente',
      'Server deactivated successfully': 'Mesero desactivado exitosamente',
      'Failed to activate server': 'Error al activar mesero',
      'Failed to load servers': 'Error al cargar meseros',
      'Failed to load server': 'Error al cargar mesero',
      'Failed to create server': 'Error al crear mesero',
      'Failed to update server': 'Error al actualizar mesero',
      'Failed to delete server': 'Error al eliminar mesero',
      'Failed to load server data': 'Error al cargar datos del mesero',

      // Checks Translations
      'Checks': 'Cuentas',
      'Manage restaurant checks': 'Administrar cuentas del restaurante',
      'Add check': 'Agregar cuenta',
      'Edit check': 'Editar cuenta',
      'Add new check': 'Agregar nueva cuenta',
      'Update check': 'Actualizar cuenta',
      'Check Number': 'Número de Cuenta',
      'Check Type': 'Tipo de Cuenta',
      'Select check type': 'Selecciona tipo de cuenta',
      'Customer is optional. You can skip this step.': 'El cliente es opcional. Puedes omitir este paso.',
      'Customer name': 'Nombre del cliente',
      'Find Client': 'Buscar Cliente',
      'Dine In': 'Para Comer Aquí',
      'To-Go': 'Para Llevar',
      'Third Party': 'Terceros',
      'Open': 'Abierta',
      'Closed': 'Cerrada',
      'Cancelled': 'Cancelada',
      'Customer': 'Cliente',
      'Customer Name': 'Nombre del Cliente',
      'Customer Phone': 'Teléfono del Cliente',
      'Guests': 'Comensales',
      'Guest Count': 'Número de Comensales',
      'Kitchen': 'Cocina',
      'Opened At': 'Abierta En',
      'Closed At': 'Cerrada En',
      'Updated At': 'Actualizada En',
      'Filter By': 'Filtrar Por',
      'Filters applied': 'Filtros aplicados',
      'Clear all': 'Limpiar todo',
      'Select table': 'Seleccionar mesa',
      'Select server': 'Seleccionar mesero',
      'Optional notes': 'Notas opcionales',
      'No checks found': 'No se encontraron cuentas',
      'Do you want to permanently delete this check?': '¿Deseas eliminar permanentemente esta cuenta?',
      'Check created successfully': 'Cuenta creada exitosamente',
      'Check updated successfully': 'Cuenta actualizada exitosamente',
      'Check deleted successfully': 'Cuenta eliminada exitosamente',
      'Failed to load checks': 'Error al cargar cuentas',
      'Failed to load check': 'Error al cargar cuenta',
      'Failed to create check': 'Error al crear cuenta',
      'Failed to update check': 'Error al actualizar cuenta',
      'Failed to delete check': 'Error al eliminar cuenta',
      'Failed to load check data': 'Error al cargar datos de la cuenta',
      'Delete Check': 'Eliminar Cuenta',
      'Delete Order': 'Eliminar Pedido',
      'Do you want to delete this check? You can add a reason for the audit log.': '¿Deseas eliminar esta cuenta? Puedes agregar un motivo para el registro de auditoría.',
      'Do you want to delete this order? You can add a reason for the audit log.': '¿Deseas eliminar este pedido? Puedes agregar un motivo para el registro de auditoría.',
      'Are you sure you want to delete this item?': '¿Estás seguro de que deseas eliminar este elemento?',
      'Enter a reason for deletion...': 'Ingresa un motivo para la eliminación...',
      'Deleted Checks': 'Cuentas Eliminadas',
      'Audit log of soft-deleted checks': 'Registro de auditoría de cuentas eliminadas',
      'No deleted checks found': 'No se encontraron cuentas eliminadas',
      'Deleted By': 'Eliminado Por',
      'Delete Reason': 'Motivo de Eliminación',
      'Deleted At': 'Eliminado El',
      'Restore': 'Restaurar',
      'Check restored successfully': 'Cuenta restaurada exitosamente',
      'Failed to restore check': 'Error al restaurar cuenta',
      'Failed to load deleted checks': 'Error al cargar cuentas eliminadas',
      'checks.deleteSuccess': 'Cuenta eliminada exitosamente',
      'checks.deleteError': 'Error al eliminar cuenta',
      'checks.deleteOfflineError': 'No se puede eliminar la cuenta sin conexión',
      'checks.deleteAuthError': 'Inicia sesión para eliminar cuentas',
      'Deleted Orders': 'Pedidos Eliminados',
      'Audit log of soft-deleted orders': 'Registro de auditoría de pedidos eliminados',
      'No deleted orders found': 'No se encontraron pedidos eliminados',
      'Order restored successfully': 'Pedido restaurado exitosamente',
      'Failed to restore order': 'Error al restaurar pedido',
      'Failed to load deleted orders': 'Error al cargar pedidos eliminados',
      'pending': 'Pendiente',
      'preparing': 'Preparando',
      'ready': 'Listo',
      'served': 'Servido',
      'not_sent': 'No enviado',
      'sent_to_kitchen': 'Enviado a cocina',
      'canceled': 'Cancelado',
      'Send Email': 'Enviar Email',
      'Customer Email': 'Email del Cliente',
      'Send Receipt via Email': 'Enviar Recibo por Email',
      'Email sent successfully': 'Email enviado exitosamente',
      'Failed to send email': 'Error al enviar email',
      'Please enter an email address': 'Por favor ingrese una dirección de email',
      'Please enter a valid email address': 'Por favor ingrese una dirección de email válida',
      'Receipt': 'Recibo',
      'Email Testing': 'Prueba de Email',
      'Send Test Receipt': 'Enviar Recibo de Prueba',
      'Send Test Email': 'Enviar Email de Prueba',
      'Test Data Preview': 'Vista Previa de Datos de Prueba',
      'Test email sent successfully': 'Email de prueba enviado exitosamente',
      'Failed to send test email': 'Error al enviar email de prueba',
      'Check Details': 'Detalles de la Cuenta',
      'Check Info': 'Info de la Cuenta',
      'Inventory Movements': 'Movimientos de Inventario',
      'Download Image': 'Descargar Imagen',
      'Share': 'Compartir',
      'Failed to share receipt': 'Error al compartir el recibo',
      'Failed to generate image': 'Error al generar la imagen',
      'Transfer Table': 'Transferir Mesa',
      'Transfer': 'Transferir',
      'Save Notes': 'Guardar Notas',
      'Add notes': 'Agregar notas',
      'Add notes about this check': 'Agregar notas sobre esta cuenta',
      'Void Check': 'Anular Cuenta',
      'Receipt Preview': 'Vista Previa del Recibo',
      'Table transferred successfully': 'Mesa transferida exitosamente',
      'Notes saved successfully': 'Notas guardadas exitosamente',
      'Check voided successfully': 'Cuenta anulada exitosamente',
      'Failed to load check details': 'Error al cargar detalles de la cuenta',
      'Please enter customer email': 'Por favor ingrese el email del cliente',
      'Items': 'Artículos',
      'Danger Zone': 'Zona de Peligro',
      'Receipt Actions': 'Acciones de Recibo',
      'No items in this check': 'No hay artículos en esta cuenta',
      'Total Checks': 'Total de Cuentas',
      'First Check': 'Primera Cuenta',
      'Last Check': 'Última Cuenta',
      'Orders Income': 'Ingresos por Órdenes',
      'Checks Income': 'Ingresos por Cuentas',
      'Last Activity': 'Última Actividad',
      'Total Tax': 'Total de Impuestos',
      'Total Tips': 'Total de Propinas',
      'Cuenta guardada exitosamente': 'Cuenta guardada exitosamente',
      'Order enviada a cocina': 'Orden enviada a cocina',

      // Financial Overview Translations
      'Financial Overview': 'Resumen Financiero',
      'View daily financial performance with sales and expense analytics': 'Ver el rendimiento financiero diario con análisis de ventas y gastos',
      'Today': 'Hoy',
      'Yesterday': 'Ayer',
      'This Week': 'Esta Semana',
      'This Month': 'Este Mes',
      'Date Range': 'Rango de Fechas',
      'Net Profit': 'Ganancia Neta',
      'Net Loss': 'Pérdida Neta',
      'Expenses by Category': 'Gastos por Categoría',
      'Expenses by Fund Source': 'Gastos por Fuente de Fondos',
      'General': 'General',
      'No category': 'Sin categoría',
      'Category Detail': 'Detalle de categoría',
      'Sales Details': 'Detalles de Ventas',
      'Expense Details': 'Detalles de Gastos',
      'No sales data available': 'No hay datos de ventas disponibles',
      'No expense data available': 'No hay datos de gastos disponibles',
      'No sales data found': 'No se encontraron datos de ventas',
      'No expense data found': 'No se encontraron datos de gastos',
      'Failed to load financial data': 'Error al cargar datos financieros',
      'Select date range': 'Seleccionar rango de fechas',

      // Print Translations
      'print': {
        receipt: {
          order: 'Orden',
          date: 'Fecha',
          clientInfo: 'INFO CLIENTE',
          name: 'Nombre',
          email: 'Email',
          phone: 'Teléfono',
          address: 'Dirección',
          city: 'Ciudad',
          state: 'Estado',
          postal: 'Código Postal',
          notes: 'Notas',
          item: 'Artículo',
          qty: 'Cant',
          price: 'Precio',
          subtotal: 'Subtotal',
          discount: 'Descuento',
          total: 'TOTAL',
          payment: 'Pago',
          thankYou: '¡Gracias!',
          visitAgain: '¡Vuelve pronto!',
        },
      },
      'kds': {
        send: 'Enviar comanda',
      },
      // ===== CHECKS MODULE TRANSLATIONS (for Nuxt Layer) =====
      // These translations are used by the layers/checks module
      // Copy this section when porting to Tauri app
      'Check Cart': 'Carrito de Cuenta',
      '{count} items': '{count} artículos',
      'item': 'artículo',
      'items': 'artículos',
      'Save Check': 'Guardar Cuenta',
      'Send to Kitchen': 'Enviar a Cocina',
      'Kitchen Display': 'Pantalla de Cocina',
      'KDS not enabled': 'KDS no habilitado',
      'Kitchen Display System is not enabled for this business': 'El sistema de pantalla de cocina no está habilitado para este negocio',
      'Enable KDS (Kitchen Display System)': 'Habilitar KDS (Sistema de Pantalla de Cocina)',
      'Show KDS screen and enable realtime kitchen sync': 'Mostrar pantalla KDS y habilitar sincronización en tiempo real',
      'Only available in Restaurant mode': 'Solo disponible en modo Restaurante',
      'Check': 'Cuenta',
      'No Active Check': 'Sin Cuenta Activa',
      'Select a table to start a new check': 'Selecciona una mesa para iniciar una nueva cuenta',
      'Park Check': 'Aparcar Cuenta',
      'Check saved successfully': 'Cuenta guardada exitosamente',
      'Unsent Items': 'Artículos no enviados',
      'Sent to Kitchen': 'Enviado a Cocina',
      'Modified': 'Modificado',
      'Item modified after being sent to kitchen': 'Artículo modificado después de enviarse a cocina',
      'Cannot remove items already sent to kitchen': 'No se pueden eliminar artículos ya enviados a cocina',
      'Cannot modify items already sent to kitchen': 'No se pueden modificar artículos ya enviados a cocina',
      'Cannot edit items already sent to kitchen': 'No se pueden editar artículos ya enviados a cocina',
      'Failed to save check': 'Error al guardar cuenta',
      'No active check': 'No hay cuenta activa',
      'Order sent to kitchen': 'Orden enviada a cocina',
      'Failed to send to kitchen': 'Error al enviar a cocina',
      'Mark as Ready': 'Marcar como Listo',
      'Preparing': 'Preparando',
      'Served': 'Servido',
      'Voided': 'Anulado',
      'Canceled': 'Cancelado',
      'Ready Items': 'Artículos Listos',
      'Served Items': 'Artículos Servidos',
      'Voided Items': 'Artículos Anulados',
      'Canceled Items': 'Artículos Cancelados',
      'Void': 'Anular',
      'Void Item': 'Anular Artículo',
      'Void Reason': 'Razón de Anulación',
      'customer_cancel': 'Cliente canceló',
      'kitchen_error': 'Error de cocina',
      'server_error': 'Error de mesero',
      'allergy': 'Alergia',
      'other': 'Otro',
      'customer_changed_mind': 'Cliente cambió de opinión',
      'wrong_item': 'Artículo incorrecto',
      'pricing_issue': 'Problema de precio',
      'Item already sent to kitchen. Use void instead.': 'Artículo ya enviado a cocina. Use anular en su lugar.',
      'Can only void items that have been sent to kitchen': 'Solo se pueden anular artículos que han sido enviados a cocina',
      'Optional': 'Opcional',
      'Add any additional notes...': 'Agregar notas adicionales...',
      'No open checks': 'No hay cuentas abiertas',
      'Check parked': 'Cuenta aparcada',
      'Check parked - Table {tableNumber} available to reselect': 'Cuenta aparcada - {tableNumber} disponible para reseleccionar',
      'Collapse tables': 'Colapsar mesas',
      'Expand tables': 'Expandir mesas',
      'Park': 'Aparcar',
      'Hide Tables': 'Ocultar Mesas',
      'Show Tables': 'Mostrar Mesas',
      'Close Check': 'Cerrar Cuenta',
      'Cancel Check': 'Cancelar Cuenta',
      'Cancel this empty check? It can be reopened later.': '¿Cancelar esta cuenta vacía? Puede reabrirse más tarde.',
      'Yes, Cancel': 'Sí, Cancelar',
      'Tax': 'Impuesto',
      'Tip': 'Propina',
      'Enter tax amount': 'Ingresar impuesto',
      'Enter discount amount': 'Ingresar descuento',
      'Enter tip amount': 'Ingresar propina',
      'Other': 'Otro',
      'Close & Pay': 'Cerrar y Pagar',
      'Subtotal': 'Subtotal',
      'Final Total': 'Total Final',
      'Cannot close an empty check': 'No se puede cerrar una cuenta vacía',
      'Surcharge': 'Recargo',
      'Select payment method': 'Seleccionar método de pago',
      'Select discount': 'Seleccionar descuento',
      'Check was closed from another device': 'La cuenta fue cerrada desde otro dispositivo',
      'Cash Received': 'Efectivo Recibido',
      'Amount Received': 'Monto Recibido',
      'Change': 'Cambio',
      'Calculate Change': 'Calcular Cambio',
      'Insufficient cash amount': 'Monto de efectivo insuficiente',
      'Split payment': 'Pago dividido',
      'Remaining': 'Restante',
      'Overpaid': 'Excedente',
      'Use single payment': 'Usar una sola forma de pago',
      'Tendered': 'Entregado',
      'Applied': 'Aplicado',

      // Custom Item Translations
      'Artículo Personalizado': 'Artículo Personalizado',
      'Enter item name': 'Ingrese nombre del artículo',
      'Enter price': 'Ingrese precio',
      'Agregar al Pedido': 'Agregar al Pedido',
      'Custom item added': 'Artículo personalizado agregado',
      'Price is required': 'El precio es requerido',
      'Price must be at least 0.01': 'El precio debe ser al menos 0.01',
      'Quantity is required': 'La cantidad es requerida',
      'Quantity must be at least 1': 'La cantidad debe ser al menos 1',
      'Color': 'Color',

      // Category Colors
      'Slate': 'Pizarra',
      'Blue': 'Azul',
      'Emerald': 'Esmeralda',
      'Amber': 'Ámbar',
      'Red': 'Rojo',
      'Orange': 'Naranja',
      'Purple': 'Púrpura',
      'Teal': 'Turquesa',
      'Rose': 'Rosa',
      'Lime': 'Lima',
      'Indigo': 'Índigo',
      'Cyan': 'Cian',
      'Yellow': 'Amarillo',
      'Black': 'Negro',

      // Order Email Translations
      'Send Order via Email': 'Enviar Pedido por Email',

      // KDS Station Translations
      'Station': 'Estación',
      'Select Station': 'Seleccionar Estación',
      'KDS Stations': 'Estaciones KDS',
      'Station Name': 'Nombre de Estación',
      'Station Type': 'Tipo de Estación',
      'Bar': 'Bar',
      'Expo': 'Expo',
      'No station selected': 'No hay estación seleccionada',
      'Please select a KDS station to view orders': 'Por favor seleccione una estación KDS para ver órdenes',
      'Assign product categories to KDS stations for item routing': 'Asignar categorías de productos a estaciones KDS para enrutamiento de artículos',
      'Assign Categories': 'Asignar Categorías',
      'Available Categories': 'Categorías Disponibles',
      'Assigned Categories': 'Categorías Asignadas',
      'Save Assignments': 'Guardar Asignaciones',
      'No KDS stations found': 'No se encontraron estaciones KDS',
      'Create stations in the database first': 'Primero cree estaciones en la base de datos',
      'Category assignments saved successfully': 'Asignaciones de categorías guardadas exitosamente',
      'Failed to load KDS stations': 'Error al cargar estaciones KDS',
      'Failed to load station categories': 'Error al cargar categorías de estación',
      'Failed to save category assignments': 'Error al guardar asignaciones de categorías',
      'Add new KDS station': 'Agregar nueva estación KDS',
      'Edit KDS station': 'Editar estación KDS',
      'Add KDS station': 'Agregar estación KDS',
      'Update KDS station': 'Actualizar estación KDS',
      'Manage kitchen display system stations': 'Administrar estaciones del sistema de visualización de cocina',
      'Do you want to deactivate this KDS station?': '¿Desea desactivar esta estación KDS?',
      'Do you want to permanently delete this KDS station?': '¿Desea eliminar permanentemente esta estación KDS?',
      'KDS station created successfully': 'Estación KDS creada exitosamente',
      'KDS station updated successfully': 'Estación KDS actualizada exitosamente',
      'KDS station activated successfully': 'Estación KDS activada exitosamente',
      'KDS station deactivated successfully': 'Estación KDS desactivada exitosamente',
      'KDS station deleted successfully': 'Estación KDS eliminada exitosamente',
      'Kitchen Main': 'Cocina Principal',

      // Super Admin Translations
      'Super Admin': 'Super Administrador',
      'Super Admin Dashboard': 'Panel de Super Administrador',
      'All Businesses': 'Todos los Negocios',
      'All Users': 'Todos los Usuarios',
      'Change Password': 'Cambiar Contraseña',
      'Change password for': 'Cambiar contraseña para',
      'New Password': 'Nueva Contraseña',
      'Enter new password': 'Ingrese nueva contraseña',
      'Minimum 6 characters': 'Mínimo 6 caracteres',
      'Update Password': 'Actualizar Contraseña',
      'Password updated successfully': 'Contraseña actualizada exitosamente',
      'Password must be at least 6 characters': 'La contraseña debe tener al menos 6 caracteres',
      'Failed to update password': 'Error al actualizar la contraseña',
      'Set Your Password': 'Establece tu Contraseña',
      'Create a secure password for your account': 'Crea una contraseña segura para tu cuenta',
      'Confirm Password': 'Confirmar Contraseña',
      'Passwords do not match': 'Las contraseñas no coinciden',
      'Password set successfully': 'Contraseña establecida exitosamente',
      'No active session': 'No hay sesión activa',
      'Your session has expired': 'Tu sesión ha expirado',
      'Please sign in again to continue': 'Inicia sesión nuevamente para continuar',
      'Session restored': 'Sesión restaurada',
      'Sign in to continue': 'Inicia sesión para continuar',
      'No business assigned to this account': 'No hay negocio asignado a esta cuenta',
      'Failed to restore session. Please try again.': 'Error al restaurar la sesión. Intenta nuevamente.',
      'Please enter a valid email': 'Por favor ingresa un email válido',
      'Enter your password': 'Ingresa tu contraseña',
      'Repeat your password': 'Repite tu contraseña',
      'Set Password': 'Establecer Contraseña',
      'Forgot your password?': '¿Olvidaste tu contraseña?',
      'Reset Password': 'Restablecer Contraseña',
      'Enter your email to receive a reset link': 'Ingresa tu email para recibir un enlace de restablecimiento',
      'Send Reset Link': 'Enviar Enlace',
      'Reset link sent': 'Enlace de restablecimiento enviado',
      'Check your email for the reset link': 'Revisa tu email para el enlace de restablecimiento',
      'Password reset successfully': 'Contraseña restablecida exitosamente',
      'Invalid reset link': 'Enlace de restablecimiento inválido',
      'The reset link is invalid or has expired': 'El enlace de restablecimiento es inválido o ha expirado',
      'Failed to verify reset link': 'Error al verificar el enlace de restablecimiento',
      'Verifying reset link': 'Verificando enlace de restablecimiento',
      'New password should be different from the old password': 'La nueva contraseña debe ser diferente a la contraseña anterior',
      'You do not have any business assigned yet': 'Aún no tienes ningún negocio asignado',
      'Select a Business': 'Selecciona un Negocio',
      'You have access to multiple businesses. Select one to continue.': 'Tienes acceso a múltiples negocios. Selecciona uno para continuar.',
      'Loading your businesses': 'Cargando tus negocios',
      'Failed to load businesses': 'Error al cargar negocios',
      'Failed to load business configuration': 'Error al cargar configuración del negocio',
      'Failed to initialize business data': 'Error al inicializar datos del negocio',
      'Failed to select business': 'Error al seleccionar negocio',
      'Business selected successfully': 'Negocio seleccionado exitosamente',
      'Processing magic link': 'Procesando enlace mágico',
      'Please wait while we verify your login': 'Por favor espera mientras verificamos tu inicio de sesión',
      'The magic link is invalid or has expired': 'El enlace mágico es inválido o ha expirado',
      'Failed to process magic link': 'Error al procesar el enlace mágico',
      'Invalid magic link': 'Enlace mágico inválido',
      'Login Successful': 'Inicio de sesión exitoso',
      'Authenticated successfully': 'Autenticado exitosamente',
      'Failed to load business data': 'Error al cargar datos del negocio',
      'No Business Assigned': 'Sin Negocio Asignado',
      'Please contact your administrator to get access to a business': 'Por favor contacta a tu administrador para obtener acceso a un negocio',
      'Add Business': 'Agregar Negocio',
      'Business Name': 'Nombre del Negocio',
      'Debug redirect URL': 'URL de redirección de debug',
      'When set, users are redirected here after login': 'Los usuarios serán redirigidos aquí después de iniciar sesión',
      'Owner User ID': 'ID del Propietario',
      'Optional - leave empty to create business without owner': 'Opcional - dejar vacío para crear negocio sin propietario',
      'Select unassigned user': 'Seleccionar usuario sin asignar',
      'Only users without business assignments shown': 'Solo se muestran usuarios sin negocios asignados',
      'Total Businesses': 'Total de Negocios',
      'Total Users': 'Total de Usuarios',
      'Business created successfully': 'Negocio creado exitosamente',
      'Business updated successfully': 'Negocio actualizado exitosamente',
      'Create User & Business': 'Crear Usuario y Negocio',
      'Owner Information': 'Información del Propietario',
      'Owner Name': 'Nombre del Propietario',
      'Owner Email': 'Email del Propietario',
      'Admin has full access, Employee has limited access': 'Admin tiene acceso completo, Empleado tiene acceso limitado',
      'Invitation will be sent to this email': 'Se enviará invitación a este email',
      'Business Description': 'Descripción del Negocio',
      'Service Type': 'Tipo de Servicio',
      'Counter for quick service, Restaurant for table service': 'Mostrador para servicio rápido, Restaurante para servicio de mesa',
      '(Optional)': '(Opcional)',
      'Business Email': 'Email del Negocio',
      'Creating...': 'Creando...',
      'Business created and linked to existing user': 'Negocio creado y vinculado a usuario existente',
      'User invited and business created successfully': 'Usuario invitado y negocio creado exitosamente',
      'Failed to create user and business': 'Error al crear usuario y negocio',
      'Confirm': 'Confirmar',
      'User removed from business': 'Usuario removido del negocio',
      'Remove from Business': 'Remover del Negocio',
      'Delete User': 'Eliminar Usuario',
      'User deleted successfully': 'Usuario eliminado exitosamente',
      'Failed to delete user': 'Error al eliminar usuario',
      'Add User': 'Agregar Usuario',
      'Add User to Business': 'Agregar Usuario al Negocio',
      'User must already exist in the system': 'El usuario debe existir en el sistema',
      'User added to business': 'Usuario agregado al negocio',
      'Failed to add user': 'Error al agregar usuario',
      'Filter by email': 'Filtrar por email',
      'Loading businesses...': 'Cargando negocios...',
      'Business Usage Metrics': 'Métricas de Uso de Negocios',
      'Usage Metrics': 'Métricas de Uso',
      'Avg Orders/Day': 'Promedio Órdenes/Día',
      'Avg Order Value': 'Valor Promedio de Orden',
      'Avg Daily Revenue': 'Ingreso Diario Promedio',
      'Total Orders': 'Órdenes Totales',
      'Active Days': 'Días Activos',
      'Total Revenue': 'Ingreso Total',
      'First Order': 'Primera Orden',
      'Last Order': 'Última Orden',
      'Failed to fetch business metrics': 'Error al cargar métricas de negocios',

      // Subscription & Billing Translations (Spanish)
      'Subscription Status': 'Estado de Suscripción',
      'Trial': 'Prueba',
      'Churn': 'Cancelado',
      'Owner': 'Propietario',
      'Payment Due': 'Pago Vencido',
      'Paused': 'Pausado',
      'Next Billing Date': 'Próxima Fecha de Facturación',
      'Days Overdue': 'Días Vencidos',
      'days': 'días',
      'businesses': 'negocios',
      'Mark as Paid': 'Marcar como Pagado',
      'Pause': 'Pausar',
      'Unpause': 'Reanudar',
      'Business paused successfully': 'Negocio pausado exitosamente',
      'Business unpaused successfully': 'Negocio reanudado exitosamente',
      'Edit Subscription': 'Editar Suscripción',
      'Due Date': 'Fecha de Vencimiento',
      'Exempt': 'Exento',
      'Exempt from automatic billing': 'Exento de facturación automática',
      'Subscription updated successfully': 'Suscripción actualizada exitosamente',
      'Failed to update subscription': 'Error al actualizar la suscripción',
      'Grace period expires 7 days after this date': 'El período de gracia vence 7 días después de esta fecha',
      'Business Service Paused': 'Servicio de Negocio Pausado',
      'This business has been paused due to unpaid subscription': 'Este negocio ha sido pausado por falta de pago de suscripción',
      'Your service has been temporarily suspended. To reactivate your account:': 'Su servicio ha sido suspendido temporalmente. Para reactivar su cuenta:',
      'Contact our support team to process your payment': 'Contacte a nuestro equipo de soporte para procesar su pago',
      'Once payment is received, your service will be reactivated immediately': 'Una vez recibido el pago, su servicio será reactivado inmediatamente',
      'All your data remains secure and will be available upon reactivation': 'Todos sus datos permanecen seguros y estarán disponibles al reactivar',
      'Business reactivated successfully': 'Negocio reactivado exitosamente',
      'Failed to mark payment as received': 'Error al marcar el pago como recibido',
      'Payment overdue - Service will be paused soon': 'Pago vencido - El servicio será pausado pronto',
      'Payment due - Service will be paused in 1 day': 'Pago vencido - El servicio será pausado en 1 día',
      'Payment due - Service will be paused in {days} days': 'Pago vencido - El servicio será pausado en {days} días',
      'Please contact support to process your payment': 'Por favor contacte a soporte para procesar su pago',
      'Subscription Settings': 'Configuración de Suscripción',
      'Initial Subscription Status': 'Estado Inicial de Suscripción',
      'Trial for new businesses, Active if payment already received': 'Prueba para negocios nuevos, Activo si ya se recibió el pago',
      'Subscription Start Date': 'Fecha de Inicio de Suscripción',
      'Date when billing cycle begins': 'Fecha cuando comienza el ciclo de facturación',
      'Billing Day of Month': 'Día de Facturación del Mes',
      'Day of each month when payment is due (default: 20)': 'Día de cada mes cuando vence el pago (predeterminado: 20)',
      // ===== END CHECKS MODULE TRANSLATIONS =====

      // Tienda (Public Store) Translations
      'Store not found': 'Tienda no encontrada',
      'The store you are looking for does not exist.': 'La tienda que buscas no existe.',
      'Loading store...': 'Cargando tienda...',
      'Search products...': 'Buscar productos...',
      'No products found': 'No se encontraron productos',
      'Your cart is empty': 'Tu carrito está vacío',
      'Your cart': 'Tu carrito',
      'Proceed to checkout': 'Proceder al pago',
      'Add to cart': 'Agregar al carrito',
      'Update': 'Actualizar',
      'Multiple': 'Múltiple',
      'Order summary': 'Resumen del pedido',
      'Your information': 'Tu información',
      'Your name': 'Tu nombre',
      'Your phone number': 'Tu número de teléfono',
      'Delivery address (optional)': 'Dirección de entrega (opcional)',
      'Special instructions (optional)': 'Instrucciones especiales (opcional)',
      'Place order': 'Realizar pedido',
      'Failed to place order. Please try again.': 'Error al realizar el pedido. Por favor intenta de nuevo.',
      'An error occurred. Please try again.': 'Ocurrió un error. Por favor intenta de nuevo.',
      'Order confirmed!': '¡Pedido confirmado!',
      'Thank you for your order. We will prepare it as soon as possible.': 'Gracias por tu pedido. Lo prepararemos lo antes posible.',
      'Order number': 'Número de pedido',
      'You will receive a notification when your order is ready.': 'Recibirás una notificación cuando tu pedido esté listo.',
      'Continue shopping': 'Seguir comprando',
    },
  },
}))
